(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.app = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"core-js/fn/regexp/escape":19,"core-js/shim":398,"regenerator-runtime/runtime":400}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":20}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":21}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":22}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":23}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };
},{"core-js/library/fn/object/entries":24}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-descriptor":25}],8:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":26}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":27}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":28}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":29}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],13:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":5}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _getPrototypeOf = require("../core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = require("../core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};
},{"../core-js/object/get-own-property-descriptor":7,"../core-js/object/get-prototype-of":8}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":4,"../core-js/object/set-prototype-of":9,"../helpers/typeof":18}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":18}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":2,"../core-js/is-iterable":3}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":10,"../core-js/symbol/iterator":11}],19:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;
},{"../../modules/_core":126,"../../modules/core.regexp.escape":222}],20:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');
},{"../modules/core.get-iterator":91,"../modules/es6.string.iterator":100,"../modules/web.dom.iterable":105}],21:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');
},{"../modules/core.is-iterable":92,"../modules/es6.string.iterator":100,"../modules/web.dom.iterable":105}],22:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
},{"../../modules/_core":36,"../../modules/es6.object.create":94}],23:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
},{"../../modules/_core":36,"../../modules/es6.object.define-property":95}],24:[function(require,module,exports){
require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;
},{"../../modules/_core":36,"../../modules/es7.object.entries":102}],25:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};
},{"../../modules/_core":36,"../../modules/es6.object.get-own-property-descriptor":96}],26:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;
},{"../../modules/_core":36,"../../modules/es6.object.get-prototype-of":97}],27:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;
},{"../../modules/_core":36,"../../modules/es6.object.set-prototype-of":98}],28:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;
},{"../../modules/_core":36,"../../modules/es6.object.to-string":99,"../../modules/es6.symbol":101,"../../modules/es7.symbol.async-iterator":103,"../../modules/es7.symbol.observable":104}],29:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');
},{"../../modules/_wks-ext":88,"../../modules/es6.string.iterator":100,"../../modules/web.dom.iterable":105}],30:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],31:[function(require,module,exports){
module.exports = function(){ /* empty */ };
},{}],32:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":52}],33:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":80,"./_to-iobject":82,"./_to-length":83}],34:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof')
  , TAG = require('./_wks')('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
},{"./_cof":35,"./_wks":89}],35:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],36:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],37:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":30}],38:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],39:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":44}],40:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":45,"./_is-object":52}],41:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],42:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys')
  , gOPS    = require('./_object-gops')
  , pIE     = require('./_object-pie');
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
},{"./_object-gops":66,"./_object-keys":69,"./_object-pie":70}],43:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , ctx       = require('./_ctx')
  , hide      = require('./_hide')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":36,"./_ctx":37,"./_global":45,"./_hide":47}],44:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],45:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],46:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],47:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":39,"./_object-dp":61,"./_property-desc":73}],48:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":45}],49:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":39,"./_dom-create":40,"./_fails":44}],50:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":35}],51:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":35}],52:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],53:[function(require,module,exports){
'use strict';
var create         = require('./_object-create')
  , descriptor     = require('./_property-desc')
  , setToStringTag = require('./_set-to-string-tag')
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
},{"./_hide":47,"./_object-create":60,"./_property-desc":73,"./_set-to-string-tag":76,"./_wks":89}],54:[function(require,module,exports){
'use strict';
var LIBRARY        = require('./_library')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , hide           = require('./_hide')
  , has            = require('./_has')
  , Iterators      = require('./_iterators')
  , $iterCreate    = require('./_iter-create')
  , setToStringTag = require('./_set-to-string-tag')
  , getPrototypeOf = require('./_object-gpo')
  , ITERATOR       = require('./_wks')('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
},{"./_export":43,"./_has":46,"./_hide":47,"./_iter-create":53,"./_iterators":56,"./_library":58,"./_object-gpo":67,"./_redefine":74,"./_set-to-string-tag":76,"./_wks":89}],55:[function(require,module,exports){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
},{}],56:[function(require,module,exports){
module.exports = {};
},{}],57:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject');
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
},{"./_object-keys":69,"./_to-iobject":82}],58:[function(require,module,exports){
module.exports = true;
},{}],59:[function(require,module,exports){
var META     = require('./_uid')('meta')
  , isObject = require('./_is-object')
  , has      = require('./_has')
  , setDesc  = require('./_object-dp').f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require('./_fails')(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
},{"./_fails":44,"./_has":46,"./_is-object":52,"./_object-dp":61,"./_uid":86}],60:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require('./_an-object')
  , dPs         = require('./_object-dps')
  , enumBugKeys = require('./_enum-bug-keys')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":32,"./_dom-create":40,"./_enum-bug-keys":41,"./_html":48,"./_object-dps":62,"./_shared-key":77}],61:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":32,"./_descriptors":39,"./_ie8-dom-define":49,"./_to-primitive":85}],62:[function(require,module,exports){
var dP       = require('./_object-dp')
  , anObject = require('./_an-object')
  , getKeys  = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
},{"./_an-object":32,"./_descriptors":39,"./_object-dp":61,"./_object-keys":69}],63:[function(require,module,exports){
var pIE            = require('./_object-pie')
  , createDesc     = require('./_property-desc')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , has            = require('./_has')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
},{"./_descriptors":39,"./_has":46,"./_ie8-dom-define":49,"./_object-pie":70,"./_property-desc":73,"./_to-iobject":82,"./_to-primitive":85}],64:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject')
  , gOPN      = require('./_object-gopn').f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":65,"./_to-iobject":82}],65:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require('./_object-keys-internal')
  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
},{"./_enum-bug-keys":41,"./_object-keys-internal":68}],66:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],67:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require('./_has')
  , toObject    = require('./_to-object')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
},{"./_has":46,"./_shared-key":77,"./_to-object":84}],68:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":33,"./_has":46,"./_shared-key":77,"./_to-iobject":82}],69:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":41,"./_object-keys-internal":68}],70:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],71:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export')
  , core    = require('./_core')
  , fails   = require('./_fails');
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
},{"./_core":36,"./_export":43,"./_fails":44}],72:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject')
  , isEnum    = require('./_object-pie').f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};
},{"./_object-keys":69,"./_object-pie":70,"./_to-iobject":82}],73:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],74:[function(require,module,exports){
module.exports = require('./_hide');
},{"./_hide":47}],75:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object')
  , anObject = require('./_an-object');
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
},{"./_an-object":32,"./_ctx":37,"./_is-object":52,"./_object-gopd":63}],76:[function(require,module,exports){
var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
},{"./_has":46,"./_object-dp":61,"./_wks":89}],77:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":78,"./_uid":86}],78:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":45}],79:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
},{"./_defined":38,"./_to-integer":81}],80:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":81}],81:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],82:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":38,"./_iobject":50}],83:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":81}],84:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":38}],85:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":52}],86:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],87:[function(require,module,exports){
var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
},{"./_core":36,"./_global":45,"./_library":58,"./_object-dp":61,"./_wks-ext":88}],88:[function(require,module,exports){
exports.f = require('./_wks');
},{"./_wks":89}],89:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":45,"./_shared":78,"./_uid":86}],90:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
},{"./_classof":34,"./_core":36,"./_iterators":56,"./_wks":89}],91:[function(require,module,exports){
var anObject = require('./_an-object')
  , get      = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
},{"./_an-object":32,"./_core":36,"./core.get-iterator-method":90}],92:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
},{"./_classof":34,"./_core":36,"./_iterators":56,"./_wks":89}],93:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables')
  , step             = require('./_iter-step')
  , Iterators        = require('./_iterators')
  , toIObject        = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
},{"./_add-to-unscopables":31,"./_iter-define":54,"./_iter-step":55,"./_iterators":56,"./_to-iobject":82}],94:[function(require,module,exports){
var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});
},{"./_export":43,"./_object-create":60}],95:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperty: require('./_object-dp').f});
},{"./_descriptors":39,"./_export":43,"./_object-dp":61}],96:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = require('./_to-iobject')
  , $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});
},{"./_object-gopd":63,"./_object-sap":71,"./_to-iobject":82}],97:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require('./_to-object')
  , $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
},{"./_object-gpo":67,"./_object-sap":71,"./_to-object":84}],98:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});
},{"./_export":43,"./_set-proto":75}],99:[function(require,module,exports){

},{}],100:[function(require,module,exports){
'use strict';
var $at  = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
},{"./_iter-define":54,"./_string-at":79}],101:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global         = require('./_global')
  , has            = require('./_has')
  , DESCRIPTORS    = require('./_descriptors')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , META           = require('./_meta').KEY
  , $fails         = require('./_fails')
  , shared         = require('./_shared')
  , setToStringTag = require('./_set-to-string-tag')
  , uid            = require('./_uid')
  , wks            = require('./_wks')
  , wksExt         = require('./_wks-ext')
  , wksDefine      = require('./_wks-define')
  , keyOf          = require('./_keyof')
  , enumKeys       = require('./_enum-keys')
  , isArray        = require('./_is-array')
  , anObject       = require('./_an-object')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , createDesc     = require('./_property-desc')
  , _create        = require('./_object-create')
  , gOPNExt        = require('./_object-gopn-ext')
  , $GOPD          = require('./_object-gopd')
  , $DP            = require('./_object-dp')
  , $keys          = require('./_object-keys')
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f  = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require('./_library')){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
},{"./_an-object":32,"./_descriptors":39,"./_enum-keys":42,"./_export":43,"./_fails":44,"./_global":45,"./_has":46,"./_hide":47,"./_is-array":51,"./_keyof":57,"./_library":58,"./_meta":59,"./_object-create":60,"./_object-dp":61,"./_object-gopd":63,"./_object-gopn":65,"./_object-gopn-ext":64,"./_object-gops":66,"./_object-keys":69,"./_object-pie":70,"./_property-desc":73,"./_redefine":74,"./_set-to-string-tag":76,"./_shared":78,"./_to-iobject":82,"./_to-primitive":85,"./_uid":86,"./_wks":89,"./_wks-define":87,"./_wks-ext":88}],102:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export  = require('./_export')
  , $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});
},{"./_export":43,"./_object-to-array":72}],103:[function(require,module,exports){
require('./_wks-define')('asyncIterator');
},{"./_wks-define":87}],104:[function(require,module,exports){
require('./_wks-define')('observable');
},{"./_wks-define":87}],105:[function(require,module,exports){
require('./es6.array.iterator');
var global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , TO_STRING_TAG = require('./_wks')('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
},{"./_global":45,"./_hide":47,"./_iterators":56,"./_wks":89,"./es6.array.iterator":93}],106:[function(require,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"dup":30}],107:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};
},{"./_cof":121}],108:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};
},{"./_hide":143,"./_wks":220}],109:[function(require,module,exports){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
},{}],110:[function(require,module,exports){
arguments[4][32][0].apply(exports,arguments)
},{"./_is-object":152,"dup":32}],111:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object')
  , toIndex  = require('./_to-index')
  , toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};
},{"./_to-index":208,"./_to-length":211,"./_to-object":212}],112:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object')
  , toIndex  = require('./_to-index')
  , toLength = require('./_to-length');
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};
},{"./_to-index":208,"./_to-length":211,"./_to-object":212}],113:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":140}],114:[function(require,module,exports){
arguments[4][33][0].apply(exports,arguments)
},{"./_to-index":208,"./_to-iobject":210,"./_to-length":211,"dup":33}],115:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = require('./_ctx')
  , IObject  = require('./_iobject')
  , toObject = require('./_to-object')
  , toLength = require('./_to-length')
  , asc      = require('./_array-species-create');
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};
},{"./_array-species-create":118,"./_ctx":128,"./_iobject":148,"./_to-length":211,"./_to-object":212}],116:[function(require,module,exports){
var aFunction = require('./_a-function')
  , toObject  = require('./_to-object')
  , IObject   = require('./_iobject')
  , toLength  = require('./_to-length');

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};
},{"./_a-function":106,"./_iobject":148,"./_to-length":211,"./_to-object":212}],117:[function(require,module,exports){
var isObject = require('./_is-object')
  , isArray  = require('./_is-array')
  , SPECIES  = require('./_wks')('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};
},{"./_is-array":150,"./_is-object":152,"./_wks":220}],118:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};
},{"./_array-species-constructor":117}],119:[function(require,module,exports){
'use strict';
var aFunction  = require('./_a-function')
  , isObject   = require('./_is-object')
  , invoke     = require('./_invoke')
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};
},{"./_a-function":106,"./_invoke":147,"./_is-object":152}],120:[function(require,module,exports){
arguments[4][34][0].apply(exports,arguments)
},{"./_cof":121,"./_wks":220,"dup":34}],121:[function(require,module,exports){
arguments[4][35][0].apply(exports,arguments)
},{"dup":35}],122:[function(require,module,exports){
'use strict';
var dP          = require('./_object-dp').f
  , create      = require('./_object-create')
  , redefineAll = require('./_redefine-all')
  , ctx         = require('./_ctx')
  , anInstance  = require('./_an-instance')
  , defined     = require('./_defined')
  , forOf       = require('./_for-of')
  , $iterDefine = require('./_iter-define')
  , step        = require('./_iter-step')
  , setSpecies  = require('./_set-species')
  , DESCRIPTORS = require('./_descriptors')
  , fastKey     = require('./_meta').fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};
},{"./_an-instance":109,"./_ctx":128,"./_defined":130,"./_descriptors":131,"./_for-of":140,"./_iter-define":156,"./_iter-step":158,"./_meta":165,"./_object-create":169,"./_object-dp":170,"./_redefine-all":189,"./_set-species":194}],123:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof')
  , from    = require('./_array-from-iterable');
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};
},{"./_array-from-iterable":113,"./_classof":120}],124:[function(require,module,exports){
'use strict';
var redefineAll       = require('./_redefine-all')
  , getWeak           = require('./_meta').getWeak
  , anObject          = require('./_an-object')
  , isObject          = require('./_is-object')
  , anInstance        = require('./_an-instance')
  , forOf             = require('./_for-of')
  , createArrayMethod = require('./_array-methods')
  , $has              = require('./_has')
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};
},{"./_an-instance":109,"./_an-object":110,"./_array-methods":115,"./_for-of":140,"./_has":142,"./_is-object":152,"./_meta":165,"./_redefine-all":189}],125:[function(require,module,exports){
'use strict';
var global            = require('./_global')
  , $export           = require('./_export')
  , redefine          = require('./_redefine')
  , redefineAll       = require('./_redefine-all')
  , meta              = require('./_meta')
  , forOf             = require('./_for-of')
  , anInstance        = require('./_an-instance')
  , isObject          = require('./_is-object')
  , fails             = require('./_fails')
  , $iterDetect       = require('./_iter-detect')
  , setToStringTag    = require('./_set-to-string-tag')
  , inheritIfRequired = require('./_inherit-if-required');

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};
},{"./_an-instance":109,"./_export":135,"./_fails":137,"./_for-of":140,"./_global":141,"./_inherit-if-required":146,"./_is-object":152,"./_iter-detect":157,"./_meta":165,"./_redefine":190,"./_redefine-all":189,"./_set-to-string-tag":195}],126:[function(require,module,exports){
arguments[4][36][0].apply(exports,arguments)
},{"dup":36}],127:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp')
  , createDesc      = require('./_property-desc');

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};
},{"./_object-dp":170,"./_property-desc":188}],128:[function(require,module,exports){
arguments[4][37][0].apply(exports,arguments)
},{"./_a-function":106,"dup":37}],129:[function(require,module,exports){
'use strict';
var anObject    = require('./_an-object')
  , toPrimitive = require('./_to-primitive')
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};
},{"./_an-object":110,"./_to-primitive":213}],130:[function(require,module,exports){
arguments[4][38][0].apply(exports,arguments)
},{"dup":38}],131:[function(require,module,exports){
arguments[4][39][0].apply(exports,arguments)
},{"./_fails":137,"dup":39}],132:[function(require,module,exports){
arguments[4][40][0].apply(exports,arguments)
},{"./_global":141,"./_is-object":152,"dup":40}],133:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"dup":41}],134:[function(require,module,exports){
arguments[4][42][0].apply(exports,arguments)
},{"./_object-gops":176,"./_object-keys":179,"./_object-pie":180,"dup":42}],135:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , hide      = require('./_hide')
  , redefine  = require('./_redefine')
  , ctx       = require('./_ctx')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":126,"./_ctx":128,"./_global":141,"./_hide":143,"./_redefine":190}],136:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};
},{"./_wks":220}],137:[function(require,module,exports){
arguments[4][44][0].apply(exports,arguments)
},{"dup":44}],138:[function(require,module,exports){
'use strict';
var hide     = require('./_hide')
  , redefine = require('./_redefine')
  , fails    = require('./_fails')
  , defined  = require('./_defined')
  , wks      = require('./_wks');

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};
},{"./_defined":130,"./_fails":137,"./_hide":143,"./_redefine":190,"./_wks":220}],139:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};
},{"./_an-object":110}],140:[function(require,module,exports){
var ctx         = require('./_ctx')
  , call        = require('./_iter-call')
  , isArrayIter = require('./_is-array-iter')
  , anObject    = require('./_an-object')
  , toLength    = require('./_to-length')
  , getIterFn   = require('./core.get-iterator-method')
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
},{"./_an-object":110,"./_ctx":128,"./_is-array-iter":149,"./_iter-call":154,"./_to-length":211,"./core.get-iterator-method":221}],141:[function(require,module,exports){
arguments[4][45][0].apply(exports,arguments)
},{"dup":45}],142:[function(require,module,exports){
arguments[4][46][0].apply(exports,arguments)
},{"dup":46}],143:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"./_descriptors":131,"./_object-dp":170,"./_property-desc":188,"dup":47}],144:[function(require,module,exports){
arguments[4][48][0].apply(exports,arguments)
},{"./_global":141,"dup":48}],145:[function(require,module,exports){
arguments[4][49][0].apply(exports,arguments)
},{"./_descriptors":131,"./_dom-create":132,"./_fails":137,"dup":49}],146:[function(require,module,exports){
var isObject       = require('./_is-object')
  , setPrototypeOf = require('./_set-proto').set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};
},{"./_is-object":152,"./_set-proto":193}],147:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],148:[function(require,module,exports){
arguments[4][50][0].apply(exports,arguments)
},{"./_cof":121,"dup":50}],149:[function(require,module,exports){
// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
},{"./_iterators":159,"./_wks":220}],150:[function(require,module,exports){
arguments[4][51][0].apply(exports,arguments)
},{"./_cof":121,"dup":51}],151:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object')
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};
},{"./_is-object":152}],152:[function(require,module,exports){
arguments[4][52][0].apply(exports,arguments)
},{"dup":52}],153:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object')
  , cof      = require('./_cof')
  , MATCH    = require('./_wks')('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};
},{"./_cof":121,"./_is-object":152,"./_wks":220}],154:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
},{"./_an-object":110}],155:[function(require,module,exports){
arguments[4][53][0].apply(exports,arguments)
},{"./_hide":143,"./_object-create":169,"./_property-desc":188,"./_set-to-string-tag":195,"./_wks":220,"dup":53}],156:[function(require,module,exports){
arguments[4][54][0].apply(exports,arguments)
},{"./_export":135,"./_has":142,"./_hide":143,"./_iter-create":155,"./_iterators":159,"./_library":161,"./_object-gpo":177,"./_redefine":190,"./_set-to-string-tag":195,"./_wks":220,"dup":54}],157:[function(require,module,exports){
var ITERATOR     = require('./_wks')('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
},{"./_wks":220}],158:[function(require,module,exports){
arguments[4][55][0].apply(exports,arguments)
},{"dup":55}],159:[function(require,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"dup":56}],160:[function(require,module,exports){
arguments[4][57][0].apply(exports,arguments)
},{"./_object-keys":179,"./_to-iobject":210,"dup":57}],161:[function(require,module,exports){
module.exports = false;
},{}],162:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;
},{}],163:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};
},{}],164:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};
},{}],165:[function(require,module,exports){
arguments[4][59][0].apply(exports,arguments)
},{"./_fails":137,"./_has":142,"./_is-object":152,"./_object-dp":170,"./_uid":217,"dup":59}],166:[function(require,module,exports){
var Map     = require('./es6.map')
  , $export = require('./_export')
  , shared  = require('./_shared')('metadata')
  , store   = shared.store || (shared.store = new (require('./es6.weak-map')));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};
},{"./_export":135,"./_shared":197,"./es6.map":252,"./es6.weak-map":358}],167:[function(require,module,exports){
var global    = require('./_global')
  , macrotask = require('./_task').set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require('./_cof')(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
},{"./_cof":121,"./_global":141,"./_task":207}],168:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":137,"./_iobject":148,"./_object-gops":176,"./_object-keys":179,"./_object-pie":180,"./_to-object":212}],169:[function(require,module,exports){
arguments[4][60][0].apply(exports,arguments)
},{"./_an-object":110,"./_dom-create":132,"./_enum-bug-keys":133,"./_html":144,"./_object-dps":171,"./_shared-key":196,"dup":60}],170:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"./_an-object":110,"./_descriptors":131,"./_ie8-dom-define":145,"./_to-primitive":213,"dup":61}],171:[function(require,module,exports){
arguments[4][62][0].apply(exports,arguments)
},{"./_an-object":110,"./_descriptors":131,"./_object-dp":170,"./_object-keys":179,"dup":62}],172:[function(require,module,exports){
// Forced replacement prototype accessors methods
module.exports = require('./_library')|| !require('./_fails')(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete require('./_global')[K];
});
},{"./_fails":137,"./_global":141,"./_library":161}],173:[function(require,module,exports){
arguments[4][63][0].apply(exports,arguments)
},{"./_descriptors":131,"./_has":142,"./_ie8-dom-define":145,"./_object-pie":180,"./_property-desc":188,"./_to-iobject":210,"./_to-primitive":213,"dup":63}],174:[function(require,module,exports){
arguments[4][64][0].apply(exports,arguments)
},{"./_object-gopn":175,"./_to-iobject":210,"dup":64}],175:[function(require,module,exports){
arguments[4][65][0].apply(exports,arguments)
},{"./_enum-bug-keys":133,"./_object-keys-internal":178,"dup":65}],176:[function(require,module,exports){
arguments[4][66][0].apply(exports,arguments)
},{"dup":66}],177:[function(require,module,exports){
arguments[4][67][0].apply(exports,arguments)
},{"./_has":142,"./_shared-key":196,"./_to-object":212,"dup":67}],178:[function(require,module,exports){
arguments[4][68][0].apply(exports,arguments)
},{"./_array-includes":114,"./_has":142,"./_shared-key":196,"./_to-iobject":210,"dup":68}],179:[function(require,module,exports){
arguments[4][69][0].apply(exports,arguments)
},{"./_enum-bug-keys":133,"./_object-keys-internal":178,"dup":69}],180:[function(require,module,exports){
arguments[4][70][0].apply(exports,arguments)
},{"dup":70}],181:[function(require,module,exports){
arguments[4][71][0].apply(exports,arguments)
},{"./_core":126,"./_export":135,"./_fails":137,"dup":71}],182:[function(require,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"./_object-keys":179,"./_object-pie":180,"./_to-iobject":210,"dup":72}],183:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN     = require('./_object-gopn')
  , gOPS     = require('./_object-gops')
  , anObject = require('./_an-object')
  , Reflect  = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};
},{"./_an-object":110,"./_global":141,"./_object-gopn":175,"./_object-gops":176}],184:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat
  , $trim       = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;
},{"./_global":141,"./_string-trim":205,"./_string-ws":206}],185:[function(require,module,exports){
var $parseInt = require('./_global').parseInt
  , $trim     = require('./_string-trim').trim
  , ws        = require('./_string-ws')
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;
},{"./_global":141,"./_string-trim":205,"./_string-ws":206}],186:[function(require,module,exports){
'use strict';
var path      = require('./_path')
  , invoke    = require('./_invoke')
  , aFunction = require('./_a-function');
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};
},{"./_a-function":106,"./_invoke":147,"./_path":187}],187:[function(require,module,exports){
module.exports = require('./_global');
},{"./_global":141}],188:[function(require,module,exports){
arguments[4][73][0].apply(exports,arguments)
},{"dup":73}],189:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};
},{"./_redefine":190}],190:[function(require,module,exports){
var global    = require('./_global')
  , hide      = require('./_hide')
  , has       = require('./_has')
  , SRC       = require('./_uid')('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
},{"./_core":126,"./_global":141,"./_has":142,"./_hide":143,"./_uid":217}],191:[function(require,module,exports){
module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};
},{}],192:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};
},{}],193:[function(require,module,exports){
arguments[4][75][0].apply(exports,arguments)
},{"./_an-object":110,"./_ctx":128,"./_is-object":152,"./_object-gopd":173,"dup":75}],194:[function(require,module,exports){
'use strict';
var global      = require('./_global')
  , dP          = require('./_object-dp')
  , DESCRIPTORS = require('./_descriptors')
  , SPECIES     = require('./_wks')('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
},{"./_descriptors":131,"./_global":141,"./_object-dp":170,"./_wks":220}],195:[function(require,module,exports){
arguments[4][76][0].apply(exports,arguments)
},{"./_has":142,"./_object-dp":170,"./_wks":220,"dup":76}],196:[function(require,module,exports){
arguments[4][77][0].apply(exports,arguments)
},{"./_shared":197,"./_uid":217,"dup":77}],197:[function(require,module,exports){
arguments[4][78][0].apply(exports,arguments)
},{"./_global":141,"dup":78}],198:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
},{"./_a-function":106,"./_an-object":110,"./_wks":220}],199:[function(require,module,exports){
var fails = require('./_fails');

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};
},{"./_fails":137}],200:[function(require,module,exports){
arguments[4][79][0].apply(exports,arguments)
},{"./_defined":130,"./_to-integer":209,"dup":79}],201:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp')
  , defined  = require('./_defined');

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};
},{"./_defined":130,"./_is-regexp":153}],202:[function(require,module,exports){
var $export = require('./_export')
  , fails   = require('./_fails')
  , defined = require('./_defined')
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};
},{"./_defined":130,"./_export":135,"./_fails":137}],203:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length')
  , repeat   = require('./_string-repeat')
  , defined  = require('./_defined');

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":130,"./_string-repeat":204,"./_to-length":211}],204:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};
},{"./_defined":130,"./_to-integer":209}],205:[function(require,module,exports){
var $export = require('./_export')
  , defined = require('./_defined')
  , fails   = require('./_fails')
  , spaces  = require('./_string-ws')
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;
},{"./_defined":130,"./_export":135,"./_fails":137,"./_string-ws":206}],206:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
},{}],207:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":121,"./_ctx":128,"./_dom-create":132,"./_global":141,"./_html":144,"./_invoke":147}],208:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"./_to-integer":209,"dup":80}],209:[function(require,module,exports){
arguments[4][81][0].apply(exports,arguments)
},{"dup":81}],210:[function(require,module,exports){
arguments[4][82][0].apply(exports,arguments)
},{"./_defined":130,"./_iobject":148,"dup":82}],211:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"./_to-integer":209,"dup":83}],212:[function(require,module,exports){
arguments[4][84][0].apply(exports,arguments)
},{"./_defined":130,"dup":84}],213:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"./_is-object":152,"dup":85}],214:[function(require,module,exports){
'use strict';
if(require('./_descriptors')){
  var LIBRARY             = require('./_library')
    , global              = require('./_global')
    , fails               = require('./_fails')
    , $export             = require('./_export')
    , $typed              = require('./_typed')
    , $buffer             = require('./_typed-buffer')
    , ctx                 = require('./_ctx')
    , anInstance          = require('./_an-instance')
    , propertyDesc        = require('./_property-desc')
    , hide                = require('./_hide')
    , redefineAll         = require('./_redefine-all')
    , toInteger           = require('./_to-integer')
    , toLength            = require('./_to-length')
    , toIndex             = require('./_to-index')
    , toPrimitive         = require('./_to-primitive')
    , has                 = require('./_has')
    , same                = require('./_same-value')
    , classof             = require('./_classof')
    , isObject            = require('./_is-object')
    , toObject            = require('./_to-object')
    , isArrayIter         = require('./_is-array-iter')
    , create              = require('./_object-create')
    , getPrototypeOf      = require('./_object-gpo')
    , gOPN                = require('./_object-gopn').f
    , getIterFn           = require('./core.get-iterator-method')
    , uid                 = require('./_uid')
    , wks                 = require('./_wks')
    , createArrayMethod   = require('./_array-methods')
    , createArrayIncludes = require('./_array-includes')
    , speciesConstructor  = require('./_species-constructor')
    , ArrayIterators      = require('./es6.array.iterator')
    , Iterators           = require('./_iterators')
    , $iterDetect         = require('./_iter-detect')
    , setSpecies          = require('./_set-species')
    , arrayFill           = require('./_array-fill')
    , arrayCopyWithin     = require('./_array-copy-within')
    , $DP                 = require('./_object-dp')
    , $GOPD               = require('./_object-gopd')
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };
},{"./_an-instance":109,"./_array-copy-within":111,"./_array-fill":112,"./_array-includes":114,"./_array-methods":115,"./_classof":120,"./_ctx":128,"./_descriptors":131,"./_export":135,"./_fails":137,"./_global":141,"./_has":142,"./_hide":143,"./_is-array-iter":149,"./_is-object":152,"./_iter-detect":157,"./_iterators":159,"./_library":161,"./_object-create":169,"./_object-dp":170,"./_object-gopd":173,"./_object-gopn":175,"./_object-gpo":177,"./_property-desc":188,"./_redefine-all":189,"./_same-value":192,"./_set-species":194,"./_species-constructor":198,"./_to-index":208,"./_to-integer":209,"./_to-length":211,"./_to-object":212,"./_to-primitive":213,"./_typed":216,"./_typed-buffer":215,"./_uid":217,"./_wks":220,"./core.get-iterator-method":221,"./es6.array.iterator":233}],215:[function(require,module,exports){
'use strict';
var global         = require('./_global')
  , DESCRIPTORS    = require('./_descriptors')
  , LIBRARY        = require('./_library')
  , $typed         = require('./_typed')
  , hide           = require('./_hide')
  , redefineAll    = require('./_redefine-all')
  , fails          = require('./_fails')
  , anInstance     = require('./_an-instance')
  , toInteger      = require('./_to-integer')
  , toLength       = require('./_to-length')
  , gOPN           = require('./_object-gopn').f
  , dP             = require('./_object-dp').f
  , arrayFill      = require('./_array-fill')
  , setToStringTag = require('./_set-to-string-tag')
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;
},{"./_an-instance":109,"./_array-fill":112,"./_descriptors":131,"./_fails":137,"./_global":141,"./_hide":143,"./_library":161,"./_object-dp":170,"./_object-gopn":175,"./_redefine-all":189,"./_set-to-string-tag":195,"./_to-integer":209,"./_to-length":211,"./_typed":216}],216:[function(require,module,exports){
var global = require('./_global')
  , hide   = require('./_hide')
  , uid    = require('./_uid')
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};
},{"./_global":141,"./_hide":143,"./_uid":217}],217:[function(require,module,exports){
arguments[4][86][0].apply(exports,arguments)
},{"dup":86}],218:[function(require,module,exports){
arguments[4][87][0].apply(exports,arguments)
},{"./_core":126,"./_global":141,"./_library":161,"./_object-dp":170,"./_wks-ext":219,"dup":87}],219:[function(require,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"./_wks":220,"dup":88}],220:[function(require,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"./_global":141,"./_shared":197,"./_uid":217,"dup":89}],221:[function(require,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"./_classof":120,"./_core":126,"./_iterators":159,"./_wks":220,"dup":90}],222:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export')
  , $re     = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});

},{"./_export":135,"./_replacer":191}],223:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', {copyWithin: require('./_array-copy-within')});

require('./_add-to-unscopables')('copyWithin');
},{"./_add-to-unscopables":108,"./_array-copy-within":111,"./_export":135}],224:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $every  = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});
},{"./_array-methods":115,"./_export":135,"./_strict-method":199}],225:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', {fill: require('./_array-fill')});

require('./_add-to-unscopables')('fill');
},{"./_add-to-unscopables":108,"./_array-fill":112,"./_export":135}],226:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});
},{"./_array-methods":115,"./_export":135,"./_strict-method":199}],227:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export')
  , $find   = require('./_array-methods')(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);
},{"./_add-to-unscopables":108,"./_array-methods":115,"./_export":135}],228:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export')
  , $find   = require('./_array-methods')(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);
},{"./_add-to-unscopables":108,"./_array-methods":115,"./_export":135}],229:[function(require,module,exports){
'use strict';
var $export  = require('./_export')
  , $forEach = require('./_array-methods')(0)
  , STRICT   = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});
},{"./_array-methods":115,"./_export":135,"./_strict-method":199}],230:[function(require,module,exports){
'use strict';
var ctx            = require('./_ctx')
  , $export        = require('./_export')
  , toObject       = require('./_to-object')
  , call           = require('./_iter-call')
  , isArrayIter    = require('./_is-array-iter')
  , toLength       = require('./_to-length')
  , createProperty = require('./_create-property')
  , getIterFn      = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":127,"./_ctx":128,"./_export":135,"./_is-array-iter":149,"./_iter-call":154,"./_iter-detect":157,"./_to-length":211,"./_to-object":212,"./core.get-iterator-method":221}],231:[function(require,module,exports){
'use strict';
var $export       = require('./_export')
  , $indexOf      = require('./_array-includes')(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});
},{"./_array-includes":114,"./_export":135,"./_strict-method":199}],232:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', {isArray: require('./_is-array')});
},{"./_export":135,"./_is-array":150}],233:[function(require,module,exports){
arguments[4][93][0].apply(exports,arguments)
},{"./_add-to-unscopables":108,"./_iter-define":156,"./_iter-step":158,"./_iterators":159,"./_to-iobject":210,"dup":93}],234:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export   = require('./_export')
  , toIObject = require('./_to-iobject')
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});
},{"./_export":135,"./_iobject":148,"./_strict-method":199,"./_to-iobject":210}],235:[function(require,module,exports){
'use strict';
var $export       = require('./_export')
  , toIObject     = require('./_to-iobject')
  , toInteger     = require('./_to-integer')
  , toLength      = require('./_to-length')
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});
},{"./_export":135,"./_strict-method":199,"./_to-integer":209,"./_to-iobject":210,"./_to-length":211}],236:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $map    = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});
},{"./_array-methods":115,"./_export":135,"./_strict-method":199}],237:[function(require,module,exports){
'use strict';
var $export        = require('./_export')
  , createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});
},{"./_create-property":127,"./_export":135,"./_fails":137}],238:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});
},{"./_array-reduce":116,"./_export":135,"./_strict-method":199}],239:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});
},{"./_array-reduce":116,"./_export":135,"./_strict-method":199}],240:[function(require,module,exports){
'use strict';
var $export    = require('./_export')
  , html       = require('./_html')
  , cof        = require('./_cof')
  , toIndex    = require('./_to-index')
  , toLength   = require('./_to-length')
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});
},{"./_cof":121,"./_export":135,"./_fails":137,"./_html":144,"./_to-index":208,"./_to-length":211}],241:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $some   = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});
},{"./_array-methods":115,"./_export":135,"./_strict-method":199}],242:[function(require,module,exports){
'use strict';
var $export   = require('./_export')
  , aFunction = require('./_a-function')
  , toObject  = require('./_to-object')
  , fails     = require('./_fails')
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});
},{"./_a-function":106,"./_export":135,"./_fails":137,"./_strict-method":199,"./_to-object":212}],243:[function(require,module,exports){
require('./_set-species')('Array');
},{"./_set-species":194}],244:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});
},{"./_export":135}],245:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export')
  , fails   = require('./_fails')
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});
},{"./_export":135,"./_fails":137}],246:[function(require,module,exports){
'use strict';
var $export     = require('./_export')
  , toObject    = require('./_to-object')
  , toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});
},{"./_export":135,"./_fails":137,"./_to-object":212,"./_to-primitive":213}],247:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));
},{"./_date-to-primitive":129,"./_hide":143,"./_wks":220}],248:[function(require,module,exports){
var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  require('./_redefine')(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}
},{"./_redefine":190}],249:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', {bind: require('./_bind')});
},{"./_bind":119,"./_export":135}],250:[function(require,module,exports){
'use strict';
var isObject       = require('./_is-object')
  , getPrototypeOf = require('./_object-gpo')
  , HAS_INSTANCE   = require('./_wks')('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))require('./_object-dp').f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});
},{"./_is-object":152,"./_object-dp":170,"./_object-gpo":177,"./_wks":220}],251:[function(require,module,exports){
var dP         = require('./_object-dp').f
  , createDesc = require('./_property-desc')
  , has        = require('./_has')
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});
},{"./_descriptors":131,"./_has":142,"./_object-dp":170,"./_property-desc":188}],252:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');

// 23.1 Map Objects
module.exports = require('./_collection')('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);
},{"./_collection":125,"./_collection-strong":122}],253:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export')
  , log1p   = require('./_math-log1p')
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});
},{"./_export":135,"./_math-log1p":163}],254:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export')
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});
},{"./_export":135}],255:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export')
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});
},{"./_export":135}],256:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export')
  , sign    = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});
},{"./_export":135,"./_math-sign":164}],257:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});
},{"./_export":135}],258:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export')
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});
},{"./_export":135}],259:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export')
  , $expm1  = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});
},{"./_export":135,"./_math-expm1":162}],260:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export   = require('./_export')
  , sign      = require('./_math-sign')
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});
},{"./_export":135,"./_math-sign":164}],261:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export')
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});
},{"./_export":135}],262:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export')
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});
},{"./_export":135,"./_fails":137}],263:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});
},{"./_export":135}],264:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', {log1p: require('./_math-log1p')});
},{"./_export":135,"./_math-log1p":163}],265:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});
},{"./_export":135}],266:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', {sign: require('./_math-sign')});
},{"./_export":135,"./_math-sign":164}],267:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export')
  , expm1   = require('./_math-expm1')
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});
},{"./_export":135,"./_fails":137,"./_math-expm1":162}],268:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export')
  , expm1   = require('./_math-expm1')
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});
},{"./_export":135,"./_math-expm1":162}],269:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});
},{"./_export":135}],270:[function(require,module,exports){
'use strict';
var global            = require('./_global')
  , has               = require('./_has')
  , cof               = require('./_cof')
  , inheritIfRequired = require('./_inherit-if-required')
  , toPrimitive       = require('./_to-primitive')
  , fails             = require('./_fails')
  , gOPN              = require('./_object-gopn').f
  , gOPD              = require('./_object-gopd').f
  , dP                = require('./_object-dp').f
  , $trim             = require('./_string-trim').trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(require('./_object-create')(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}
},{"./_cof":121,"./_descriptors":131,"./_fails":137,"./_global":141,"./_has":142,"./_inherit-if-required":146,"./_object-create":169,"./_object-dp":170,"./_object-gopd":173,"./_object-gopn":175,"./_redefine":190,"./_string-trim":205,"./_to-primitive":213}],271:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});
},{"./_export":135}],272:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export   = require('./_export')
  , _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});
},{"./_export":135,"./_global":141}],273:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', {isInteger: require('./_is-integer')});
},{"./_export":135,"./_is-integer":151}],274:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});
},{"./_export":135}],275:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export   = require('./_export')
  , isInteger = require('./_is-integer')
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});
},{"./_export":135,"./_is-integer":151}],276:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});
},{"./_export":135}],277:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});
},{"./_export":135}],278:[function(require,module,exports){
var $export     = require('./_export')
  , $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});
},{"./_export":135,"./_parse-float":184}],279:[function(require,module,exports){
var $export   = require('./_export')
  , $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});
},{"./_export":135,"./_parse-int":185}],280:[function(require,module,exports){
'use strict';
var $export      = require('./_export')
  , toInteger    = require('./_to-integer')
  , aNumberValue = require('./_a-number-value')
  , repeat       = require('./_string-repeat')
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});
},{"./_a-number-value":107,"./_export":135,"./_fails":137,"./_string-repeat":204,"./_to-integer":209}],281:[function(require,module,exports){
'use strict';
var $export      = require('./_export')
  , $fails       = require('./_fails')
  , aNumberValue = require('./_a-number-value')
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});
},{"./_a-number-value":107,"./_export":135,"./_fails":137}],282:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":135,"./_object-assign":168}],283:[function(require,module,exports){
arguments[4][94][0].apply(exports,arguments)
},{"./_export":135,"./_object-create":169,"dup":94}],284:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperties: require('./_object-dps')});
},{"./_descriptors":131,"./_export":135,"./_object-dps":171}],285:[function(require,module,exports){
arguments[4][95][0].apply(exports,arguments)
},{"./_descriptors":131,"./_export":135,"./_object-dp":170,"dup":95}],286:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object')
  , meta     = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});
},{"./_is-object":152,"./_meta":165,"./_object-sap":181}],287:[function(require,module,exports){
arguments[4][96][0].apply(exports,arguments)
},{"./_object-gopd":173,"./_object-sap":181,"./_to-iobject":210,"dup":96}],288:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function(){
  return require('./_object-gopn-ext').f;
});
},{"./_object-gopn-ext":174,"./_object-sap":181}],289:[function(require,module,exports){
arguments[4][97][0].apply(exports,arguments)
},{"./_object-gpo":177,"./_object-sap":181,"./_to-object":212,"dup":97}],290:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});
},{"./_is-object":152,"./_object-sap":181}],291:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});
},{"./_is-object":152,"./_object-sap":181}],292:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});
},{"./_is-object":152,"./_object-sap":181}],293:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', {is: require('./_same-value')});
},{"./_export":135,"./_same-value":192}],294:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
},{"./_object-keys":179,"./_object-sap":181,"./_to-object":212}],295:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object')
  , meta     = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});
},{"./_is-object":152,"./_meta":165,"./_object-sap":181}],296:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object')
  , meta     = require('./_meta').onFreeze;

require('./_object-sap')('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});
},{"./_is-object":152,"./_meta":165,"./_object-sap":181}],297:[function(require,module,exports){
arguments[4][98][0].apply(exports,arguments)
},{"./_export":135,"./_set-proto":193,"dup":98}],298:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof')
  , test    = {};
test[require('./_wks')('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  require('./_redefine')(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}
},{"./_classof":120,"./_redefine":190,"./_wks":220}],299:[function(require,module,exports){
var $export     = require('./_export')
  , $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});
},{"./_export":135,"./_parse-float":184}],300:[function(require,module,exports){
var $export   = require('./_export')
  , $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});
},{"./_export":135,"./_parse-int":185}],301:[function(require,module,exports){
'use strict';
var LIBRARY            = require('./_library')
  , global             = require('./_global')
  , ctx                = require('./_ctx')
  , classof            = require('./_classof')
  , $export            = require('./_export')
  , isObject           = require('./_is-object')
  , aFunction          = require('./_a-function')
  , anInstance         = require('./_an-instance')
  , forOf              = require('./_for-of')
  , speciesConstructor = require('./_species-constructor')
  , task               = require('./_task').set
  , microtask          = require('./_microtask')()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
},{"./_a-function":106,"./_an-instance":109,"./_classof":120,"./_core":126,"./_ctx":128,"./_export":135,"./_for-of":140,"./_global":141,"./_is-object":152,"./_iter-detect":157,"./_library":161,"./_microtask":167,"./_redefine-all":189,"./_set-species":194,"./_set-to-string-tag":195,"./_species-constructor":198,"./_task":207,"./_wks":220}],302:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = require('./_export')
  , aFunction = require('./_a-function')
  , anObject  = require('./_an-object')
  , rApply    = (require('./_global').Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});
},{"./_a-function":106,"./_an-object":110,"./_export":135,"./_fails":137,"./_global":141}],303:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = require('./_export')
  , create     = require('./_object-create')
  , aFunction  = require('./_a-function')
  , anObject   = require('./_an-object')
  , isObject   = require('./_is-object')
  , fails      = require('./_fails')
  , bind       = require('./_bind')
  , rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});
},{"./_a-function":106,"./_an-object":110,"./_bind":119,"./_export":135,"./_fails":137,"./_global":141,"./_is-object":152,"./_object-create":169}],304:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = require('./_object-dp')
  , $export     = require('./_export')
  , anObject    = require('./_an-object')
  , toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});
},{"./_an-object":110,"./_export":135,"./_fails":137,"./_object-dp":170,"./_to-primitive":213}],305:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = require('./_export')
  , gOPD     = require('./_object-gopd').f
  , anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});
},{"./_an-object":110,"./_export":135,"./_object-gopd":173}],306:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export  = require('./_export')
  , anObject = require('./_an-object');
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});
},{"./_an-object":110,"./_export":135,"./_iter-create":155}],307:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = require('./_object-gopd')
  , $export  = require('./_export')
  , anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});
},{"./_an-object":110,"./_export":135,"./_object-gopd":173}],308:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = require('./_export')
  , getProto = require('./_object-gpo')
  , anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});
},{"./_an-object":110,"./_export":135,"./_object-gpo":177}],309:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = require('./_object-gopd')
  , getPrototypeOf = require('./_object-gpo')
  , has            = require('./_has')
  , $export        = require('./_export')
  , isObject       = require('./_is-object')
  , anObject       = require('./_an-object');

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});
},{"./_an-object":110,"./_export":135,"./_has":142,"./_is-object":152,"./_object-gopd":173,"./_object-gpo":177}],310:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});
},{"./_export":135}],311:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export       = require('./_export')
  , anObject      = require('./_an-object')
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});
},{"./_an-object":110,"./_export":135}],312:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', {ownKeys: require('./_own-keys')});
},{"./_export":135,"./_own-keys":183}],313:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export            = require('./_export')
  , anObject           = require('./_an-object')
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});
},{"./_an-object":110,"./_export":135}],314:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = require('./_export')
  , setProto = require('./_set-proto');

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});
},{"./_export":135,"./_set-proto":193}],315:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = require('./_object-dp')
  , gOPD           = require('./_object-gopd')
  , getPrototypeOf = require('./_object-gpo')
  , has            = require('./_has')
  , $export        = require('./_export')
  , createDesc     = require('./_property-desc')
  , anObject       = require('./_an-object')
  , isObject       = require('./_is-object');

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});
},{"./_an-object":110,"./_export":135,"./_has":142,"./_is-object":152,"./_object-dp":170,"./_object-gopd":173,"./_object-gpo":177,"./_property-desc":188}],316:[function(require,module,exports){
var global            = require('./_global')
  , inheritIfRequired = require('./_inherit-if-required')
  , dP                = require('./_object-dp').f
  , gOPN              = require('./_object-gopn').f
  , isRegExp          = require('./_is-regexp')
  , $flags            = require('./_flags')
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function(){
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');
},{"./_descriptors":131,"./_fails":137,"./_flags":139,"./_global":141,"./_inherit-if-required":146,"./_is-regexp":153,"./_object-dp":170,"./_object-gopn":175,"./_redefine":190,"./_set-species":194,"./_wks":220}],317:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if(require('./_descriptors') && /./g.flags != 'g')require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});
},{"./_descriptors":131,"./_flags":139,"./_object-dp":170}],318:[function(require,module,exports){
// @@match logic
require('./_fix-re-wks')('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});
},{"./_fix-re-wks":138}],319:[function(require,module,exports){
// @@replace logic
require('./_fix-re-wks')('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});
},{"./_fix-re-wks":138}],320:[function(require,module,exports){
// @@search logic
require('./_fix-re-wks')('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});
},{"./_fix-re-wks":138}],321:[function(require,module,exports){
// @@split logic
require('./_fix-re-wks')('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = require('./_is-regexp')
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});
},{"./_fix-re-wks":138,"./_is-regexp":153}],322:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject    = require('./_an-object')
  , $flags      = require('./_flags')
  , DESCRIPTORS = require('./_descriptors')
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(require('./_fails')(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}
},{"./_an-object":110,"./_descriptors":131,"./_fails":137,"./_flags":139,"./_redefine":190,"./es6.regexp.flags":317}],323:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');

// 23.2 Set Objects
module.exports = require('./_collection')('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);
},{"./_collection":125,"./_collection-strong":122}],324:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});
},{"./_string-html":202}],325:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});
},{"./_string-html":202}],326:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});
},{"./_string-html":202}],327:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});
},{"./_string-html":202}],328:[function(require,module,exports){
'use strict';
var $export = require('./_export')
  , $at     = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});
},{"./_export":135,"./_string-at":200}],329:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export   = require('./_export')
  , toLength  = require('./_to-length')
  , context   = require('./_string-context')
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});
},{"./_export":135,"./_fails-is-regexp":136,"./_string-context":201,"./_to-length":211}],330:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});
},{"./_string-html":202}],331:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});
},{"./_string-html":202}],332:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});
},{"./_string-html":202}],333:[function(require,module,exports){
var $export        = require('./_export')
  , toIndex        = require('./_to-index')
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});
},{"./_export":135,"./_to-index":208}],334:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export  = require('./_export')
  , context  = require('./_string-context')
  , INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});
},{"./_export":135,"./_fails-is-regexp":136,"./_string-context":201}],335:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});
},{"./_string-html":202}],336:[function(require,module,exports){
arguments[4][100][0].apply(exports,arguments)
},{"./_iter-define":156,"./_string-at":200,"dup":100}],337:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});
},{"./_string-html":202}],338:[function(require,module,exports){
var $export   = require('./_export')
  , toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});
},{"./_export":135,"./_to-iobject":210,"./_to-length":211}],339:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});
},{"./_export":135,"./_string-repeat":204}],340:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});
},{"./_string-html":202}],341:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export     = require('./_export')
  , toLength    = require('./_to-length')
  , context     = require('./_string-context')
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});
},{"./_export":135,"./_fails-is-regexp":136,"./_string-context":201,"./_to-length":211}],342:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});
},{"./_string-html":202}],343:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});
},{"./_string-html":202}],344:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});
},{"./_string-html":202}],345:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});
},{"./_string-trim":205}],346:[function(require,module,exports){
arguments[4][101][0].apply(exports,arguments)
},{"./_an-object":110,"./_descriptors":131,"./_enum-keys":134,"./_export":135,"./_fails":137,"./_global":141,"./_has":142,"./_hide":143,"./_is-array":150,"./_keyof":160,"./_library":161,"./_meta":165,"./_object-create":169,"./_object-dp":170,"./_object-gopd":173,"./_object-gopn":175,"./_object-gopn-ext":174,"./_object-gops":176,"./_object-keys":179,"./_object-pie":180,"./_property-desc":188,"./_redefine":190,"./_set-to-string-tag":195,"./_shared":197,"./_to-iobject":210,"./_to-primitive":213,"./_uid":217,"./_wks":220,"./_wks-define":218,"./_wks-ext":219,"dup":101}],347:[function(require,module,exports){
'use strict';
var $export      = require('./_export')
  , $typed       = require('./_typed')
  , buffer       = require('./_typed-buffer')
  , anObject     = require('./_an-object')
  , toIndex      = require('./_to-index')
  , toLength     = require('./_to-length')
  , isObject     = require('./_is-object')
  , ArrayBuffer  = require('./_global').ArrayBuffer
  , speciesConstructor = require('./_species-constructor')
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);
},{"./_an-object":110,"./_export":135,"./_fails":137,"./_global":141,"./_is-object":152,"./_set-species":194,"./_species-constructor":198,"./_to-index":208,"./_to-length":211,"./_typed":216,"./_typed-buffer":215}],348:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});
},{"./_export":135,"./_typed":216,"./_typed-buffer":215}],349:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],350:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],351:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],352:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],353:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],354:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],355:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],356:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});
},{"./_typed-array":214}],357:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);
},{"./_typed-array":214}],358:[function(require,module,exports){
'use strict';
var each         = require('./_array-methods')(0)
  , redefine     = require('./_redefine')
  , meta         = require('./_meta')
  , assign       = require('./_object-assign')
  , weak         = require('./_collection-weak')
  , isObject     = require('./_is-object')
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}
},{"./_array-methods":115,"./_collection":125,"./_collection-weak":124,"./_is-object":152,"./_meta":165,"./_object-assign":168,"./_redefine":190}],359:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');

// 23.4 WeakSet Objects
require('./_collection')('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);
},{"./_collection":125,"./_collection-weak":124}],360:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export   = require('./_export')
  , $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');
},{"./_add-to-unscopables":108,"./_array-includes":114,"./_export":135}],361:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = require('./_export')
  , microtask = require('./_microtask')()
  , process   = require('./_global').process
  , isNode    = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});
},{"./_cof":121,"./_export":135,"./_global":141,"./_microtask":167}],362:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export')
  , cof     = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});
},{"./_cof":121,"./_export":135}],363:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./_export');

$export($export.P + $export.R, 'Map', {toJSON: require('./_collection-to-json')('Map')});
},{"./_collection-to-json":123,"./_export":135}],364:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});
},{"./_export":135}],365:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});
},{"./_export":135}],366:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});
},{"./_export":135}],367:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});
},{"./_export":135}],368:[function(require,module,exports){
'use strict';
var $export         = require('./_export')
  , toObject        = require('./_to-object')
  , aFunction       = require('./_a-function')
  , $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});
},{"./_a-function":106,"./_descriptors":131,"./_export":135,"./_object-dp":170,"./_object-forced-pam":172,"./_to-object":212}],369:[function(require,module,exports){
'use strict';
var $export         = require('./_export')
  , toObject        = require('./_to-object')
  , aFunction       = require('./_a-function')
  , $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});
},{"./_a-function":106,"./_descriptors":131,"./_export":135,"./_object-dp":170,"./_object-forced-pam":172,"./_to-object":212}],370:[function(require,module,exports){
arguments[4][102][0].apply(exports,arguments)
},{"./_export":135,"./_object-to-array":182,"dup":102}],371:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = require('./_export')
  , ownKeys        = require('./_own-keys')
  , toIObject      = require('./_to-iobject')
  , gOPD           = require('./_object-gopd')
  , createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});
},{"./_create-property":127,"./_export":135,"./_object-gopd":173,"./_own-keys":183,"./_to-iobject":210}],372:[function(require,module,exports){
'use strict';
var $export                  = require('./_export')
  , toObject                 = require('./_to-object')
  , toPrimitive              = require('./_to-primitive')
  , getPrototypeOf           = require('./_object-gpo')
  , getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});
},{"./_descriptors":131,"./_export":135,"./_object-forced-pam":172,"./_object-gopd":173,"./_object-gpo":177,"./_to-object":212,"./_to-primitive":213}],373:[function(require,module,exports){
'use strict';
var $export                  = require('./_export')
  , toObject                 = require('./_to-object')
  , toPrimitive              = require('./_to-primitive')
  , getPrototypeOf           = require('./_object-gpo')
  , getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});
},{"./_descriptors":131,"./_export":135,"./_object-forced-pam":172,"./_object-gopd":173,"./_object-gpo":177,"./_to-object":212,"./_to-primitive":213}],374:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export')
  , $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});
},{"./_export":135,"./_object-to-array":182}],375:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export     = require('./_export')
  , global      = require('./_global')
  , core        = require('./_core')
  , microtask   = require('./_microtask')()
  , OBSERVABLE  = require('./_wks')('observable')
  , aFunction   = require('./_a-function')
  , anObject    = require('./_an-object')
  , anInstance  = require('./_an-instance')
  , redefineAll = require('./_redefine-all')
  , hide        = require('./_hide')
  , forOf       = require('./_for-of')
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

require('./_set-species')('Observable');
},{"./_a-function":106,"./_an-instance":109,"./_an-object":110,"./_core":126,"./_export":135,"./_for-of":140,"./_global":141,"./_hide":143,"./_microtask":167,"./_redefine-all":189,"./_set-species":194,"./_wks":220}],376:[function(require,module,exports){
var metadata                  = require('./_metadata')
  , anObject                  = require('./_an-object')
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});
},{"./_an-object":110,"./_metadata":166}],377:[function(require,module,exports){
var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});
},{"./_an-object":110,"./_metadata":166}],378:[function(require,module,exports){
var Set                     = require('./es6.set')
  , from                    = require('./_array-from-iterable')
  , metadata                = require('./_metadata')
  , anObject                = require('./_an-object')
  , getPrototypeOf          = require('./_object-gpo')
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});
},{"./_an-object":110,"./_array-from-iterable":113,"./_metadata":166,"./_object-gpo":177,"./es6.set":323}],379:[function(require,module,exports){
var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , getPrototypeOf         = require('./_object-gpo')
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});
},{"./_an-object":110,"./_metadata":166,"./_object-gpo":177}],380:[function(require,module,exports){
var metadata                = require('./_metadata')
  , anObject                = require('./_an-object')
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});
},{"./_an-object":110,"./_metadata":166}],381:[function(require,module,exports){
var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});
},{"./_an-object":110,"./_metadata":166}],382:[function(require,module,exports){
var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , getPrototypeOf         = require('./_object-gpo')
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});
},{"./_an-object":110,"./_metadata":166,"./_object-gpo":177}],383:[function(require,module,exports){
var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});
},{"./_an-object":110,"./_metadata":166}],384:[function(require,module,exports){
var metadata                  = require('./_metadata')
  , anObject                  = require('./_an-object')
  , aFunction                 = require('./_a-function')
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});
},{"./_a-function":106,"./_an-object":110,"./_metadata":166}],385:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./_export');

$export($export.P + $export.R, 'Set', {toJSON: require('./_collection-to-json')('Set')});
},{"./_collection-to-json":123,"./_export":135}],386:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export')
  , $at     = require('./_string-at')(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});
},{"./_export":135,"./_string-at":200}],387:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export     = require('./_export')
  , defined     = require('./_defined')
  , toLength    = require('./_to-length')
  , isRegExp    = require('./_is-regexp')
  , getFlags    = require('./_flags')
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});
},{"./_defined":130,"./_export":135,"./_flags":139,"./_is-regexp":153,"./_iter-create":155,"./_to-length":211}],388:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});
},{"./_export":135,"./_string-pad":203}],389:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});
},{"./_export":135,"./_string-pad":203}],390:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');
},{"./_string-trim":205}],391:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');
},{"./_string-trim":205}],392:[function(require,module,exports){
arguments[4][103][0].apply(exports,arguments)
},{"./_wks-define":218,"dup":103}],393:[function(require,module,exports){
arguments[4][104][0].apply(exports,arguments)
},{"./_wks-define":218,"dup":104}],394:[function(require,module,exports){
// https://github.com/ljharb/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {global: require('./_global')});
},{"./_export":135,"./_global":141}],395:[function(require,module,exports){
var $iterators    = require('./es6.array.iterator')
  , redefine      = require('./_redefine')
  , global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , wks           = require('./_wks')
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}
},{"./_global":141,"./_hide":143,"./_iterators":159,"./_redefine":190,"./_wks":220,"./es6.array.iterator":233}],396:[function(require,module,exports){
var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});
},{"./_export":135,"./_task":207}],397:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global     = require('./_global')
  , $export    = require('./_export')
  , invoke     = require('./_invoke')
  , partial    = require('./_partial')
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});
},{"./_export":135,"./_global":141,"./_invoke":147,"./_partial":186}],398:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.umulh');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');
},{"./modules/_core":126,"./modules/es6.array.copy-within":223,"./modules/es6.array.every":224,"./modules/es6.array.fill":225,"./modules/es6.array.filter":226,"./modules/es6.array.find":228,"./modules/es6.array.find-index":227,"./modules/es6.array.for-each":229,"./modules/es6.array.from":230,"./modules/es6.array.index-of":231,"./modules/es6.array.is-array":232,"./modules/es6.array.iterator":233,"./modules/es6.array.join":234,"./modules/es6.array.last-index-of":235,"./modules/es6.array.map":236,"./modules/es6.array.of":237,"./modules/es6.array.reduce":239,"./modules/es6.array.reduce-right":238,"./modules/es6.array.slice":240,"./modules/es6.array.some":241,"./modules/es6.array.sort":242,"./modules/es6.array.species":243,"./modules/es6.date.now":244,"./modules/es6.date.to-iso-string":245,"./modules/es6.date.to-json":246,"./modules/es6.date.to-primitive":247,"./modules/es6.date.to-string":248,"./modules/es6.function.bind":249,"./modules/es6.function.has-instance":250,"./modules/es6.function.name":251,"./modules/es6.map":252,"./modules/es6.math.acosh":253,"./modules/es6.math.asinh":254,"./modules/es6.math.atanh":255,"./modules/es6.math.cbrt":256,"./modules/es6.math.clz32":257,"./modules/es6.math.cosh":258,"./modules/es6.math.expm1":259,"./modules/es6.math.fround":260,"./modules/es6.math.hypot":261,"./modules/es6.math.imul":262,"./modules/es6.math.log10":263,"./modules/es6.math.log1p":264,"./modules/es6.math.log2":265,"./modules/es6.math.sign":266,"./modules/es6.math.sinh":267,"./modules/es6.math.tanh":268,"./modules/es6.math.trunc":269,"./modules/es6.number.constructor":270,"./modules/es6.number.epsilon":271,"./modules/es6.number.is-finite":272,"./modules/es6.number.is-integer":273,"./modules/es6.number.is-nan":274,"./modules/es6.number.is-safe-integer":275,"./modules/es6.number.max-safe-integer":276,"./modules/es6.number.min-safe-integer":277,"./modules/es6.number.parse-float":278,"./modules/es6.number.parse-int":279,"./modules/es6.number.to-fixed":280,"./modules/es6.number.to-precision":281,"./modules/es6.object.assign":282,"./modules/es6.object.create":283,"./modules/es6.object.define-properties":284,"./modules/es6.object.define-property":285,"./modules/es6.object.freeze":286,"./modules/es6.object.get-own-property-descriptor":287,"./modules/es6.object.get-own-property-names":288,"./modules/es6.object.get-prototype-of":289,"./modules/es6.object.is":293,"./modules/es6.object.is-extensible":290,"./modules/es6.object.is-frozen":291,"./modules/es6.object.is-sealed":292,"./modules/es6.object.keys":294,"./modules/es6.object.prevent-extensions":295,"./modules/es6.object.seal":296,"./modules/es6.object.set-prototype-of":297,"./modules/es6.object.to-string":298,"./modules/es6.parse-float":299,"./modules/es6.parse-int":300,"./modules/es6.promise":301,"./modules/es6.reflect.apply":302,"./modules/es6.reflect.construct":303,"./modules/es6.reflect.define-property":304,"./modules/es6.reflect.delete-property":305,"./modules/es6.reflect.enumerate":306,"./modules/es6.reflect.get":309,"./modules/es6.reflect.get-own-property-descriptor":307,"./modules/es6.reflect.get-prototype-of":308,"./modules/es6.reflect.has":310,"./modules/es6.reflect.is-extensible":311,"./modules/es6.reflect.own-keys":312,"./modules/es6.reflect.prevent-extensions":313,"./modules/es6.reflect.set":315,"./modules/es6.reflect.set-prototype-of":314,"./modules/es6.regexp.constructor":316,"./modules/es6.regexp.flags":317,"./modules/es6.regexp.match":318,"./modules/es6.regexp.replace":319,"./modules/es6.regexp.search":320,"./modules/es6.regexp.split":321,"./modules/es6.regexp.to-string":322,"./modules/es6.set":323,"./modules/es6.string.anchor":324,"./modules/es6.string.big":325,"./modules/es6.string.blink":326,"./modules/es6.string.bold":327,"./modules/es6.string.code-point-at":328,"./modules/es6.string.ends-with":329,"./modules/es6.string.fixed":330,"./modules/es6.string.fontcolor":331,"./modules/es6.string.fontsize":332,"./modules/es6.string.from-code-point":333,"./modules/es6.string.includes":334,"./modules/es6.string.italics":335,"./modules/es6.string.iterator":336,"./modules/es6.string.link":337,"./modules/es6.string.raw":338,"./modules/es6.string.repeat":339,"./modules/es6.string.small":340,"./modules/es6.string.starts-with":341,"./modules/es6.string.strike":342,"./modules/es6.string.sub":343,"./modules/es6.string.sup":344,"./modules/es6.string.trim":345,"./modules/es6.symbol":346,"./modules/es6.typed.array-buffer":347,"./modules/es6.typed.data-view":348,"./modules/es6.typed.float32-array":349,"./modules/es6.typed.float64-array":350,"./modules/es6.typed.int16-array":351,"./modules/es6.typed.int32-array":352,"./modules/es6.typed.int8-array":353,"./modules/es6.typed.uint16-array":354,"./modules/es6.typed.uint32-array":355,"./modules/es6.typed.uint8-array":356,"./modules/es6.typed.uint8-clamped-array":357,"./modules/es6.weak-map":358,"./modules/es6.weak-set":359,"./modules/es7.array.includes":360,"./modules/es7.asap":361,"./modules/es7.error.is-error":362,"./modules/es7.map.to-json":363,"./modules/es7.math.iaddh":364,"./modules/es7.math.imulh":365,"./modules/es7.math.isubh":366,"./modules/es7.math.umulh":367,"./modules/es7.object.define-getter":368,"./modules/es7.object.define-setter":369,"./modules/es7.object.entries":370,"./modules/es7.object.get-own-property-descriptors":371,"./modules/es7.object.lookup-getter":372,"./modules/es7.object.lookup-setter":373,"./modules/es7.object.values":374,"./modules/es7.observable":375,"./modules/es7.reflect.define-metadata":376,"./modules/es7.reflect.delete-metadata":377,"./modules/es7.reflect.get-metadata":379,"./modules/es7.reflect.get-metadata-keys":378,"./modules/es7.reflect.get-own-metadata":381,"./modules/es7.reflect.get-own-metadata-keys":380,"./modules/es7.reflect.has-metadata":382,"./modules/es7.reflect.has-own-metadata":383,"./modules/es7.reflect.metadata":384,"./modules/es7.set.to-json":385,"./modules/es7.string.at":386,"./modules/es7.string.match-all":387,"./modules/es7.string.pad-end":388,"./modules/es7.string.pad-start":389,"./modules/es7.string.trim-left":390,"./modules/es7.string.trim-right":391,"./modules/es7.symbol.async-iterator":392,"./modules/es7.symbol.observable":393,"./modules/es7.system.global":394,"./modules/web.dom.iterable":395,"./modules/web.immediate":396,"./modules/web.timers":397}],399:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],400:[function(require,module,exports){
(function (process,global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":399}],401:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

exports.init = init;

require('babel-polyfill');

var _stats = require('./stats');

var stats = _interopRequireWildcard(_stats);

var _params = require('./params');

var params = _interopRequireWildcard(_params);

var _states = require('./states');

var states = _interopRequireWildcard(_states);

var _audio = require('./audio');

var audio = _interopRequireWildcard(_audio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import game states.
function init() {
    var config = {
        width: 640,
        height: 480,
        renderer: Phaser.AUTO,
        antialias: true
    };

    var game = new Phaser.Game(config);

    // Hack for Phaser fonts
    Phaser.Cache.addBitmapFontFromAtlas = function (key, atlasKey, atlasFrame, dataKey, dataType, xSpacing, ySpacing) {

        var frame = this.getFrameByName(atlasKey, atlasFrame);

        if (!frame) {
            return;
        }

        var obj = {
            font: null,
            base: this.getBaseTexture(atlasKey),
            frame: frame
        };

        if (xSpacing === undefined) {
            xSpacing = 0;
        }
        if (ySpacing === undefined) {
            ySpacing = 0;
        }

        var fontData;

        if (dataType === 'json') {
            fontData = this.getJSON(dataKey);
            obj.font = Phaser.LoaderParser.jsonBitmapFont(fontData, obj.base, xSpacing, ySpacing, frame);
        } else {
            fontData = this.getXML(dataKey);
            obj.font = Phaser.LoaderParser.xmlBitmapFont(fontData, obj.base, xSpacing, ySpacing, frame);
        }

        for (var charName in obj.font.chars) {
            var char = obj.font.chars[charName];
            //console.log("char before: ", char);
            char.x -= 20;
            char.y -= 20;

            char.width += 40;
            char.height += 40;

            char.corrected = true;
            //console.log("char after: ", char);
        }

        this._cache.bitmapFont[key] = obj;
    };
    Phaser.LoaderParser.xmlBitmapFont = function (xml, baseTexture, xSpacing, ySpacing, frame) {
        var fixForFonts = 2;

        var data = {};
        var info = xml.getElementsByTagName('info')[0];
        var common = xml.getElementsByTagName('common')[0];

        data.font = info.getAttribute('face');
        data.size = parseInt(info.getAttribute('size'), 10);
        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) + ySpacing;
        data.chars = {};

        var letters = xml.getElementsByTagName('char');

        var x = frame ? frame.x : 0;
        var y = frame ? frame.y : 0;

        for (var i = 0; i < letters.length; i++) {
            var charCode = parseInt(letters[i].getAttribute('id'), 10);

            data.chars[charCode] = {
                x: x + parseInt(letters[i].getAttribute('x'), 10) - fixForFonts,
                y: y + parseInt(letters[i].getAttribute('y'), 10) - fixForFonts,
                width: parseInt(letters[i].getAttribute('width'), 10) + 2 * fixForFonts,
                height: parseInt(letters[i].getAttribute('height'), 10) + 2 * fixForFonts,
                xOffset: parseInt(letters[i].getAttribute('xoffset'), 10),
                yOffset: parseInt(letters[i].getAttribute('yoffset'), 10),
                xAdvance: parseInt(letters[i].getAttribute('xadvance'), 10) + xSpacing,
                kerning: {}
            };
        }

        var kernings = xml.getElementsByTagName('kerning');

        for (i = 0; i < kernings.length; i++) {
            var first = parseInt(kernings[i].getAttribute('first'), 10);
            var second = parseInt(kernings[i].getAttribute('second'), 10);
            var amount = parseInt(kernings[i].getAttribute('amount'), 10);

            data.chars[second].kerning[first] = amount;
        }

        return this.finalizeBitmapFont(baseTexture, data);
    };

    // Dynamically add all required game states.
    (0, _entries2.default)(states).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            state = _ref2[1];

        return game.state.add(key, state);
    });

    game.state.start('Boot');

    return game;
} /**
   * `app` module
   * Provides the game initialization routine.
   */

// Required: import the Babel runtime module.
;

},{"./audio":403,"./params":417,"./states":418,"./stats":422,"babel-polyfill":1,"babel-runtime/core-js/object/entries":6,"babel-runtime/helpers/slicedToArray":17}],402:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * `assets` module
 */

exports.default = {
    // -- Splash screen assets, displayed during the 'Preload' state.
    boot: [{
        key: 'preloader',
        type: 'atlasJSONHash',
        atlasURL: 'images/' + PARAMS.assetsVersion + '/preloader.json',
        textureURL: 'images/' + PARAMS.assetsVersion + '/preloader.png'
    }],

    // -- General assets, used throughout the game.
    game: [{
        key: 'blurredBg',
        type: 'image',
        url: 'images/blurredBg.png'
    }, {
        key: 'backgroundMusic',
        type: 'audio',
        urls: ['audio/music/backgroundMusic.mp3', 'audio/music/backgroundMusic.m4a', 'backgroundMusic.ogg']
    }, {
        key: 'TilePop2',
        type: 'audio',
        urls: ['audio/sfx/TilePop2.mp3', 'audio/sfx/TilePop2.m4a', 'audio/sfx/TilePop2.ogg']
    }, {
        key: 'BaddieGrunt1',
        type: 'audio',
        urls: ['audio/sfx/BaddieGrunt1.mp3', 'audio/sfx/BaddieGrunt1.m4a', 'audio/sfx/BaddieGrunt1.ogg']
    }, {
        key: 'emptyLine',
        type: 'audio',
        urls: ['audio/sfx/emptyLine.mp3', 'audio/sfx/emptyLine.m4a', 'audio/sfx/emptyLine.ogg']
    }, {
        key: 'PowerupPartyBombExplosion1',
        type: 'audio',
        urls: ['audio/sfx/PowerupPartyBombExplosion1.mp3', 'audio/sfx/PowerupPartyBombExplosion1.m4a', 'audio/sfx/PowerupPartyBombExplosion1.ogg']
    }, {
        key: 'bombCharged',
        type: 'audio',
        urls: ['audio/sfx/bombCharged.mp3', 'audio/sfx/bombCharged.m4a', 'audio/sfx/bombCharged.ogg']
    }, {
        key: 'ButtonClick',
        type: 'audio',
        urls: ['audio/sfx/ButtonClick.mp3', 'audio/sfx/ButtonClick.m4a', 'audio/sfx/ButtonClick.ogg']
    }, {
        key: 'Success',
        type: 'audio',
        urls: ['audio/sfx/Success.mp3', 'audio/sfx/Success.m4a', 'audio/sfx/Success.ogg']
    }, {
        key: 'gameOver',
        type: 'audio',
        urls: ['audio/sfx/gameOver.mp3', 'audio/sfx/gameOver.m4a', 'audio/sfx/gameOver.ogg']
    }, {
        key: 'time_15sec',
        type: 'audio',
        urls: ['audio/sfx/time_15sec.mp3', 'audio/sfx/time_15sec.m4a', 'audio/sfx/time_15sec.ogg']
    }, {
        key: 'time_30sec',
        type: 'audio',
        urls: ['audio/sfx/time_30sec.mp3', 'audio/sfx/time_30sec.m4a', 'audio/sfx/time_30sec.ogg']
    }, {
        key: 'words',
        type: 'text',
        url: 'words.txt'
    }, {
        key: 'fontsData',
        type: 'json',
        url: 'data/fontsData.json'
    }, {
        key: 'fontsAll',
        type: 'atlasJSONHash',
        atlasURL: 'images/fontsAll.json',
        textureURL: 'images/fontsAll.png'
    }, {
        'type': 'script',
        'key': 'BlurX',
        'url': 'filters/BlurX.js'
    }, {
        'type': 'script',
        'key': 'BlurY',
        'url': 'filters/BlurY.js'
    }]
};

},{}],403:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Audio = function () {
    function Audio() {
        (0, _classCallCheck3.default)(this, Audio);
    }

    (0, _createClass3.default)(Audio, [{
        key: 'init',
        value: function init(game) {
            this.game = game;
            this.allMuted = false;
            this.isMusicPlaying = false;
            this.musicVolume = 0.5;
            this.sounds = {};

            this.tilePopBlocked = false;
            this.music = game.add.audio('backgroundMusic');
            this.sounds['tilePop'] = this.tilePop = game.add.audio('TilePop2');
            this.sounds['baddieGrunt'] = this.tilePop = game.add.audio('BaddieGrunt1');
            this.sounds['emptyLine'] = this.tilePop = game.add.audio('emptyLine');
            this.sounds['bombExplosion'] = this.bombExplosion = game.add.audio('PowerupPartyBombExplosion1');
            this.sounds['bombCharged'] = this.bombCharged = game.add.audio('bombCharged');
            this.sounds['buttonClick'] = this.buttonClick = game.add.audio('ButtonClick');
            this.sounds['success'] = this.success = game.add.audio('Success');
            this.sounds['gameOver'] = this.gameOver = game.add.audio('gameOver');
            this.sounds['time_15sec'] = this.time_15sec = game.add.audio('time_15sec');
            this.sounds['time_30sec'] = this.time_30sec = game.add.audio('time_30sec');
        }
    }, {
        key: 'playMusic',
        value: function playMusic() {
            if (this.isMusicPlaying) {
                return;
            }
            this.music.volume = this.allMuted ? 0 : this.musicVolume;
            this.isMusicPlaying = true;
            this.music.loop = true;
            this.music.play();
        }
    }, {
        key: 'playSound',
        value: function playSound(name) {
            if (name === 'tilePop' && this.tilePopBlocked) return;else if (name === 'tilePop') {
                this.tilePopBlocked = true;
                this.game.time.events.add(100, function () {
                    AUDIO.tilePopBlocked = false;
                });
            }

            var sound = this.sounds[name];
            sound.play();
        }
    }, {
        key: 'muteAll',
        value: function muteAll() {
            this.allMuted = true;
            for (var key in this.sounds) {
                var sound = this.sounds[key];
                sound.volume = 0;
            }
            this.music.volume = 0;
        }
    }, {
        key: 'unmuteAll',
        value: function unmuteAll() {
            this.allMuted = false;
            for (var key in this.sounds) {
                var sound = this.sounds[key];
                sound.volume = 1;
            }
            this.music.volume = this.musicVolume;
        }
    }, {
        key: 'updateVolume',
        value: function updateVolume() {
            if (this.allMuted || GS.pausedByArkadium) {
                this.muteAll();
            } else if (this.allMuted) {
                this.muteAll();
            } else {
                this.unmuteAll();
            }
        }
    }]);
    return Audio;
}();

exports.default = Audio;

window.AUDIO = new Audio();

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],404:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BaseGameUI
 * Handles UI panels for portrait and landscape view.
 */

var BaseGameUI = function () {
    // ==================== Construction ====================
    function BaseGameUI(game) {
        (0, _classCallCheck3.default)(this, BaseGameUI);

        this.game = game;
        this.view = game.make.group();

        this.buttons = [];
        this.texts = [];

        this.paused = false;
        this.visible = false;
    }

    (0, _createClass3.default)(BaseGameUI, [{
        key: 'init',
        value: function init(game) {
            this.levelText.text = 'Level ' + game.level;
            this.totalPointsText.text = game.score.toString();
            this.updateBombCounter(game.availableBombs);

            // Reset goals text
            this.currentGoals.text = 'Lines 0/' + game.goal;
            this.goalCompleteMark.alpha = 0;
            this.goals.alpha = 1;
            this.currentGoals.alpha = 1;
            this.bombPanel.alpha = 0;
            this.bombFiller.alpha = 0;
            this.bonusBombText.alpha = 0;

            // this.game.add.tween(this.goalCompletedSign)
            //     .to({y: this.goalCompletedSign.y + 39 / 2 * PARAMS.scaleFactor}, 300, Phaser.Easing.Linear.None, true, 2000);
        }

        // ==================== Button Callbacks ====================

    }, {
        key: 'onButtonExit',
        value: function onButtonExit() {
            if (!this.visible) {
                return;
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            AUDIO.playSound('buttonClick');
            GS.pause();
            GS.overlayScreens.showScreen('exitGame');
        }
    }, {
        key: 'onButtonHelp',
        value: function onButtonHelp() {
            if (!this.visible) {
                return;
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            AUDIO.playSound('buttonClick');
            GS.pause();
            GS.overlayScreens.screenBeforeHelp = 'game';
            GS.overlayScreens.showScreen('help1');
        }
    }, {
        key: 'onButtonPause',
        value: function onButtonPause() {
            if (!this.visible) {
                return;
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            AUDIO.playSound('buttonClick');
            GS.pause();
            GS.overlayScreens.showScreen('pause');
        }
    }, {
        key: 'onButtonMute',
        value: function onButtonMute() {
            if (!this.visible) {
                return;
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            AUDIO.playSound('buttonClick');
            GS.mute();
        }
    }, {
        key: 'onButtonUnmute',
        value: function onButtonUnmute() {
            if (!this.visible) {
                return;
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            AUDIO.playSound('buttonClick');
            GS.unmute();
        }
    }, {
        key: 'updateMuteButtons',
        value: function updateMuteButtons() {
            if (AUDIO.allMuted) {
                this.buttonMute.alpha = 1;
                this.buttonUnmute.alpha = 0;
                this.buttonMute.inputEnabled = true && this.visible && !this.paused;
                this.buttonUnmute.inputEnabled = false;
            } else {
                this.buttonMute.alpha = 0;
                this.buttonUnmute.alpha = 1;
                this.buttonMute.inputEnabled = false;
                this.buttonUnmute.inputEnabled = true && this.visible && !this.paused;
            }
        }
    }, {
        key: 'setEnableForAllButtons',
        value: function setEnableForAllButtons() {
            var enable = this.visible && !this.paused;
            for (var i = 0; i < this.buttons.length; i++) {
                this.buttons[i].inputEnabled = enable;
            }
            this.updateMuteButtons();
        }

        // ==================== Interface ====================

    }, {
        key: 'show',
        value: function show() {
            this.visible = true;
            this.setEnableForAllButtons();
            this.view.alpha = 1;
            GS.view.addAt(this.view, 0);
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.visible = false;
            this.setEnableForAllButtons();
            this.view.alpha = 0;
            GS.view.removeChild(this.view);
        }
    }, {
        key: 'onPause',
        value: function onPause() {
            this.paused = true;
            this.setEnableForAllButtons();
        }
    }, {
        key: 'onResume',
        value: function onResume() {
            this.paused = false;
            this.setEnableForAllButtons();
        }

        // ==================== Update ====================

    }, {
        key: 'updateBombCounter',
        value: function updateBombCounter(bombs) {
            if (bombs === 0) {
                this.bombCounterText.setText('');
                this.bombInstructionText.alpha = 0;
            } else {
                this.bombCounterText.setText('x ' + bombs);
                this.bombInstructionText.alpha = 1;
            }
        }
    }, {
        key: 'updateFiller',
        value: function updateFiller(factor) {
            var tween = this.game.add.tween(this.bombFiller.cropRect).to({ width: factor * this.widthForFullInficator }, 500).start();

            tween.onUpdateCallback(function () {
                this.bombFiller.updateCrop();
            }, this);
        }
    }, {
        key: 'updateGoals',
        value: function updateGoals(lines, goal) {
            this.currentGoals.setText('Lines ' + lines + '/' + goal);
        }
    }, {
        key: 'updateSelectedWord',
        value: function updateSelectedWord(word, valid, points) {
            this.wrongText.fontSize = this.currentWordFontSize * PARAMS.scaleFactor;
            this.rightText.fontSize = this.currentWordFontSize * PARAMS.scaleFactor;
            if (valid) {
                this.setValidWord(word);
            } else {
                this.setInvalidWord(word);
            }
            if (points >= 0) {
                this.wordPointsText.setText(points);
            } else {
                this.wordPointsText.setText('');
            }
        }
    }, {
        key: 'updateTexts',
        value: function updateTexts(texts) {
            if (!texts) {
                texts = this.texts;
            }

            var globalScale = 1;
            var par = this.view;
            while (par) {
                // par.x = Math.round(par.x);
                // par.y = Math.round(par.y);
                // par.pivot.x = Math.round(par.pivot.x);
                // par.pivot.y = Math.round(par.pivot.y);
                globalScale *= par.scale.x;
                par = par.parent;
            }

            for (var i = 0; i < texts.length; i++) {
                var elem = texts[i];
                // elem.x = Math.round(elem.x)
                // elem.y = Math.round(elem.y)
                // elem.pivot.x = Math.round(elem.pivot.x);
                // elem.pivot.y = Math.round(elem.pivot.y);

                if (elem.preferredFontSize) {
                    var newFont = PARAMS.getFonts(elem.fontNameColor, globalScale * elem.preferredFontSize);
                    elem.font = newFont;
                }
                // elem.x -= elem.worldPosition.x - Math.floor(elem.worldPosition.x) ;
                // elem.y -= elem.worldPosition.y - Math.floor(elem.worldPosition.y) ;
            }
        }
    }, {
        key: 'updateTimer',
        value: function updateTimer(timeLeft) {
            var seconds = Math.round(timeLeft / 1000);
            this.timeLeftText.setText(seconds);
            if (seconds <= 15) {
                this.timeLeftText.tint = 0xff6666;
            } else {
                this.timeLeftText.tint = 0xffffff;
            }
            window.timeLeft = this.timeLeftText;
        }
    }, {
        key: 'updateTotalScore',
        value: function updateTotalScore(score) {
            this.totalPointsText.setText(score);
        }

        // ==================== Methods ====================

    }, {
        key: 'clearCurrentScore',
        value: function clearCurrentScore() {
            this.game.time.events.add(500, function () {
                this.wordPointsText.setText('');
                this.setValidWord('');
            }, this);
        }
    }, {
        key: 'goalReached',
        value: function goalReached() {
            this.goalCompleteMark.alpha = 1;
            this.goalCompleteMark.play('show');

            this.game.add.tween(this.goals).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true, 1500);

            this.game.add.tween(this.currentGoals).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true, 1500);

            this.game.add.tween(this.goalCompletedSign).to({ y: this.goalCompletedSign.y + 39 / 2 * PARAMS.scaleFactor }, 300, Phaser.Easing.Linear.None, true, 2000);

            this.game.add.tween(this.bombPanel).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true, 1750);

            this.game.add.tween(this.bombFiller).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true, 1750);

            this.game.add.tween(this.bonusBombText).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true, 1750);
        }

        // ==================== Helper Methods ====================

    }, {
        key: 'addTextElement',
        value: function addTextElement(x, y, font, text, size) {
            var element = this.game.make.bitmapText(x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, font, text, size * PARAMS.scaleFactor);
            element.anchor.set(0.5);
            this.view.add(element);
            this.texts.push(element);
            return element;
        }
    }, {
        key: 'addTextElement2',
        value: function addTextElement2(x, y, fontColor, text, size) {
            var font = PARAMS.getFonts(fontColor, size);
            var element = this.game.make.bitmapText(x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, font, text, size * PARAMS.scaleFactor);
            element.preferredFontSize = size * PARAMS.scaleFactor;
            element.fontNameColor = fontColor;
            element.anchor.set(0.5);
            this.view.add(element);
            this.texts.push(element);
            return element;
        }
    }, {
        key: 'addButton',
        value: function addButton(x, y, texture, action) {
            var normal = texture + '.png';
            var down = texture + 'Rollover.png';
            var button = PARAMS.addButton(this.game, x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, 'gameElements', action, this, normal, normal, down);
            button.anchor.set(0.5);
            this.view.add(button);
            this.buttons.push(button);
            return button;
        }
    }, {
        key: 'setInvalidWord',
        value: function setInvalidWord(word) {
            word = word.substring(0, 15);
            this.wrongText.alpha = 1;
            this.wrongText.setText(word.toUpperCase());
            this.rightText.alpha = 0;

            var width = this.wrongText.width;
            var change = false;
            if (width > this.currentWordMaxLength * PARAMS.scaleFactor) {
                this.wrongText.fontSize -= 1;
                this.setInvalidWord(word);
                change = true;
            }
            if (change) {
                this.updateTexts();
            }
        }
    }, {
        key: 'setValidWord',
        value: function setValidWord(word) {
            word = word.substring(0, 15);
            this.wrongText.alpha = 0;
            this.rightText.setText(word.toUpperCase());
            this.rightText.alpha = 1;

            var width = this.rightText.width;
            var change = false;
            if (width > this.currentWordMaxLength * PARAMS.scaleFactor) {
                this.rightText.fontSize -= 1;
                this.setValidWord(word);
                change = true;
            }
            if (change) {
                this.updateTexts();
            }
        }

        // ==================== Destruction ====================

    }, {
        key: 'destroy',
        value: function destroy() {
            this.game = null;
            this.view = null;

            for (var i = 0; i < this.buttons.length; ++i) {
                this.buttons[i].destroy();
            }
            this.buttons.length = 0;

            for (var i = 0; i < this.texts.length; ++i) {
                this.texts[i].destroy();
            }
            this.texts.length = 0;
        }
    }]);
    return BaseGameUI;
}();

exports.default = BaseGameUI;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],405:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseGameUI2 = require('../gameui/BaseGameUI');

var _BaseGameUI3 = _interopRequireDefault(_BaseGameUI2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandscapeGameUI = function (_BaseGameUI) {
    (0, _inherits3.default)(LandscapeGameUI, _BaseGameUI);

    // ==================== Construction ====================
    function LandscapeGameUI(game) {
        (0, _classCallCheck3.default)(this, LandscapeGameUI);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LandscapeGameUI.__proto__ || (0, _getPrototypeOf2.default)(LandscapeGameUI)).call(this, game));

        _this.topPanel = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'topPanelLandscape.png');
        _this.topPanel.anchor.set(0.5, 176 / 2 / 245);
        _this.view.add(_this.topPanel);

        _this.goalCompletedSign = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 300 * PARAMS.scaleFactor, 'gameElements', 'levelCompleteSign.png');
        _this.goalCompletedSign.anchor.set(0.5);
        _this.view.add(_this.goalCompletedSign);

        _this.bottomPanel = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, 253 * PARAMS.scaleFactor, 'gameElements', 'bottomPanelLandscape.png');
        _this.bottomPanel.anchor.set(0.5);
        _this.view.add(_this.bottomPanel);

        _this.bombPanel = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, 253 * PARAMS.scaleFactor, 'gameElements', 'bombActivePanelLandscape.png');
        _this.bombPanel.anchor.set(0.5);
        _this.bombPanel.alpha = 0;
        _this.view.add(_this.bombPanel);

        _this.bombFiller = PARAMS.makeSprite(game, -70 * PARAMS.scaleFactor, 255 * PARAMS.scaleFactor, 'gameElements', 'bombChargeLandscape.png');
        _this.bombFiller.alpha = 0;
        _this.view.add(_this.bombFiller);

        _this.widthForFullInficator = _this.bombFiller.width;
        _this.bombFiller.cropRect = new Phaser.Rectangle(0, 0, 0, _this.bombFiller.height);
        _this.bombFiller.updateCrop();

        _this.view.x = (154 / 2 + 3) * PARAMS.scaleFactor;
        _this.view.y = (176 / 2 + 1) * PARAMS.scaleFactor;

        _this.levelText = _this.addTextElement2(0, -65, 'blue', 'Level ' + game.level, 20);
        _this.rightText = _this.addTextElement2(0, -30, 'green', '', 30);
        _this.wrongText = _this.addTextElement2(0, -30, 'red', '', 30);
        _this.wordPointsText = _this.addTextElement2(0, -8, 'white', '', 17);
        _this.scoreText = _this.addTextElement2(0, 27, 'white', 'Score:', 20);
        _this.totalPointsText = _this.addTextElement2(0, 55, 'white', '' + game.score, 30);
        _this.timerText = _this.addTextElement2(0, 100, 'white', 'Time:', 20);
        _this.timeLeftText = _this.addTextElement2(0, 128, 'white', '', 20);
        _this.goals = _this.addTextElement2(0, 20 + 253, 'white', 'Goal', 18);
        _this.currentGoals = _this.addTextElement2(0, 43 + 253, 'white', 'Lines 0/' + game.goal, 22);
        _this.bombCounterText = _this.addTextElement2(40, 225, 'blue', 'x 8', 22);

        _this.goalCompleteMark = PARAMS.makeSprite(game, 40 * PARAMS.scaleFactor, 255 * PARAMS.scaleFactor, 'flashAnims', 'goalCompleteAnimation/0000');
        _this.goalCompleteMark.anchor.set(0.5);
        _this.goalCompleteMark.alpha = 0;
        _this.view.add(_this.goalCompleteMark);

        _this.goalCompletedText = _this.addTextElement2(0, 10, 'blue', 'Goal completed', 14);
        _this.goalCompletedSign.scale.set(0.8);
        _this.goalCompletedSign.addChild(_this.goalCompletedText);

        _this.bombInstructionText = _this.addTextElement2(0, 180, 'white', 'Drag Bomb To Use', 14);
        _this.bonusBombText = _this.addTextElement2(0, 296, 'white', 'Bonus Bomb', 20);
        _this.bonusBombText.alpha = 0;

        var frames = window.Phaser.Animation.generateFrameNames('goalCompleteAnimation/', 0, 34, '', 4);
        _this.goalCompleteMark.animations.add('show', frames, 20, false);
        _this.goalCompleteMark.events.onAnimationComplete.add(function () {
            this.goalCompleteMark.alpha = 0;
        }, _this);

        // Buttons
        _this.buttonExit = _this.addButton(-56, 365, 'exitButton', _this.onButtonExit);
        _this.buttonPause = _this.addButton(-19, 365, 'statsButton', _this.onButtonPause);
        _this.buttonMute = _this.addButton(19, 365, 'unmuteButton', _this.onButtonUnmute);
        _this.buttonUnmute = _this.addButton(19, 365, 'muteButton', _this.onButtonMute);
        _this.buttonHelp = _this.addButton(56, 365, 'helpButton', _this.onButtonHelp);

        _this.currentWordFontSize = 30;
        _this.currentWordMaxLength = 130;
        return _this;
    }

    // ==================== Initialization ====================


    (0, _createClass3.default)(LandscapeGameUI, [{
        key: 'init',
        value: function init(game) {
            (0, _get3.default)(LandscapeGameUI.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandscapeGameUI.prototype), 'init', this).call(this, game);
            this.goalCompletedSign.y = 300 * PARAMS.scaleFactor;
        }
    }]);
    return LandscapeGameUI;
}(_BaseGameUI3.default); /**
                          * LandscapeGameUI
                          * Handles UI panels for landscape view.
                          */

// ==================== Imports ====================


exports.default = LandscapeGameUI;

},{"../gameui/BaseGameUI":404,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],406:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseGameUI2 = require('../gameui/BaseGameUI');

var _BaseGameUI3 = _interopRequireDefault(_BaseGameUI2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortraitGameUI = function (_BaseGameUI) {
    (0, _inherits3.default)(PortraitGameUI, _BaseGameUI);

    // ==================== Construction ====================
    function PortraitGameUI(game) {
        (0, _classCallCheck3.default)(this, PortraitGameUI);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PortraitGameUI.__proto__ || (0, _getPrototypeOf2.default)(PortraitGameUI)).call(this, game));

        _this.goalCompletedSign = PARAMS.makeSprite(game, -140 * PARAMS.scaleFactor, 106 * PARAMS.scaleFactor, 'gameElements', 'levelCompleteSign.png');
        _this.goalCompletedSign.anchor.set(0.5);
        _this.view.add(_this.goalCompletedSign);

        _this.topPanel = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 70 * PARAMS.scaleFactor, 'gameElements', 'topPanelPortrait.png');
        _this.topPanel.anchor.set(0.5);
        _this.view.add(_this.topPanel);

        _this.bottomPanel = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 695 * PARAMS.scaleFactor, 'gameElements', 'bottomPanelPortrait.png');
        _this.bottomPanel.anchor.set(0.5);
        _this.view.add(_this.bottomPanel);

        _this.bombPanel = PARAMS.makeSprite(game, -104 * PARAMS.scaleFactor, 70 * PARAMS.scaleFactor, 'gameElements', 'bombActivePanelPortrait.png');
        _this.bombPanel.anchor.set(0.5);
        _this.bombPanel.alpha = 0;
        _this.view.add(_this.bombPanel);

        _this.bombFiller = PARAMS.makeSprite(game, -229.5 * PARAMS.scaleFactor, 49 * PARAMS.scaleFactor, 'gameElements', 'bombChargerPortrait.png');
        _this.bombFiller.alpha = 0;
        _this.view.add(_this.bombFiller);

        _this.widthForFullInficator = _this.bombFiller.width;
        _this.bombFiller.cropRect = new Phaser.Rectangle(0, 0, 0, _this.bombFiller.height);
        _this.bombFiller.updateCrop();

        _this.view.x = 518 / 2 * PARAMS.scaleFactor;
        _this.view.y = 0;

        _this.levelText = _this.addTextElement2(-145, 35, 'blue', 'Level ' + game.level, 20);
        _this.rightText = _this.addTextElement2(-147, 685, 'green', '', 35);
        _this.wrongText = _this.addTextElement2(-147, 685, 'red', '', 35);
        _this.wordPointsText = _this.addTextElement2(-150, 720, 'white', '', 24);
        _this.scoreText = _this.addTextElement2(150, 675, 'white', 'Score:', 24);
        _this.totalPointsText = _this.addTextElement2(150, 710, 'white', '' + game.score, 35);
        _this.timerText = _this.addTextElement2(150, 35, 'blue', 'Time:', 20);
        _this.timeLeftText = _this.addTextElement2(150, 88, 'whiteNumbers', '', 50);
        _this.goals = _this.addTextElement2(-145, 68, 'white', 'Goal', 22);
        _this.currentGoals = _this.addTextElement2(-145, 95, 'white', 'Lines 0/' + game.goal, 30);
        _this.bombCounterText = _this.addTextElement2(-5, 105, 'blue', 'x 8', 22);

        _this.goalCompleteMark = PARAMS.makeSprite(game, -70 * PARAMS.scaleFactor, 60 * PARAMS.scaleFactor, 'flashAnims', 'goalCompleteAnimation/0000');
        _this.goalCompleteMark.anchor.set(0.5);
        _this.goalCompleteMark.alpha = 0;
        _this.view.add(_this.goalCompleteMark);

        _this.goalCompletedText = _this.addTextElement2(0, 10, 'blue', 'Goal completed', 14);
        _this.goalCompletedSign.addChild(_this.goalCompletedText);

        _this.bombInstructionText = _this.addTextElement2(150, 140, 'white', 'Drag Bomb To Use', 14);
        _this.bonusBombText = _this.addTextElement2(-145, 95, 'white', 'Bonus Bomb', 26);
        _this.bonusBombText.alpha = 0;

        var frames = window.Phaser.Animation.generateFrameNames('goalCompleteAnimation/', 0, 34, '', 4);
        _this.goalCompleteMark.animations.add('show', frames, 20, false);
        _this.goalCompleteMark.events.onAnimationComplete.add(function () {
            this.goalCompleteMark.alpha = 0;
        }, _this);

        // Buttons
        _this.buttonExit = _this.addButton(-23, 720, 'exitButton', _this.onButtonExit);
        _this.buttonPause = _this.addButton(23, 720, 'statsButton', _this.onButtonPause);
        _this.buttonMute = _this.addButton(23, 674, 'unmuteButton', _this.onButtonUnmute);
        _this.buttonUnmute = _this.addButton(23, 674, 'muteButton', _this.onButtonMute);
        _this.buttonHelp = _this.addButton(-23, 674, 'helpButton', _this.onButtonHelp);

        _this.currentWordFontSize = 35;
        _this.currentWordMaxLength = 160;
        return _this;
    }

    // ==================== Initialization ====================


    (0, _createClass3.default)(PortraitGameUI, [{
        key: 'init',
        value: function init(game) {
            (0, _get3.default)(PortraitGameUI.prototype.__proto__ || (0, _getPrototypeOf2.default)(PortraitGameUI.prototype), 'init', this).call(this, game);
            this.goalCompletedSign.y = 106 * PARAMS.scaleFactor;
        }
    }]);
    return PortraitGameUI;
}(_BaseGameUI3.default); /**
                          * PortraitGameUI
                          * Handles UI panels for portrait view.
                          */

// ==================== Imports ====================


exports.default = PortraitGameUI;

},{"../gameui/BaseGameUI":404,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],407:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Tile = require('./Tile');

var _Tile2 = _interopRequireDefault(_Tile);

var _SymbolsGenerator = require('./SymbolsGenerator');

var _SymbolsGenerator2 = _interopRequireDefault(_SymbolsGenerator);

var _BoardInputController = require('./BoardInputController');

var _BoardInputController2 = _interopRequireDefault(_BoardInputController);

var _WordVerificator = require('./WordVerificator');

var _WordVerificator2 = _interopRequireDefault(_WordVerificator);

var _ScoreCalculator = require('./ScoreCalculator');

var _ScoreCalculator2 = _interopRequireDefault(_ScoreCalculator);

var _PathCreator = require('./PathCreator');

var _PathCreator2 = _interopRequireDefault(_PathCreator);

var _ExplosionManager = require('./ExplosionManager');

var _ExplosionManager2 = _interopRequireDefault(_ExplosionManager);

var _ClearLineAnimator = require('./ClearLineAnimator');

var _ClearLineAnimator2 = _interopRequireDefault(_ClearLineAnimator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Board
 * Logic for board of tiles.
 */

// ==================== Import ====================
var Board = function () {

    // ==================== Construction ====================
    function Board(game) {
        (0, _classCallCheck3.default)(this, Board);

        window.board = this;

        // Model objects
        this.game = game;
        this.view = game.make.group(); // layers of elements added in proper order, other objects uses those layers passed to them as params

        this.columnsCount = 10;
        this.rowsCount = 10;
        this.tiles = [];

        this.symbolsGenerator = new _SymbolsGenerator2.default();
        this.scoreCalculator = new _ScoreCalculator2.default();
        this.wordVerificator = new _WordVerificator2.default(game.cache.getText('words'));

        // View objects
        this.backPicture = PARAMS.makeSprite(game, -10 * PARAMS.scaleFactor, -8 * PARAMS.scaleFactor, 'boardBackgrounds', 'boardBackground1.png');
        this.view.add(this.backPicture);

        this.bgTilesViews = game.make.group();
        this.view.add(this.bgTilesViews);

        this.tilesViews = game.make.group();
        this.view.add(this.tilesViews);

        this.connectionsView = game.make.group();
        this.view.add(this.connectionsView);

        this.explosionsView = game.make.group();
        this.view.add(this.explosionsView);

        this.linesAnimView = game.make.group();
        this.view.add(this.linesAnimView);

        // Helpers
        this.boardInputController = new _BoardInputController2.default(this);
        this.pathCreator = new _PathCreator2.default(this.game, this.connectionsView, this);
        this.explosionManager = new _ExplosionManager2.default(this.game, this, this.explosionsView);
        this.clearLineAnimator = new _ClearLineAnimator2.default(this.game, this, this.bgTilesViews, this.linesAnimView);
    }

    // ==================== Initialization ====================


    (0, _createClass3.default)(Board, [{
        key: 'init',
        value: function init(level) {
            // Set the background picture
            this.backPicture.frameName = 'boardBackground' + (level % 4 + 1) + '.png';

            // Reset the clear line animator
            this.clearLineAnimator.init();

            // Reset all tiles
            this.tilesViews.removeAll();
            this.tiles = [];

            // Create new tiles for the level
            for (var col = 0; col < this.columnsCount; col++) {
                this.tiles[col] = [];
                for (var row = 0; row < this.rowsCount; row++) {
                    this.generateTile(col, row);
                }
            }
        }

        // ==================== Tiles ====================

    }, {
        key: 'generateTile',
        value: function generateTile(col, row) {
            var symbol = this.symbolsGenerator.getRandomLetter(Math.random());
            var tile = new _Tile2.default(this.game, symbol, col, row);
            this.tiles[col][row] = tile;
            this.tilesViews.add(tile.view);
            return tile;
        }
    }, {
        key: 'getTile',
        value: function getTile(col, row) {
            return this.tiles[col][row];
        }
    }, {
        key: 'placeTile',
        value: function placeTile(tile) {
            this.tiles[tile.col][tile.row] = tile;
        }
    }, {
        key: 'putEmpty',
        value: function putEmpty(col, row) {
            var tile = this.generateTile(col, row);
            tile.explode();
        }

        // ==================== Events ====================

    }, {
        key: 'onPause',
        value: function onPause() {
            this.boardInputController.active = false;
            this.boardInputController.clearSelected();
            this.pathCreator.updatePath(false);
        }
    }, {
        key: 'onResume',
        value: function onResume() {
            this.boardInputController.active = true;
        }

        // ==================== Destruction ====================

    }, {
        key: 'destroy',
        value: function destroy() {
            this.symbolsGenerator.destroy();
            this.scoreCalculator.destroy();
            this.wordVerificator.destroy();
            this.boardInputController.destroy();
            this.pathCreator.destroy();
            this.explosionManager.destroy();
            this.clearLineAnimator.destroy();

            this.backPicture.removeAll();
            this.bgTilesViews.removeAll();
            this.tilesViews.removeAll();
            this.tilesViews.removeAll();
            this.explosionsView.removeAll();
            this.linesAnimView.removeAll();
        }
    }]);
    return Board;
}();

exports.default = Board;

},{"./BoardInputController":408,"./ClearLineAnimator":410,"./ExplosionManager":411,"./PathCreator":412,"./ScoreCalculator":413,"./SymbolsGenerator":414,"./Tile":415,"./WordVerificator":416,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],408:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BoardInputController
 * Handles logic for input on board of tiles, decides when to select or unselect tiles.
 * Decides when word is confirmed by user both by tap/click or by swipe/mouse move.
 */

var BoardInputController = function () {

    // ==================== Construction ====================
    function BoardInputController(board) {
        (0, _classCallCheck3.default)(this, BoardInputController);

        this.board = board;

        // Enable input on back image and add all needed listeners
        this.board.backPicture.inputEnabled = true;
        this.board.backPicture.events.onInputDown.add(this.onDown, this);
        this.board.backPicture.events.onInputUp.add(this.onUp, this);
        this.board.game.input.addMoveCallback(this.onMove, this);

        // Handles all selected tiles
        this.selected = [];

        // useful to avoid situation where mouse is released outside, then go back to tiles
        // and tiles are selected, or start selecting while the whole system is not active
        this.canSelectOnMove = false;

        // used to detect word confirmation at the and of swipe (tap requires additional confirmation
        // by tap on lastly selected tile)
        this.selectedWithMove = 0;

        this.active = true; // quick flag to turn on/off selecting possibility
        this.specialUnselectBlockForMove = false;
        this.lastSwipePosition = null;
        this.selectTilesCounter = 0;
    }

    // ==================== Input Events ====================


    (0, _createClass3.default)(BoardInputController, [{
        key: 'onDown',
        value: function onDown(sprite, pointer) {
            if (!this.active) {
                return;
            }
            this.lastSwipePosition = { x: pointer.x, y: pointer.y };
            this.canSelectOnMove = true;
            var tile = this.getTileUnderPointer(pointer);
            if (tile && tile.canBeSelected()) {
                this.selectTile(tile);
            }
        }
    }, {
        key: 'onUp',
        value: function onUp() {
            // this.specialUnselectBlockForMove = false
            this.canSelectOnMove = false;
            this.lastSwipePosition = null;
            if (this.selectedWithMove) {
                this.onWordConfirmed();
            }
            this.selectedWithMove = 0;
        }
    }, {
        key: 'onMove',
        value: function onMove(pointer) {
            if (!this.canSelectOnMove || !this.active) {
                return;
            }

            this.selectTilesCounter = 0;
            if (this.lastSwipePosition === null) {
                this.lastSwipePosition = { x: pointer.x, y: pointer.y };
                var tile = this.getTileUnderPointer(pointer);
                if (tile && tile.canBeSelected()) {
                    this.selectTileOnMove(tile, pointer);
                }
            } else {
                var dx = pointer.x - this.lastSwipePosition.x;
                var dy = pointer.y - this.lastSwipePosition.y;
                var steps = Math.round(Math.max(Math.abs(dx), Math.abs(dy)));

                if (dx === 0 && dy === 0) {
                    var tile = this.getTileUnderPointer(pointer);
                    if (tile && tile.canBeSelected()) {
                        this.selectTileOnMove(tile, pointer);
                    }
                } else {
                    var stepX = dx / steps;
                    var stepY = dy / steps;
                    while (steps) {
                        var tile = this.getTileUnderPointer(this.lastSwipePosition);
                        if (tile && tile.canBeSelected()) {
                            this.selectTileOnMove(tile, this.lastSwipePosition);
                        }
                        this.lastSwipePosition.x += stepX;
                        this.lastSwipePosition.y += stepY;
                        steps -= 1;
                    }
                }
            }

            // var tile = this.getTileUnderPointer(pointer)
            // if (tile && tile.canBeSelected()) this.selectTileOnMove(tile, pointer)
            if (this.selectTilesCounter > 0) {
                AUDIO.playSound('tilePop');
            }
        }

        // ==================== Word Events ====================

    }, {
        key: 'onWordChanged',
        value: function onWordChanged() {
            AUDIO.playSound('tilePop');
            var word = this.getSelectedWord();
            var valid = this.board.wordVerificator.isWordValid(word);
            var score = this.board.scoreCalculator.getScoreForWord(word);
            this.board.pathCreator.updatePath(valid);
            GS.onWordChanged(word, valid, score);
        }
    }, {
        key: 'onWordChangedFromPowerup',
        value: function onWordChangedFromPowerup(text) {
            var word = this.getSelectedWord();
            var score = this.board.scoreCalculator.getScoreForWordSimple(word);
            GS.onWordChanged('BOMB', true, score);
        }
    }, {
        key: 'onWordChangedOnMove',
        value: function onWordChangedOnMove() {
            // AUDIO.playSound('tilePop');
            this.selectTilesCounter += 1;
            var word = this.getSelectedWord();
            var valid = this.board.wordVerificator.isWordValid(word);
            var score = this.board.scoreCalculator.getScoreForWord(word);
            this.board.pathCreator.updatePath(valid);
            GS.onWordChanged(word, valid, score);
        }
    }, {
        key: 'onWordCleared',
        value: function onWordCleared() {
            this.clearSelected();
            this.board.pathCreator.updatePath(false);
            GS.onWordChanged('', false, -90);
        }
    }, {
        key: 'onWordConfirmed',
        value: function onWordConfirmed() {
            var word = this.getSelectedWord();
            var valid = this.board.wordVerificator.isWordValid(word);
            var score = this.board.scoreCalculator.getScoreForWord(word);

            if (valid) {
                this.board.explosionManager.explodeTiles(this.selected, this.board);
                this.board.pathCreator.hideConnections();

                this.active = false;
                this.selected = [];

                GS.onWordConfirmed(score, word);
                AUDIO.playSound('baddieGrunt');
            }
        }
    }, {
        key: 'onWordConfirmedFromPowerup',
        value: function onWordConfirmedFromPowerup() {
            var word = this.getSelectedWord();
            var score = this.board.scoreCalculator.getScoreForWordSimple(word);

            this.board.explosionManager.explodeTiles(this.selected, this.board);
            this.board.pathCreator.hideConnections();

            this.active = false;
            this.selected = [];

            GS.onWordConfirmed(score, word);
            AUDIO.playSound('bombExplosion');
        }

        // ==================== Selection ====================

    }, {
        key: 'selectTile',
        value: function selectTile(tile) {
            // Helper variable to detect later if word actually changed
            var lengthBefore = this.selected.length;

            // comparison of length isn't enough if we have one selected letter and then select the another one
            // so here we have additional helper
            var firstBuffer = null;
            if (lengthBefore === 1) {
                firstBuffer = this.selected[0];
            }

            if (this.selected.length === 0) {
                this.selected.push(tile);
            } else if (this.selected.length === 1 && tile === this.selected[0]) {
                this.clearSelected();
                this.onWordChanged();
                this.canSelectOnMove = false;
                return;
            } else if (tile.isSelected()) {
                this.clearAfterTile(tile);
            } else {
                var neighbour = this.isNeighbourOfLastTile(tile);
                if (!neighbour) {
                    this.clearSelected();
                } // If they are not neighbours start new selection
                this.selected.push(tile);
            }

            var lengthChanged = this.selected.length !== lengthBefore;
            var anotherOneSelected = lengthBefore === 1 && firstBuffer !== this.selected[0];
            if (lengthChanged || anotherOneSelected) {
                tile.select();
                this.onWordChanged();
            }
            // else if (!anotherOneSelected ) this.clearSelected();
            else {
                    this.onWordConfirmed();
                }
        }
    }, {
        key: 'selectTileOnMove',
        value: function selectTileOnMove(tile, pointer) {
            if (!this.canSelectOnMove) {
                return;
            }
            var lengthBefore = this.selected.length;

            if (this.selected.length === 0) {
                // this should be commented if selecting on swipe after start on empty tile is not wanted
                this.selected.push(tile);
            } else if (tile.isSelected()) {
                // distance limit is needed to make diagonal selects possible
                var distLimit = tile.isWithinDistanceLimit(pointer);
                var isDiagonalTile = this.isDiagonalToLastTile(tile);
                if (!distLimit) {
                    return;
                }
                this.clearAfterTile(tile);
            } else {
                // detect the situation where swipe is super-quick or goes through empty tiles
                var neighbour = this.isNeighbourOfLastTile(tile);
                distLimit = tile.isWithinDistanceLimit(pointer);
                var isDiagonalTile = this.isDiagonalToLastTile(tile);
                if (isDiagonalTile) {
                    distLimit = true;
                }
                if (!neighbour || !distLimit) {
                    return;
                }
                this.selected.push(tile);
            }

            if (this.selected.length !== lengthBefore) {
                tile.select();
                this.onWordChangedOnMove();
                this.selectedWithMove += 1;
            }
        }
    }, {
        key: 'selectAround',
        value: function selectAround(tile) {
            for (var col = tile.col - 1; col <= tile.col + 1; col++) {
                for (var row = tile.row - 1; row <= tile.row + 1; row++) {
                    if (col < 0 || row < 0 || col >= this.board.columnsCount || row >= this.board.rowsCount) {
                        continue;
                    }

                    var newTile = this.board.getTile(col, row);
                    if (newTile === tile || !newTile.alive) {
                        continue;
                    }
                    newTile.select();
                    this.selected.push(newTile);
                }
            }

            tile.select();
            this.selected.push(tile);
        }

        // ==================== Clearing ====================

    }, {
        key: 'clearSelected',
        value: function clearSelected() {
            for (var i = 0; i < this.selected.length; i++) {
                this.selected[i].unselect();
            }
            this.selected = [];
        }
    }, {
        key: 'clearAfterTile',
        value: function clearAfterTile(tile) {
            for (var i = this.selected.length - 1; i >= 0; i--) {
                if (this.selected[i] === tile) {
                    break;
                }
                this.selected[i].unselect();
                this.selected.pop();
            }
        }

        // ==================== Utility ====================

    }, {
        key: 'isNeighbourOfLastTile',
        value: function isNeighbourOfLastTile(tile) {
            var lastTile = this.selected[this.selected.length - 1];
            var rowDiff = Math.abs(tile.row - lastTile.row);
            var colDiff = Math.abs(tile.col - lastTile.col);
            if (rowDiff > 1 || colDiff > 1) {
                return false;
            }
            return true;
        }
    }, {
        key: 'isDiagonalToLastTile',
        value: function isDiagonalToLastTile(tile) {
            var lastTile = this.selected[this.selected.length - 1];
            var rowDiff = Math.abs(tile.row - lastTile.row);
            var colDiff = Math.abs(tile.col - lastTile.col);
            if (rowDiff === 1 && colDiff === 1) {
                return true;
            }
            return false;
        }
    }, {
        key: 'getTileUnderPointer',
        value: function getTileUnderPointer(pointer) {
            var localPos = this.board.backPicture.toLocal(pointer);
            var col = Math.floor((localPos.x - 10 * PARAMS.scaleFactor) / 47 / PARAMS.scaleFactor);
            var row = Math.floor((localPos.y - 9 * PARAMS.scaleFactor) / 47 / PARAMS.scaleFactor);
            if (col < 0 || row < 0 || col >= this.board.columnsCount || row >= this.board.rowsCount) {
                return null;
            }
            return this.board.tiles[col][row];
        }
    }, {
        key: 'getSelectedWord',
        value: function getSelectedWord() {
            var word = '';
            for (var i = 0; i < this.selected.length; i++) {
                word += this.selected[i].symbol;
            }
            return word;
        }

        // ==================== Destruction ====================

    }, {
        key: 'destroyInput',
        value: function destroyInput() {
            this.lastSwipePosition = null;
            this.board.backPicture.events.onInputDown.removeAll();
            this.board.backPicture.events.onInputUp.removeAll();
            this.board.game.input.deleteMoveCallback(this.onMove, this);
        }
    }]);
    return BoardInputController;
}();

exports.default = BoardInputController;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],409:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BombPowerup
 * Handles logic for bomb powerup.
 */

var BombPowerup = function () {
    // ==================== Construction ====================
    function BombPowerup(game, board) {
        (0, _classCallCheck3.default)(this, BombPowerup);

        window.bmb = this;
        this.game = game;
        this.board = board;

        this.view = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'bombDisabled.png');
        this.anims = PARAMS.makeSprite(game, 0, 0, 'flashAnims2', 'bombButtonReadyAnimation/0000');

        var frames = window.Phaser.Animation.generateFrameNames('bombButtonReadyAnimation/', 0, 26, '', 4);
        this.anims.animations.add('activate', frames, 24, false);
        // this.anims.animations.add('disabled', ['BombPowerupDisabled.png'], 14, false)

        this.anims.events.onAnimationComplete.add(function () {
            this.anims.alpha = 0;
            if (GS.availableBombs === 0) {
                this.disable();
                this.view.frameName = 'bombDisabled.png';
            }
        }, this);
        this.view.addChild(this.anims);

        // enable input and add callbacks for events
        this.view.inputEnabled = true;
        this.view.input.disableDrag();

        this.view.events.onDragStart.add(this.dragStart, this);
        this.view.events.onDragUpdate.add(this.dragUpdate, this);
        this.view.events.onDragStop.add(this.dragStop, this);

        this.basePositionX = 40 * PARAMS.scaleFactor;
        this.basePositionY = 286 * PARAMS.scaleFactor;

        this.anims.alpha = 0;
        this.anims.x = -52 * PARAMS.scaleFactor;
        this.anims.y = -50 * PARAMS.scaleFactor;

        this.lastTile = null; // helper to remember which tile was selected for bomb as last one
        this.active = false;
    }

    // ==================== Dragging ====================


    (0, _createClass3.default)(BombPowerup, [{
        key: 'dragStart',
        value: function dragStart() {
            GS.onBombDragged();
        }
    }, {
        key: 'dragUpdate',
        value: function dragUpdate(sprite, pointer) {
            var pos = sprite.game.input.getLocalPosition(sprite.parent, pointer);
            if (sprite.hitArea) {
                sprite.x = pos.x - sprite.hitArea.width / 2;
                sprite.y = pos.y - sprite.hitArea.height / 2;
            } else {
                sprite.x = pos.x - sprite.width / 2;
                sprite.y = pos.y - sprite.height / 2;
            }

            var tile = this.board.boardInputController.getTileUnderPointer(pointer);
            // there is a tile, tile has changed since last selection and is not empty (invisible)
            if (tile && tile !== this.lastTile && tile.canBeSelected()) {
                // find all selected tiles
                this.board.boardInputController.clearSelected();
                this.board.boardInputController.selectAround(tile);
                this.board.boardInputController.onWordChangedFromPowerup();

                // update their view
                this.board.pathCreator.updateSelectedTilesForPowerup();

                this.lastTile = tile;
            } else if (!this.lastTile) {
                // didn't get over tile board yet

            } else if (!tile || tile && !tile.canBeSelected()) {
                // bomb was moved outside tiles or over inactive(invisible) tile
                this.board.boardInputController.clearSelected();
                this.board.boardInputController.onWordChangedFromPowerup();
                this.lastTile = null;
            }
        }
    }, {
        key: 'dragStop',
        value: function dragStop(pointer, sprite) {
            // if there are selected tiles and they were selected actually by bomb!
            if (this.board.boardInputController.selected.length > 0 && this.lastTile) {
                this.board.boardInputController.onWordConfirmedFromPowerup();
                GS.onBombDroppedWithUse();
            } else {
                GS.onBombDroppedWithoutUse();
            }

            this.view.x = this.basePositionX;
            this.view.y = this.basePositionY;
            this.lastTile = null;
        }
    }, {
        key: 'isDragged',
        value: function isDragged() {
            if (this.view.x !== this.basePositionX || this.view.y !== this.basePositionY) {
                return true;
            }
            return false;
        }
    }, {
        key: 'setBasePosition',
        value: function setBasePosition(x, y) {
            this.basePositionX = this.view.x = x;
            this.basePositionY = this.view.y = y;
        }

        // ==================== Animations ====================

    }, {
        key: 'playActivationAnim',
        value: function playActivationAnim() {
            // AUDIO.playSound('bombCharged')
            this.anims.alpha = 1;
            this.anims.animations.play('activate');
        }
    }, {
        key: 'playAnimationWithDisabling',
        value: function playAnimationWithDisabling() {
            // AUDIO.playSound('bombCharged')
            this.view.input.disableDrag();
            this.anims.alpha = 1;
            this.anims.animations.play('activate');
        }

        // ==================== Activation ====================

    }, {
        key: 'activate',
        value: function activate() {
            this.active = true;
            this.view.frameName = 'bomb.png';
            this.view.input.enableDrag();
            this.playActivationAnim();

            this.view.anchor.set(0);
            this.view.x = this.basePositionX;
            this.view.y = this.basePositionY;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.active = false;

            this.view.input.disableDrag();
            this.anims.alpha = 0;
            this.view.frameName = 'bombDisabled.png';
            // this.view.animations.play('disabled')

            this.view.anchor.set(0);
            this.view.x = this.basePositionX;
            this.view.y = this.basePositionY;
        }

        // ==================== Events ====================

    }, {
        key: 'onPause',
        value: function onPause() {
            if (!this.active) {
                return;
            }
            this.view.input.disableDrag();
            this.board.boardInputController.onWordCleared();
            this.lastTile = null;

            if (this.isDragged()) {
                this.dragStop(null, null);
            }
        }
    }, {
        key: 'onResume',
        value: function onResume() {
            if (this.active) {
                this.view.input.enableDrag(true);
            }
        }
    }]);
    return BombPowerup;
}();

exports.default = BombPowerup;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],410:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ClearLineAnimator
 * Handles the explosion of tiles and falling of these above of exploded ones.
 */

var ClearLineAnimator = function () {

    // ==================== Construction ====================
    function ClearLineAnimator(game, board, bgTilesView, animsView) {
        (0, _classCallCheck3.default)(this, ClearLineAnimator);

        this.game = game;
        this.board = board;

        // separate layers because bacgrodund tiles are under tiles, and animations are above tiles
        this.bgTilesView = bgTilesView;
        this.animsView = animsView;

        // we keep them here, not as a part of tile, because these are static, and tiles are falling and moving
        // so it is easier to have them in separate arrays
        this.bgTiles = [];

        // cache helpers for checking simplification
        this.rowCleared = [];
        this.colsCleared = [];
    }

    // ==================== Initialization ====================


    (0, _createClass3.default)(ClearLineAnimator, [{
        key: 'init',
        value: function init() {
            this.animsView.removeAll();
            this.bgTilesView.removeAll();
            this.bgTiles.length = 0;
            this.rowCleared.length = 0;
            this.colsCleared.length = 0;

            var cols = this.board.columnsCount;
            var rows = this.board.rowsCount;
            for (var col = 0; col < cols; col++) {
                this.bgTiles[col] = [];
                for (var row = 0; row < rows; row++) {
                    this.generateBgTile(col, row);
                }
            }
        }

        // ==================== Checking ====================

    }, {
        key: 'checkRows',
        value: function checkRows() {
            for (var row = 0; row < this.board.rowsCount; row++) {
                var emptyRow = true;
                for (var col = 0; col < this.board.columnsCount; col++) {
                    var tile = this.board.getTile(col, row);

                    // at least one tile is still alive, so row can't be empty!
                    if (tile.alive) {
                        emptyRow = false;
                        break;
                    }
                }

                if (emptyRow) {
                    this.clearRow(row);
                }
                // rows on the top can only be cleared, so as soon as there is one not clear, we can be sure
                // there won't be any more clear ones later
                else break;
            }
        }
    }, {
        key: 'checkColumns',
        value: function checkColumns() {
            for (var col = 0; col < this.board.columnsCount; col++) {
                var emptyCol = true;
                for (var row = 0; row < this.board.rowsCount; row++) {
                    var tile = this.board.getTile(col, row);

                    // at least one tile is still alive, so row can't be empty!
                    if (tile.alive) {
                        emptyCol = false;
                        break;
                    }
                }

                if (emptyCol) {
                    this.clearCol(col);
                }
            }
        }

        // ==================== Clearing ====================

    }, {
        key: 'clearRow',
        value: function clearRow(row) {
            if (this.rowCleared[row]) {
                return;
            }
            GS.newLineCleared();
            this.rowCleared[row] = true;

            for (var col = 0; col < this.board.columnsCount; col++) {
                // control this value to control, what delay between tiles animation occures in ms
                var delay = 50 * col;
                this.playTileClearAnim(col, row, delay);
            }
        }
    }, {
        key: 'clearCol',
        value: function clearCol(col) {
            if (this.colsCleared[col]) {
                return;
            }
            GS.newLineCleared();
            this.colsCleared[col] = true;

            for (var row = 0; row < this.board.rowsCount; row++) {
                // control this value to control, what delay between tiles animation occures in ms
                var delay = 50 * row;
                this.playTileClearAnim(col, row, delay);
            }
        }
    }, {
        key: 'playTileClearAnim',
        value: function playTileClearAnim(col, row, delay) {
            // here is a part responsible for animating clearing up the line
            // for tiles which were not cleared yet
            var tile = this.bgTiles[col][row];

            var anim = this.generateBgAnim(col, row, delay);

            // to make it more smooth small alpha animation is added
            anim.alpha = 0;

            this.game.add.tween(anim).to({ alpha: 1 }, 150, window.Phaser.Easing.Linear.None, true, delay * 0.85);

            this.game.tweens.removeFrom(tile);
            this.game.add.tween(tile).to({ alpha: 0 }, 150, window.Phaser.Easing.Linear.None, true, delay + 100);

            this.game.time.events.add(delay + 250, function () {
                tile.alpha = 0;
            }, this);
        }

        // ==================== Generation ====================

    }, {
        key: 'generateBgTile',
        value: function generateBgTile(col, row) {
            // return null
            var tile = PARAMS.makeSprite(this.game, 0, 0, 'gameElements', 'tileBg.png');
            tile.x = col * 47 * PARAMS.scaleFactor;
            tile.y = row * 47 * PARAMS.scaleFactor;

            this.bgTilesView.add(tile);
            this.bgTiles[col][row] = tile;
            return tile;
        }
    }, {
        key: 'generateBgAnim',
        value: function generateBgAnim(col, row, delay) {
            var anim = PARAMS.makeSprite(this.game, 0, 0, 'flashAnims', 'emptyLineTileAnimation/0000');
            var frames = window.Phaser.Animation.generateFrameNames('emptyLineTileAnimation/', 0, 10, '', 4);
            anim.animations.add('explode', frames, 16, false);
            anim.x = (col * 47 - 47 - 13) * PARAMS.scaleFactor;
            anim.y = (row * 47 - 47 - 13) * PARAMS.scaleFactor;
            this.animsView.add(anim);

            anim.events.onAnimationComplete.add(function () {
                this.animsView.removeChild(anim);
                anim.destroy();
                anim = null;
            }, this);

            this.game.time.events.add(delay, function () {
                this.play('explode');
            }, anim);
            return anim;
        }
    }]);
    return ClearLineAnimator;
}();

exports.default = ClearLineAnimator;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],411:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ExplosionManager
 * Handles the explosion of tiles and falling of these above of exploded ones.
 */

var ExplosionManager = function () {

    // ==================== Construction ====================
    function ExplosionManager(game, board, explosionsView) {
        (0, _classCallCheck3.default)(this, ExplosionManager);

        this.game = game;
        this.board = board;
        this.explosionsView = explosionsView;
    }

    // ==================== Explosion ====================


    (0, _createClass3.default)(ExplosionManager, [{
        key: 'explodeTiles',
        value: function explodeTiles(tiles) {
            if (tiles.length < 1) return;
            // position in grid of lastly selected tile
            var lastCol = tiles[tiles.length - 1].col;
            var lastRow = tiles[tiles.length - 1].row;

            // used to determinate how much time will explosions take
            var maxTime = 0;
            var explosionOrder = [];

            for (var i = 0; i < tiles.length; i++) {
                var diffCol = Math.abs(lastCol - tiles[i].col);
                var diffRow = Math.abs(lastRow - tiles[i].row);

                // explosion delay for tile is based on its distance to the lastly selected tile
                var diff = (diffCol + diffRow) / 2 / PARAMS.scaleFactor;

                explosionOrder.push({ tile: tiles[i], diff: diff });
            }
            explosionOrder = this.bubbleSortDiff(explosionOrder);

            var lastDiff = explosionOrder[0].diff;
            var counter = 0;
            for (var i = 0; i < explosionOrder.length; i++) {
                var diff = explosionOrder[i].diff;
                var tile = explosionOrder[i].tile;

                if (diff !== lastDiff) {
                    lastDiff = diff;
                    counter += 1;
                }
                explosionOrder[i].counter = counter;

                var time = explosionOrder[i].counter * 125;
                if (time > maxTime) maxTime = time;
            }
            maxTime = Math.min(maxTime, 500);

            var timeStep = maxTime / explosionOrder.length;
            var counter = 0;
            for (var i = explosionOrder.length - 1; i >= 0; i--) {
                var diff = explosionOrder[i].diff;
                var tile = explosionOrder[i].tile;
                tile.explode();
                this.createExplosion(tile.view.x + (47 / 2 - 6) * PARAMS.scaleFactor, tile.view.y + (47 / 2 - 7) * PARAMS.scaleFactor, timeStep * i);
                counter += 1;
            }

            this.game.time.events.add(maxTime * 0.5, this.startFall, this);
        }
    }, {
        key: 'createExplosion',
        value: function createExplosion(x, y, delay) {
            var explo = PARAMS.makeSprite(this.game, 0, 0, 'flashAnims', 'tileMatchAnimation/0000');

            var frames = window.Phaser.Animation.generateFrameNames('tileMatchAnimation/', 0, 22, '', 4);

            explo.animations.add('explode', frames, 14, false);

            explo.anchor.set(0.5);

            explo.x = x;
            explo.y = y;
            this.explosionsView.add(explo);

            explo.events.onAnimationComplete.add(function () {
                this.explosionsView.removeChild(explo);
                explo.destroy();
                explo = null;
            }, this);

            this.game.time.events.add(delay, function () {
                this.play('explode');
            }, explo);

            return explo;
        }

        // ==================== Falling ====================

    }, {
        key: 'startFall',
        value: function startFall() {
            var maxTime = 0;

            for (var col = 0; col < this.board.columnsCount; col++) {
                var explodedUnderTile = 0;
                var tilesToRemove = [];

                for (var row = this.board.columnsCount - 1; row >= 0; row--) {
                    // goes all rows from the bottom and looks for the ones just destroyed, to know
                    // how much move down those above
                    var tile = this.board.getTile(col, row);

                    if (!tile.alive) {
                        explodedUnderTile += 1;
                        tilesToRemove.push(tile);
                    } else if (explodedUnderTile > 0) {
                        var time = this.moveTileByY(tile, explodedUnderTile);

                        if (time > maxTime) maxTime = time;
                    }
                }

                // now fills the tiles on the top with empty ones
                for (var i = 0; i < tilesToRemove.length; i++) {
                    tile = tilesToRemove[i];

                    this.board.tilesViews.removeChild(tile);

                    this.board.putEmpty(col, i);
                }
            }
            this.onShiftStart();
            this.game.time.events.add(maxTime, this.onFallEnd, this);
        }
    }, {
        key: 'onFallEnd',
        value: function onFallEnd() {}
        // this.onShiftStart()


        // ==================== Shifting ====================

    }, {
        key: 'onShiftStart',
        value: function onShiftStart() {
            var maxTime = 0;

            // counter holds empty cols from the middle to the left occuring before current col is met
            var counter = 0;

            for (var col = 4; col >= 0; col--) {
                if (this.isColumnEmpty(col)) {
                    counter += 1;
                } else if (counter !== 0) {
                    var time = this.moveColumnBy(col, counter);
                    maxTime = Math.max(maxTime, time);
                }
            }

            // now fill all columns which are on the left with empty tiles
            while (counter > 0) {
                this.clearCol(counter - 1);
                counter--;
            }

            // here the situation is opposite
            // counter holds empty cols from the middle to the right occuring before current col is met
            counter = 0;

            for (col = 5; col < 10; col++) {
                if (this.isColumnEmpty(col)) {
                    counter += 1;
                } else if (counter !== 0) {
                    // minus counter because here we move to the left!
                    time = this.moveColumnBy(col, -counter);
                    maxTime = Math.max(maxTime, time);
                }
            }

            // now fill all columns which are on the right with empty tiles
            while (counter > 0) {
                this.clearCol(10 - counter);
                counter--;
            }

            this.game.time.events.add(Math.max(maxTime, 350), this.onShiftEnd, this);
        }
    }, {
        key: 'isColumnEmpty',
        value: function isColumnEmpty(col) {
            for (var row = 0; row < this.board.rowsCount; row++) {
                var tile = this.board.getTile(col, row);
                if (tile.alive) return false;
            }
            return true;
        }
    }, {
        key: 'moveColumnBy',
        value: function moveColumnBy(col, diffX) {
            var maxTime = 0;
            for (var row = 0; row < this.board.rowsCount; row++) {
                var time = this.moveTileByX(this.board.getTile(col, row), diffX);
                maxTime = Math.max(maxTime, time);
            }
            return maxTime;
        }
    }, {
        key: 'onShiftEnd',
        value: function onShiftEnd() {
            this.board.boardInputController.active = true;

            var buffLines = GS.lines;
            this.board.clearLineAnimator.checkRows();
            this.board.clearLineAnimator.checkColumns();

            if (buffLines !== GS.lines) AUDIO.playSound('emptyLine');
        }

        // ==================== Tile Movement ====================

    }, {
        key: 'moveTileByY',
        value: function moveTileByY(tile, diffY) {
            tile.row += diffY;
            this.board.placeTile(tile);
            var targetY = tile.view.y + diffY * 47 * PARAMS.scaleFactor;
            var moveTime = 200 * diffY;
            this.game.add.tween(tile.view).to({ y: targetY }, moveTime).start();
            return moveTime;
        }
    }, {
        key: 'moveTileByX',
        value: function moveTileByX(tile, diffX) {
            tile.col += diffX;
            this.board.placeTile(tile);
            var targetX = tile.view.x + diffX * 47 * PARAMS.scaleFactor;
            var moveTime = Math.abs(200 * diffX);
            this.game.add.tween(tile.view).to({ x: targetX }, moveTime).start();
            return Math.abs(moveTime);
        }

        // ==================== Clearing ====================

    }, {
        key: 'clearCol',
        value: function clearCol(col) {
            for (var row = 0; row < this.board.rowsCount; row++) {
                this.board.putEmpty(col, row);
            }
        }

        // ==================== Sorting ====================

    }, {
        key: 'bubbleSortSwap',
        value: function bubbleSortSwap(items, firstIndex, secondIndex) {
            var temp = items[firstIndex];
            items[firstIndex] = items[secondIndex];
            items[secondIndex] = temp;
        }
    }, {
        key: 'bubbleSortDiff',
        value: function bubbleSortDiff(a) {
            var swapped;
            do {
                swapped = false;
                for (var i = 0; i < a.length - 1; i++) {
                    if (a[i].diff > a[i + 1].diff) {
                        var temp = a[i];
                        a[i] = a[i + 1];
                        a[i + 1] = temp;
                        swapped = true;
                    }
                }
            } while (swapped);
            return a;
        }
    }]);
    return ExplosionManager;
}();

exports.default = ExplosionManager;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],412:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * PathCreator
 * Handles the look of selected tiles and also create connections between them.
 */

var PathCreator = function () {

    // ==================== Construction ====================
    function PathCreator(game, connectionsView, board) {
        (0, _classCallCheck3.default)(this, PathCreator);

        this.board = board;
        this.game = game;
        this.connectionsView = connectionsView;
        this.connections = [];
    }

    // ==================== Update ====================


    (0, _createClass3.default)(PathCreator, [{
        key: 'updatePath',
        value: function updatePath(valid) {
            this.updateSelectedTilesVisual(valid);
            this.updateConnectionsVisual(valid);
        }
    }, {
        key: 'hideConnections',
        value: function hideConnections() {
            this.connectionsView.removeAll();
        }
    }, {
        key: 'updateConnectionsVisual',
        value: function updateConnectionsVisual(valid) {
            var selected = this.board.boardInputController.selected;

            this.connectionsView.removeAll();
            this.connections = [];

            for (var i = 0; i < selected.length - 1; i++) {
                var connectionType = this.getConnectionTypeBetweenTiles(selected[i], selected[i + 1]);
                var connectionName = 'connection' + (valid ? 'Correct' : 'Wrong') + connectionType + '.png';
                var connection = PARAMS.makeSprite(this.game, 0, 0, 'gameElements', connectionName);
                connection.anchor.set(0.5);

                this.placeConnectionBetweenTiles(connection, selected[i], selected[i + 1]);
                this.connections.push(connection);
                this.connectionsView.add(connection);
            }
        }
    }, {
        key: 'updateSelectedTilesVisual',
        value: function updateSelectedTilesVisual(valid) {
            var selected = this.board.boardInputController.selected;
            for (var i = 0; i < selected.length - 1; i++) {
                selected[i].updateView(valid, false);
            }

            if (selected.length > 0) {
                selected[selected.length - 1].updateView(valid, true);
            }
        }
    }, {
        key: 'updateSelectedTilesForPowerup',
        value: function updateSelectedTilesForPowerup() {
            var valid = true;
            var selected = this.board.boardInputController.selected;

            for (var i = 0; i < selected.length - 1; i++) {
                selected[i].updateView(valid, false, true);
            }

            if (selected.length > 0) {
                selected[selected.length - 1].updateView(valid, true, true);
            }

            this.hideConnections();
        }
    }, {
        key: 'getConnectionTypeBetweenTiles',
        value: function getConnectionTypeBetweenTiles(tileFrom, tileTo) {
            var rowDiff = tileTo.row - tileFrom.row;
            var colDiff = tileTo.col - tileFrom.col;

            var row = '';
            var col = '';

            if (rowDiff === 1) row = 'S';else if (rowDiff === -1) row = 'N';

            if (colDiff === 1) col = 'E';else if (colDiff === -1) col = 'W';

            return row + col;
        }
    }, {
        key: 'placeConnectionBetweenTiles',
        value: function placeConnectionBetweenTiles(connection, tileA, tileB) {
            var x = (tileA.view.x + tileB.view.x + 47 * PARAMS.scaleFactor) / 2;
            var y = (tileA.view.y + tileB.view.y + 47 * PARAMS.scaleFactor) / 2;

            connection.x = x;
            connection.y = y;
        }

        // ==================== Destruction ====================

    }, {
        key: 'destroy',
        value: function destroy() {
            this.connectionsView.removeAll();
            this.connections.length = 0;
        }
    }]);
    return PathCreator;
}();

exports.default = PathCreator;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],413:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreCalculator = function () {
  function ScoreCalculator() {
    (0, _classCallCheck3.default)(this, ScoreCalculator);

    this.DEFAULT_SYMBOL_SCORE = 1;
    this.scores = {};
    this.bonuses = {};

    this.initScores();
  }

  (0, _createClass3.default)(ScoreCalculator, [{
    key: 'initScores',
    value: function initScores() {
      this.scores['c'] = 4;
      this.scores['b'] = 7;
      this.scores['d'] = 2;
      this.scores['g'] = 5;
      this.scores['h'] = 2;
      this.scores['l'] = 2;
      this.scores['m'] = 4;
      this.scores['p'] = 4;
      this.scores['r'] = 2;
      this.scores['s'] = 2;
      this.scores['t'] = 4;
      this.scores['u'] = 4;
    }
  }, {
    key: 'getScoreForWordSimple',
    value: function getScoreForWordSimple(word) {
      var score = 0;

      for (var i = 0; i < word.length; i++) {
        var symbol = word.charAt(i);
        score += this.getScoreForSymbol(symbol);
      }

      return score;
    }
  }, {
    key: 'getScoreForSymbol',
    value: function getScoreForSymbol(symbol) {
      if (this.scores[symbol]) return this.scores[symbol];else return this.DEFAULT_SYMBOL_SCORE;
    }
  }, {
    key: 'getScoreForWord',
    value: function getScoreForWord(word) {
      var score = 0;
      var areSymbolsIdentical = true;
      var prevSymbol = null;

      for (var i = 0; i < word.length; i++) {
        var symbol = word.charAt(i);
        score += this.getScoreForSymbol(symbol);

        if (prevSymbol !== null && prevSymbol !== symbol) {
          areSymbolsIdentical = false;
        }
        prevSymbol = symbol;
      }

      if (!areSymbolsIdentical) {
        score *= word.length;
      }

      score *= 2;

      return score;
    }
  }]);
  return ScoreCalculator;
}();

exports.default = ScoreCalculator;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],414:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Symbol generator
 * ==========
 *
 * Generates symbol with appropriate probability.
 */

var SymbolsGenerator = function () {
  function SymbolsGenerator() {
    (0, _classCallCheck3.default)(this, SymbolsGenerator);

    this.sumFrequency = new Array(26);
    this.letterFrequency = [0.08167, 0.01492, 0.0278, 0.04253, 0.12702, 0.02288, 0.02022, 0.06094, 0.06973, 0.00153, 0.00747, 0.04025, 0.02517, 0.06749, 0.07507, 0.01929, 0.00098, 0.05987, 0.06333, 0.09056, 0.02758, 0.01037, 0.02465, 0.0015, 0.01971, 0.00074];
    this.alphabet = 'abcdefghijklmnopqrstuvwxyz';

    var frq = NaN;
    var frq1 = NaN;
    var i = 0;
    frq = 0;
    i = 0;

    while (i < 26) {
      frq = frq + this.letterFrequency[i];
      i++;
    }

    frq1 = frq;
    frq = 0;
    i = 0;

    while (i < 26) {
      frq = frq + this.letterFrequency[i];
      this.sumFrequency[i] = frq / frq1;
      i++;
    }
  }

  (0, _createClass3.default)(SymbolsGenerator, [{
    key: 'getRandomLetter',
    value: function getRandomLetter(freq) {
      var index = 0;

      while (index < 26) {
        if (freq < this.sumFrequency[index]) {
          return this.alphabet.charAt(index);
        }

        index++;
      }

      return 'e';
    }
  }]);
  return SymbolsGenerator;
}();

exports.default = SymbolsGenerator;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],415:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Tile
 * ==========
 *
 * Logic for board of one tile. Actually there is not much logic, mostly stores data for particular tile.
 * Logic is usually in propriate modules.
 */

var Tile = function () {
  function Tile(game, symbol, col, row) {
    (0, _classCallCheck3.default)(this, Tile);

    this.game = game;

    this.col = col;
    this.row = row;

    this.symbol = symbol;

    this.view = game.make.group();

    this.tileBg = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'tileFront.png');
    this.view.add(this.tileBg);
    // this.tileBg.alpha = 0

    this.selectBg = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'tileSelectedCorrect.png');
    this.selectBg.alpha = 0;
    this.view.add(this.selectBg);

    this.selectBg2 = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, -2 * PARAMS.scaleFactor, 'flashAnims', 'lastTileAnimation/0000');
    this.selectBg2.alpha = 0;
    this.view.add(this.selectBg2);

    var frames = window.Phaser.Animation.generateFrameNames('lastTileAnimation/', 0, 20, '', 4);

    this.selectBg2.animations.add('blink', frames, 18, true);

    this.letter = PARAMS.makeSprite(game, 0, 0, 'gameElements', symbol.toUpperCase() + '.png');
    this.view.add(this.letter);

    this.view.x = col * 47 * PARAMS.scaleFactor;
    this.view.y = row * 47 * PARAMS.scaleFactor;

    this.alive = true;
    this.selected = false;
  }

  (0, _createClass3.default)(Tile, [{
    key: 'select',
    value: function select() {
      this.selected = true;
    }
  }, {
    key: 'unselect',
    value: function unselect() {
      this.selected = false;
      this.selectBg.alpha = 0;
      this.selectBg2.alpha = 0;
      this.selectBg2.animations.stop();
    }
  }, {
    key: 'canBeSelected',
    value: function canBeSelected() {
      var xOnPlace = this.view.x === this.col * 47 * PARAMS.scaleFactor;
      var yOnPlace = this.view.y === this.row * 47 * PARAMS.scaleFactor;

      return this.alive && xOnPlace && yOnPlace;
    }
  }, {
    key: 'updateView',
    value: function updateView(isCorrect, isLast, isPowerup) {
      this.selectBg.alpha = 1;

      var textureName = 'tile';
      if (isLast) textureName += 'Last';
      textureName += 'Selected';
      if (isCorrect) textureName += 'Correct';else textureName += 'Wrong';

      if (isPowerup && isLast) textureName = 'bombSelectedLast';
      if (isPowerup && !isLast) textureName = 'bombSelected';

      if (isCorrect && isLast && !isPowerup) {
        this.selectBg.alpha = 0;
        this.selectBg2.alpha = 1;
        this.selectBg2.play('blink');
      } else {
        this.selectBg.frameName = textureName + '.png';
        this.selectBg2.animations.stop();
        this.selectBg.alpha = 1;
        this.selectBg2.alpha = 0;
      }

      this.selectBg.updateTransform();
    }
  }, {
    key: 'isSelected',
    value: function isSelected() {
      return this.selected;
    }
  }, {
    key: 'isWithinDistanceLimit',
    value: function isWithinDistanceLimit(pointer) {
      var localPos = this.view.toLocal(pointer);

      localPos.x -= 47 / 2 * PARAMS.scaleFactor;
      localPos.y -= 47 / 2 * PARAMS.scaleFactor;

      var dist = Phaser.Math.distance(0, 0, localPos.x, localPos.y) < 20 * PARAMS.scaleFactor;
      var line1 = localPos.y < localPos.x + 30 * PARAMS.scaleFactor;
      var line2 = localPos.y < -localPos.x + 30 * PARAMS.scaleFactor;
      var line3 = localPos.y > localPos.x - 30 * PARAMS.scaleFactor;
      var line4 = localPos.y > -localPos.x - 30 * PARAMS.scaleFactor;

      if (line1 && line2 && line3 && line4) return true;

      return false;
    }
  }, {
    key: 'explode',
    value: function explode() {
      this.alive = false;
      this.view.alpha = 0;
      this.view.destroy();
    }
  }]);
  return Tile;
}();

exports.default = Tile;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],416:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WordVerificator = function () {
  function WordVerificator(wordsAsText) {
    (0, _classCallCheck3.default)(this, WordVerificator);

    window.wordVerificatorGlobal = this;
    this._words = {};
    this._wordsLengthIndex = {};
    this._wordsAsVector = [];

    this.maxLength = 0;

    this.init(wordsAsText);

    // console.log("Longest word: " + this.maxLength )
  }

  (0, _createClass3.default)(WordVerificator, [{
    key: 'init',
    value: function init(wordsAsText) {
      var l = 0;
      var w = wordsAsText.split('\r\n');

      for (var i = 0, s = w.length; i < s; i++) {
        var word = w[i];
        this._words[word] = 1;
        this._wordsAsVector.push(word);

        var length = word.length;
        if (length > this.maxLength) this.maxLength = length;
        if (length > l) {
          this._wordsLengthIndex[length] = i;
          l = length;
        }
      }
    }
  }, {
    key: 'wordsSorterByLength',
    value: function wordsSorterByLength(w1, w2) {
      var result = 0;

      if (w1.length < w2.length) {
        result = -1;
      } else if (w1.length > w2.length) {
        result = 1;
      }

      return result;
    }
  }, {
    key: 'isWordValid',
    value: function isWordValid(word) {
      if (word.length < 3) {
        return false;
      }
      //else if (word.length >= 6) return true

      var identical = true;
      var hasWildcards = false;
      var ch = word.charAt(0);

      for (var i = 1; i < word.length; i++) {
        var ch1 = word.charAt(i);

        if (ch1 === '*') {
          hasWildcards = true;
        }

        if (ch1 !== ch && !(ch === '*' || ch1 === '*')) {
          identical = false;
        }
      }

      if (identical) {
        return true;
      }

      if (hasWildcards) {
        return getResultWithWildcards(word);
      }

      return this._words[word] !== undefined;
    }
  }, {
    key: 'getResultWithWildcards',
    value: function getResultWithWildcards(word) {
      var wordLength = word.length;
      var idxFirst = this._wordsLengthIndex[wordLength];
      var idxLast = this._wordsLengthIndex[wordLength + 1] - 1;

      for (var k = idxFirst; k <= idxLast; k++) {
        var w = this._wordsAsVector[k];
        var isResult = true;

        for (var i = 0; i < wordLength; i++) {
          var ch = w.charAt(i);
          var ch1 = word.charAt(i);

          if (ch !== ch1 && ch1 !== '*') {
            isResult = false;
            break;
          }
        }

        if (isResult) {
          return true;
        }
      }

      return false;
    }
  }]);
  return WordVerificator;
}();

exports.default = WordVerificator;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],417:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Params = function () {
    function Params() {
        (0, _classCallCheck3.default)(this, Params);

        this.version = 'v1.0.6';
        this.assetsVersion = 'x1';
        this.scaleFactor = 1;

        this.timesPerLevel = [120, 120, 120, 120, 120, 120, 120, 120, 120, 120, 110, 100, 90, 80, 70, 60];
        this.frameBasedTimer = true;

        if (window.innerWidth > 1200 || window.innerHeight > 1200) {
            this.assetsVersion = 'x2';
            this.scaleFactor = 2;
        }

        this.atlases = {
            'x1': {
                'allInOne': 1,
                'boardBackgrounds': 2
            },
            'x2': {
                'gameElements': 1,
                'flashAnims': 2,
                'flashAnims2': 3,
                'uiScreens': 4,
                'helpScreens': 5,
                'boardBackgrounds': 6
            }
        };

        this.fontsList = {
            'white': {
                'fontName': 'white',
                'sizes': [20, 24, 28, 32, 38, 44]
            },
            'whiteNumbers': {
                'fontName': 'white',
                'sizes': [20, 24, 28, 32, 38, 44, 50, 60, 70]
            },
            'blue': {
                'fontName': 'blue',
                'sizes': [14, 20, 28, 36, 48]
            },
            'green': {
                'fontName': 'green',
                'sizes': [20, 25, 30, 35, 40]
            },
            'red': {
                'fontName': 'red',
                'sizes': [10, 15, 20, 25, 30, 35, 40]
            }
        };
    }

    (0, _createClass3.default)(Params, [{
        key: 'getFonts',
        value: function getFonts(color, size) {
            var availableSizes = this.fontsList[color]['sizes'];
            var minDiff = 99999999;
            var closestSize = -1;

            for (var i = 0; i < availableSizes.length; i++) {
                var diff = Math.abs(size - availableSizes[i]);
                if (diff <= minDiff) {
                    minDiff = diff;
                    closestSize = availableSizes[i];
                }
            }

            return this.fontsList[color]['fontName'] + '_' + closestSize;
        }
    }, {
        key: 'addFontsFromAtlas',
        value: function addFontsFromAtlas(preloader) {
            for (var key in this.fontsList) {
                var sizes = this.fontsList[key]['sizes'];
                var fontName = this.fontsList[key]['fontName'];

                for (var i = 0; i < sizes.length; i++) {
                    var name = fontName + '_' + sizes[i];
                    var xmlData = preloader.cache.getJSON('fontsData')[name + '.fnt'];
                    var xml = preloader.load.parseXml(xmlData);
                    preloader.cache.addXML(name, name, xml);
                    preloader.game.cache.addBitmapFontFromAtlas(name, 'fontsAll', name + '.png', name, 'xml', 0, 0);
                }
            }
        }
    }, {
        key: 'addFontsToAssets',
        value: function addFontsToAssets(assets) {
            return assets;
            var gameAssets = assets['game'];

            for (var key in this.fontsList) {
                var sizes = this.fontsList[key]['sizes'];
                var fontName = this.fontsList[key]['fontName'];

                for (var i = 0; i < sizes.length; i++) {
                    var name = fontName + '_' + sizes[i];
                    gameAssets.push({
                        key: name,
                        type: 'xml',
                        url: 'fontsData/' + name + '.fnt'
                    });
                }
            }

            return assets;
        }
    }, {
        key: 'addAtlasesToAssets',
        value: function addAtlasesToAssets(assets) {
            var gameAssets = assets['game'];
            for (var key in this.atlases[this.assetsVersion]) {
                //console.log('Dodaje ', key)
                gameAssets.push({
                    key: key,
                    type: 'atlasJSONHash',
                    atlasURL: 'images/' + PARAMS.assetsVersion + '/' + key + '.json',
                    textureURL: 'images/' + PARAMS.assetsVersion + '/' + key + '.png'
                });
            }
            return assets;
        }
    }, {
        key: 'makeSprite',
        value: function makeSprite(game, x, y, atlas, frame) {
            var atlases = this.atlases[this.assetsVersion];
            if (!atlases[atlas] && frame && atlas !== 'preloader') atlas = 'allInOne';
            return game.make.image(x, y, atlas, frame);
        }
    }, {
        key: 'addSprite',
        value: function addSprite(game, x, y, atlas, frame) {
            var atlases = this.atlases[this.assetsVersion];
            if (!atlases[atlas] && frame && atlas !== 'preloader') atlas = 'allInOne';
            return game.add.sprite(x, y, atlas, frame);
        }
    }, {
        key: 'addButton',
        value: function addButton(game, x, y, atlas, callback, callbackTarget, normal, over, down) {
            var atlases = this.atlases[this.assetsVersion];
            if (!atlases[atlas] && atlas !== 'preloader') atlas = 'allInOne';
            return game.add.button(x, y, atlas, callback, callbackTarget, normal, over, down);
        }
    }]);
    return Params;
}();

exports.default = Params;

window.PARAMS = new Params();

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],418:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Boot = require('./states/Boot');

Object.defineProperty(exports, 'Boot', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Boot).default;
  }
});

var _Preload = require('./states/Preload');

Object.defineProperty(exports, 'Preload', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Preload).default;
  }
});

var _Game = require('./states/Game');

Object.defineProperty(exports, 'Game', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Game).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./states/Boot":419,"./states/Game":420,"./states/Preload":421}],419:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assets = require('../assets');

var _assets2 = _interopRequireDefault(_assets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Boot = function (_Phaser$State) {
  (0, _inherits3.default)(Boot, _Phaser$State);

  function Boot() {
    (0, _classCallCheck3.default)(this, Boot);
    return (0, _possibleConstructorReturn3.default)(this, (Boot.__proto__ || (0, _getPrototypeOf2.default)(Boot)).apply(this, arguments));
  }

  (0, _createClass3.default)(Boot, [{
    key: 'preload',
    value: function preload() {

      //  Add a tabindex
      this.game.canvas.tabIndex = 1;
      this.game.canvas.style.outline = 'none';

      this.game.clearBeforeRender = false;

      // Point the Phaser Asset Loader to where your game assets live.
      this.load.path = 'assets/';

      // Adjust how many pointers Phaser will check for input events.
      this.input.maxPointers = 1;

      // Set the alignment of the game canvas within the page.
      this.scale.pageAlignHorizontally = true;

      this.scale.scaleMode = Phaser.ScaleManager.RESIZE;

      // If the game canvas loses focus, keep the game loop running.
      this.stage.disableVisibilityChange = true;

      // Load the graphical assets required to show the splash screen later,
      // using the asset pack data.
      this.load.pack('boot', null, _assets2.default);
    }
  }, {
    key: 'create',
    value: function create() {
      // After applying the first adjustments and loading the splash screen
      // assets, move to the next game state.
      this.state.start('Preload');
    }
  }]);
  return Boot;
}(Phaser.State); /*
                  * Boot state
                  * ==========
                  *
                  * The first state of the game, responsible for setting up some Phaser
                  * features. Adjust the game appearance, number of input pointers, screen
                  * orientation handling etc. using this game state.
                  */

exports.default = Boot;

},{"../assets":402,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],420:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Board = require('../objects/Board');

var _Board2 = _interopRequireDefault(_Board);

var _BombPowerup = require('../objects/BombPowerup');

var _BombPowerup2 = _interopRequireDefault(_BombPowerup);

var _LandscapeGameUI = require('../gameui/LandscapeGameUI');

var _LandscapeGameUI2 = _interopRequireDefault(_LandscapeGameUI);

var _PortraitGameUI = require('../gameui/PortraitGameUI');

var _PortraitGameUI2 = _interopRequireDefault(_PortraitGameUI);

var _OverlayScreens = require('../ui/OverlayScreens');

var _OverlayScreens2 = _interopRequireDefault(_OverlayScreens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Game = function (_Phaser$State) {
    (0, _inherits3.default)(Game, _Phaser$State);

    function Game() {
        (0, _classCallCheck3.default)(this, Game);
        return (0, _possibleConstructorReturn3.default)(this, (Game.__proto__ || (0, _getPrototypeOf2.default)(Game)).apply(this, arguments));
    }

    (0, _createClass3.default)(Game, [{
        key: 'create',


        // ==================== Construction ====================
        value: function create() {
            var stats = new Stats();
            stats.setMode(0); // 0: fps, 1: ms
            stats.domElement.style.position = 'absolute';
            stats.domElement.style.left = '0px';
            stats.domElement.style.top = '0px';

            // uncomment this to see FPS display
            // document.body.appendChild(stats.domElement)
            this.stats = stats;
            window.GS = this;

            // Create background
            this.bg = PARAMS.addSprite(this, 0, 0, 'preloader', 'preloadBg.png');
            this.bg.anchor.set(0.5);

            // Create view container
            this.view = this.add.group();
            this.gameView = this.add.group();
            this.gameView.add(this.bg);
            this.gameView.add(this.view);

            // Create blur filter
            this.blurX = this.add.filter('BlurX');
            this.blurY = this.add.filter('BlurY');
            this.blurX.blur = 75;
            this.blurY.blur = 75;
            this.gameView.filters = [this.blurX, this.blurY];

            // Create obejcts in the game
            this.board = new _Board2.default(this.game, this);
            this.bomb = new _BombPowerup2.default(this.game, this.board);
            this.landscapeUI = new _LandscapeGameUI2.default(this);
            this.portraitUI = new _PortraitGameUI2.default(this);
            this.overlayScreens = new _OverlayScreens2.default(this);

            // Add objects to the view
            this.view.add(this.board.view);
            this.view.add(this.landscapeUI.view);
            this.view.add(this.portraitUI.view);
            this.view.add(this.bomb.view);

            // Initialize variables
            this.focused = true;
            this.fakePaused = false; // indicates if game is paused by lost of focus
            this.pausedByArkadium = false;

            // On desktop, set focus and blur callbacks
            if (GS.game.device.desktop) {
                this.game.onFocus.add(this.onFocus);
                this.game.onBlur.add(this.onBlur);
                this.game.canvas.addEventListener('focus', this.onFocus, true);
                this.game.canvas.addEventListener('blur', this.onBlur, true);
                this.game.canvas.addEventListener('click', function () {
                    this.game.canvas.focus();
                }.bind(this), true);
            }
            // On mobile, only enable muting/unmuting on focus events
            else {
                    this.game.onFocus.add(this.unsetMute);
                    this.game.onBlur.add(this.setMute);
                    this.game.canvas.addEventListener('focus', this.unsetMute, true);
                    this.game.canvas.addEventListener('blur', this.setMute, true);

                    if ("hidden" in document) {
                        document.addEventListener("visibilitychange", this.onVisibilityChanged);
                    } else if ("mozHidden" in document) {
                        document.addEventListener("mozvisibilitychange", this.onVisibilityChanged);
                    } else if ("webkitHidden" in document) {
                        document.addEventListener("webkitvisibilitychange", this.onVisibilityChanged);
                    } else if ("msHidden" in document) {
                        document.addEventListener("msvisibilitychange", this.onVisibilityChanged);
                    } else if ("onfocusin" in document) {
                        // IE9 and lower
                        document.onfocusin = document.onfocusout = this.onVisibilityChanged;
                    } else {
                        // All others
                        window.onpageshow = window.onpagehide = window.onfocus = window.onblur = this.onVisibilityChanged;
                    }
                }

            // Register Arkadium Arena events
            ARK_game_arena_connector.registerAction('pause', this.pauseGame.bind(this));
            ARK_game_arena_connector.registerAction('resume', this.resumeGame.bind(this));

            // Start the first level
            this.setupLevel(1);
        }

        // ==================== Focusing ====================
        // Focus

    }, {
        key: 'onFocus',
        value: function onFocus() {
            if (GS.focused) {
                return;
            }
            GS.focused = true;
            GS.game.sound.unsetMute();

            if (GS.fakePaused) {
                ARK_game_arena_connector.fireEventToArena('event_change');
                GS.overlayScreens.hideScreen();
                GS.fakePaused = false;
            }
        }
    }, {
        key: 'onBlur',


        // Blur
        value: function onBlur() {
            if (!GS.focused) {
                return;
            }
            GS.focused = false;
            GS.game.sound.setMute();

            if (!GS.paused) {
                ARK_game_arena_connector.fireEventToArena('event_change');
                GS.pause();
                GS.overlayScreens.showScreen('fakePause');
                GS.fakePaused = true;
            }
        }
    }, {
        key: 'onVisibilityChanged',


        // Visibility changes to track focus changes on mobile
        value: function onVisibilityChanged(event) {
            // Check if document supports visibility state
            if (document.visibilityState) {
                if (document.visibilityState === "visible") {
                    GS.unsetMute();
                } else if (document.visibilityState === "hidden") {
                    GS.setMute();
                }
            }
            // Otherwise, check the event type for visibility state
            else {
                    var v = "visible",
                        h = "hidden",
                        eventMap = { focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h };
                    event = event || window.event;
                    if (event.type in eventMap) {
                        if (eventMap[event.type] === v) {
                            GS.unsetMute();
                        } else {
                            GS.setMute();
                        }
                    }
                }
        }

        // ==================== Levels ====================

    }, {
        key: 'setupLevel',
        value: function setupLevel(level) {
            STATS.updateHighestLevel(level);

            // Clean up any objects from previous levels
            this.game.tweens.removeAll();
            // this.view.removeAll(true);

            // Get the time left
            var times = PARAMS.timesPerLevel;
            if (level > times.length) {
                this.timeLeft = 60 * 1000;
            } else {
                this.timeLeft = times[level - 1] * 1000;
            }
            this.timeOriginal = this.timeLeft;
            this.timeActive = false;
            this.timeLast = this.timeLeft;
            this.time.events.add(1000, function () {
                this.timeActive = true;
            }, this);

            // Reset the variables
            this.bestWordScoreLevel = 0;
            this.bestWordLevel = '';
            this.goalReached = false;
            this.goal = Math.min(15, level);
            this.level = level;
            this.levelScore = 0;
            this.lines = 0;

            // If this is the first level, then set all variables to the starting values
            if (level === 1) {
                this.score = 0;
                this.bestWordScore = 0;
                this.bestWord = '';
                this.availableBombs = 0;
                this.bombCharger = 0;
            }

            // Initialize all objects
            this.board.init(level);
            this.landscapeUI.init(this);
            this.portraitUI.init(this);

            // Reset the bombs
            if (this.availableBombs > 0) {
                this.bomb.activate();
            }
            this.landscapeUI.updateFiller(this.bombCharger / 500);

            // Initialize state
            this.pause();
            this.resize(window.innerWidth, window.innerHeight);
            this.updateAllMuteButtons();
        }
    }, {
        key: 'setupNextLevel',
        value: function setupNextLevel() {
            GS.setupLevel(GS.level + 1);
        }
    }, {
        key: 'isFresh',
        value: function isFresh() {
            return this.timeOriginal === this.timeLeft;
        }

        // ==================== Game Flow ====================

    }, {
        key: 'startGame',
        value: function startGame() {
            this.resume();
        }
    }, {
        key: 'pauseGame',
        value: function pauseGame() {
            this.pausedByArkadium = true;
            AUDIO.updateVolume();
            this.portraitUI.clearCurrentScore();
            this.landscapeUI.clearCurrentScore();

            this.board.onPause();
            this.bomb.onPause();

            this.landscapeUI.onPause();
            this.portraitUI.onPause();
        }
    }, {
        key: 'resumeGame',
        value: function resumeGame() {
            this.pausedByArkadium = false;
            AUDIO.updateVolume();
            if (!this.paused) this.resume();
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this.isFresh) ARK_game_arena_connector.fireEventToArena('event_change');

            this.portraitUI.clearCurrentScore();
            this.landscapeUI.clearCurrentScore();

            this.paused = true;
            this.board.onPause();
            this.bomb.onPause();

            this.landscapeUI.onPause();
            this.portraitUI.onPause();
        }
    }, {
        key: 'resume',
        value: function resume() {
            this.paused = false;
            this.board.onResume();
            this.bomb.onResume();

            this.landscapeUI.onResume();
            this.portraitUI.onResume();
        }

        // ==================== Update ====================

    }, {
        key: 'update',
        value: function update() {
            var blur = Phaser.Math.mapLinear(this.overlayScreens.view.alpha, 0, 1, 0, 75);
            this.blurX.blur = blur;
            this.blurY.blur = blur;
            if (this.pausedByArkadium) return;

            var dt = this.game.time.elapsed;
            if (PARAMS.frameBasedTimer) {
                dt = Math.max(1000 / 60, this.game.time.elapsed * 0.3);
            }

            this.stats.begin();

            if (this.timeActive && !this.paused && this.focused) {
                this.timeLeft -= dt;

                if (this.timeLeft < 0) {
                    this.timeActive = false;
                    this.timeLeft = 0;
                    this.onTimeOver();
                }
            }

            var leftInSeconds = Math.round(this.timeLeft / 1000);
            if (leftInSeconds !== this.timeLast && leftInSeconds === 30) AUDIO.playSound('time_30sec');else if (leftInSeconds !== this.timeLast && leftInSeconds <= 15) AUDIO.playSound('time_15sec');

            this.timeLast = leftInSeconds;

            this.landscapeUI.updateTimer(this.timeLeft);
            this.portraitUI.updateTimer(this.timeLeft);
            // this.topPanel.setTimer(Math.round(this.timeLeft / 1000))
        }
    }, {
        key: 'render',
        value: function render() {
            this.stats.end();
            // //console.log("render!")
        }

        // ==================== Resizing ====================

    }, {
        key: 'resize',
        value: function resize(w, h) {
            var scalePortrait = Math.min(w / 518, h / 778);
            var scaleLandscape = Math.min(w / 640, h / 480);

            if (scaleLandscape > scalePortrait) {
                // landscape
                this.view.pivot.set(320 * PARAMS.scaleFactor, 240 * PARAMS.scaleFactor);
                this.landscapeUI.show();
                this.portraitUI.hide();

                this.board.view.x = (640 - 477) * PARAMS.scaleFactor;
                this.board.view.y = 4 * PARAMS.scaleFactor;

                this.view.x = this.bg.x = w / 2;
                this.view.y = this.bg.y = h / 2;

                var scale = Math.min(w / 640 / PARAMS.scaleFactor, h / 480 / PARAMS.scaleFactor);
                this.view.scale.set(scale);

                var bgScale = Math.max(w / 640 / PARAMS.scaleFactor, h / 480 / PARAMS.scaleFactor);
                this.bg.scale.set(bgScale * PARAMS.scaleFactor);

                this.bomb.setBasePosition(39 * PARAMS.scaleFactor, 286 * PARAMS.scaleFactor);
                this.bomb.view.scale.set(0.88);

                this.overlayScreens.setOrientation('landscape');
            } else {
                // portrait
                this.view.pivot.set(518 / 2 * PARAMS.scaleFactor, 778 / 2 * PARAMS.scaleFactor);
                this.landscapeUI.hide();
                this.portraitUI.show();

                this.board.view.x = 24 * PARAMS.scaleFactor;
                this.board.view.y = 154 * PARAMS.scaleFactor;

                this.view.x = this.bg.x = w / 2;
                this.view.y = this.bg.y = h / 2;

                var scale = Math.min(w / 518 / PARAMS.scaleFactor, h / 778 / PARAMS.scaleFactor);
                this.view.scale.set(scale);

                var bgScale = Math.max(w / 640 / PARAMS.scaleFactor, h / 480 / PARAMS.scaleFactor);
                this.bg.scale.set(bgScale * PARAMS.scaleFactor);

                this.bomb.setBasePosition(223 * PARAMS.scaleFactor, 27 * PARAMS.scaleFactor);
                this.bomb.view.scale.set(1);

                this.overlayScreens.setOrientation('portrait');
            }

            this.overlayScreens.view.x = this.view.x;
            this.overlayScreens.view.y = this.view.y;
            if (!GS.game.device.webGL || GS.game.renderType === 1) {
                this.overlayScreens.blurredBg.scale.set(w / 640 * PARAMS.scaleFactor / this.view.scale.x, h / 480 * PARAMS.scaleFactor / this.view.scale.x);
            }
            this.overlayScreens.view.scale.set(this.view.scale.x);

            this.landscapeUI.updateTexts();
            this.portraitUI.updateTexts();
        }

        // ==================== Events ====================

    }, {
        key: 'onGoalReached',
        value: function onGoalReached() {
            if (this.goalReached) {
                return;
            }
            this.goalReached = true;
            this.landscapeUI.goalReached();
            this.portraitUI.goalReached();
        }
    }, {
        key: 'onTimeOver',
        value: function onTimeOver() {
            this.board.boardInputController.active = false;
            this.pause();
            this.time.events.add(1200, function () {
                this.overlayScreens.showScreen('gameSummary');
            }, this);
        }
    }, {
        key: 'newLineCleared',
        value: function newLineCleared() {
            STATS.onLineCleared();

            this.lines += 1;
            if (this.lines >= this.goal) {
                this.onGoalReached();
            }

            this.landscapeUI.updateGoals(this.lines, this.goal);
            this.portraitUI.updateGoals(this.lines, this.goal);
            // this.bottomPanel.setGoals(this.lines, this.goal);

            if (this.lines === 20) {
                this.pause();
                this.time.events.add(1400, function () {
                    // this.setupLevel(this.level + 1);
                    this.overlayScreens.showScreen('doubleScore');
                    AUDIO.playSound('success');
                }, this);
            }
        }
    }, {
        key: 'onWordChanged',
        value: function onWordChanged(word, valid, points) {
            this.landscapeUI.updateSelectedWord(word, valid, points);
            this.portraitUI.updateSelectedWord(word, valid, points);
        }
    }, {
        key: 'onWordConfirmed',
        value: function onWordConfirmed(score, word) {
            ARK_game_arena_connector.fireEventToArena('event_change');

            this.score += score;
            this.levelScore += score;

            if (score > this.bestWordScore) {
                this.bestWordScore = score;
                this.bestWord = word;
            }

            if (score > this.bestWordScoreLevel) {
                this.bestWordScoreLevel = score;
                this.bestWordLevel = word;
            }

            STATS.updateBestWord(word, score);
            STATS.updateHighestScore(this.score);

            this.landscapeUI.updateTotalScore(this.score);
            this.landscapeUI.clearCurrentScore();

            this.portraitUI.updateTotalScore(this.score);
            this.portraitUI.clearCurrentScore();

            if (this.goalReached) {
                this.bombCharger += score;
                var counter = 0;

                while (this.bombCharger > 500) {
                    this.bombCharger -= 500;
                    this.availableBombs += 1;
                    this.landscapeUI.updateBombCounter(this.availableBombs);
                    this.portraitUI.updateBombCounter(this.availableBombs);
                    counter += 1;
                }

                if (counter >= 1 && this.availableBombs === counter) {
                    this.bomb.activate();
                    AUDIO.playSound('bombCharged');
                } else if (counter > 0) {
                    this.bomb.playActivationAnim();
                    AUDIO.playSound('bombCharged');
                }
                this.landscapeUI.updateFiller(this.bombCharger / 500);
                this.portraitUI.updateFiller(this.bombCharger / 500);
            }
        }
    }, {
        key: 'onBombDroppedWithUse',
        value: function onBombDroppedWithUse() {
            ARK_game_arena_connector.fireEventToArena('event_change');

            this.availableBombs -= 1;
            this.landscapeUI.updateBombCounter(this.availableBombs);
            this.portraitUI.updateBombCounter(this.availableBombs);

            this.portraitUI.updateTotalScore(this.score);
            this.portraitUI.clearCurrentScore();

            this.landscapeUI.updateTotalScore(this.score);
            this.landscapeUI.clearCurrentScore();

            if (this.availableBombs === 0) {
                // //console.log()
                this.bomb.playAnimationWithDisabling();
            } else {
                this.bomb.playActivationAnim();
            }
        }
    }, {
        key: 'onBombDroppedWithoutUse',
        value: function onBombDroppedWithoutUse() {
            if (!this.isFresh()) AUDIO.playSound('bombCharged');
            this.landscapeUI.updateBombCounter(this.availableBombs);
            this.portraitUI.updateBombCounter(this.availableBombs);
            this.bomb.playActivationAnim();

            this.portraitUI.clearCurrentScore();
            this.landscapeUI.clearCurrentScore();
        }
    }, {
        key: 'onBombDragged',
        value: function onBombDragged() {
            this.landscapeUI.updateBombCounter(0);
        }

        // ==================== Audio ====================

    }, {
        key: 'mute',
        value: function mute() {
            AUDIO.allMuted = true;
            AUDIO.muteAll();
            this.updateAllMuteButtons();
        }
    }, {
        key: 'unmute',
        value: function unmute() {
            AUDIO.allMuted = false;
            AUDIO.unmuteAll();
            this.updateAllMuteButtons();
        }
    }, {
        key: 'setMute',
        value: function setMute() {
            console.log("setMute");
            GS.game.sound.setMute();
        }
    }, {
        key: 'unsetMute',
        value: function unsetMute() {
            console.log("unsetMute");
            GS.game.sound.unsetMute();
        }
    }, {
        key: 'updateAllMuteButtons',
        value: function updateAllMuteButtons() {
            this.portraitUI.updateMuteButtons();
            this.landscapeUI.updateMuteButtons();
            this.overlayScreens.gameStart.updateMuteButtons();
        }

        // ==================== Destruction ====================

    }, {
        key: 'dispose',
        value: function dispose() {
            (0, _get3.default)(Game.prototype.__proto__ || (0, _getPrototypeOf2.default)(Game.prototype), 'dispose', this).call(this);

            // Remove all focus/blur events
            this.game.onFocus.remove(this.onFocus);
            this.game.onBlur.remove(this.onBlur);
            this.game.canvas.removeEventListener('focus', this.onFocus);
            this.game.canvas.removeEventListener('blur', this.onBlur);

            this.game.onFocus.remove(this.unsetMute);
            this.game.onBlur.remove(this.setMute);
            this.game.canvas.removeEventListener('focus', this.unsetMute);
            this.game.canvas.removeEventListener('blur', this.setMute);

            document.removeEventListener("visibilitychange", this.onVisibilityChanged);
            document.removeEventListener("mozvisibilitychange", this.onVisibilityChanged);
            document.removeEventListener("webkitvisibilitychange", this.onVisibilityChanged);
            document.removeEventListener("msvisibilitychange", this.onVisibilityChanged);
        }
    }]);
    return Game;
}(Phaser.State); /**
                  * Game state
                  */
// ==================== Import ====================


exports.default = Game;

},{"../gameui/LandscapeGameUI":405,"../gameui/PortraitGameUI":406,"../objects/Board":407,"../objects/BombPowerup":409,"../ui/OverlayScreens":435,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],421:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assets = require('../assets');

var _assets2 = _interopRequireDefault(_assets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preload = function (_Phaser$State) {
    (0, _inherits3.default)(Preload, _Phaser$State);

    function Preload() {
        (0, _classCallCheck3.default)(this, Preload);
        return (0, _possibleConstructorReturn3.default)(this, (Preload.__proto__ || (0, _getPrototypeOf2.default)(Preload)).apply(this, arguments));
    }

    (0, _createClass3.default)(Preload, [{
        key: 'preload',
        value: function preload() {
            window.PL = this;
            ARK_game_arena_connector.init();

            setInterval(function () {
                ARK_game_arena_connector.fireEventToArena('event_change');
            }, 1000 * 60 * 4);

            _gameGATracker('create', 'UA-68188765-15', 'auto');
            _gameGATracker('send', 'pageview', { 'page': '/LoadingScene' });

            this.bg = this.add.sprite(0, 0, 'preloader', 'preloadBg.png');
            this.bg.anchor.set(0.5);

            this.preloadLogo = this.make.sprite(320 * PARAMS.scaleFactor, 200 * PARAMS.scaleFactor, 'preloader', 'preloadLogo.png');
            this.preloadLogo.anchor.set(0.5);
            this.preloadBg = this.make.sprite(126, 317, 'preloader', 'preloadBarBg.png');
            this.preload = this.make.sprite(126 * PARAMS.scaleFactor, 317 * PARAMS.scaleFactor, 'preloader', 'preloadBar.png');

            this.preloadBg.x = this.preload.x - 10 * PARAMS.scaleFactor;
            this.preloadBg.y = this.preload.y - 8 * PARAMS.scaleFactor;

            this.view = this.add.group();
            this.view.pivot.set(320 * PARAMS.scaleFactor, 240 * PARAMS.scaleFactor);

            var style = { font: '20px Arial', fill: '#000', boundsAlignH: 'center', boundsAlignV: 'middle' };
            this.versionText = this.add.text(4, 4, PARAMS.scaleFactor + ' ' + PARAMS.version, style);

            this.view.add(this.preloadLogo);
            this.view.add(this.preloadBg);
            this.view.add(this.preload);

            this.resize(window.innerWidth, window.innerHeight);

            this.load.setPreloadSprite(this.preload);
            var newAssets = PARAMS.addAtlasesToAssets(_assets2.default);
            var newAssets2 = PARAMS.addFontsToAssets(newAssets);
            this.load.pack('game', null, newAssets2);
        }
    }, {
        key: 'create',
        value: function create() {
            AUDIO.init(this.game);
            PARAMS.addFontsFromAtlas(this);

            this.time.events.add(100, function () {
                this.state.start('Game');
            }, this);
        }

        // --------------------------------------------------------------------------

    }, {
        key: 'resize',
        value: function resize(w, h) {
            this.view.x = w / 2;
            this.view.y = h / 2;

            this.bg.x = w / 2;
            this.bg.y = h / 2;

            var scale = Math.min(w / 640, h / 480) / PARAMS.scaleFactor;
            this.view.scale.set(scale * 1.1);

            var bgScale = Math.max(w / 640, h / 480) / PARAMS.scaleFactor;
            this.bg.scale.set(bgScale);
        }
    }]);
    return Preload;
}(Phaser.State); /*
                  * Preload state
                  * =============
                  */

exports.default = Preload;

},{"../assets":402,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],422:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stats = function () {
    function Stats() {
        (0, _classCallCheck3.default)(this, Stats);

        this.localStorage = window.localStorageSupported ? window.localStorage : {};

        this.highestScore = Number(this.localStorage.wordWipeHighestScore);
        this.updateHighestScore(0);

        this.highestLevel = Number(this.localStorage.wordWipeHighestLevel);
        this.updateHighestLevel(1);

        this.bestWord = this.localStorage.wordWipeBestWord;
        this.bestWordScore = Number(this.localStorage.wordWipeBestWordScore);
        this.updateBestWord('', 0);

        this.linesCleared = Number(this.localStorage.wordWipeLinesCleared);

        if (!this.linesCleared) {
            this.linesCleared = 0;
        }
    }

    (0, _createClass3.default)(Stats, [{
        key: 'updateHighestScore',
        value: function updateHighestScore(newScore) {
            if (this.highestScore < newScore || !this.highestScore) {
                this.highestScore = newScore;
                this.localStorage.wordWipeHighestScore = newScore;
            }
        }
    }, {
        key: 'updateHighestLevel',
        value: function updateHighestLevel(newLevel) {
            if (this.highestScore < newLevel || !this.highestLevel) {
                this.highestLevel = newLevel;
                this.localStorage.wordWipeHighestLevel = newLevel;
            }
        }
    }, {
        key: 'updateBestWord',
        value: function updateBestWord(word, score) {
            if (this.bestWordScore < score || !this.bestWordScore) {
                this.bestWordScore = score;
                this.bestWord = word;
                this.localStorage.wordWipeBestWord = word;
                this.localStorage.wordWipeBestWordScore = score;

                _gameGATracker('send', 'event', 'Best Word', word, score);
            }
        }
    }, {
        key: 'onLineCleared',
        value: function onLineCleared() {
            this.linesCleared += 1;
            this.localStorage.wordWipeLinesCleared = this.linesCleared;
        }
    }]);
    return Stats;
}();

exports.default = Stats;


window.STATS = new Stats();

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],423:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoubleScoreScreen = function (_ScreenBase) {
  (0, _inherits3.default)(DoubleScoreScreen, _ScreenBase);

  function DoubleScoreScreen(game, screens) {
    (0, _classCallCheck3.default)(this, DoubleScoreScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DoubleScoreScreen.__proto__ || (0, _getPrototypeOf2.default)(DoubleScoreScreen)).call(this, game, 'doubleScore'));

    _this.screens = screens;

    _this.params = {
      'bg': [-3, 0],
      'title': [-2, -74],
      'subtitle': [-3, -40],
      'levelScore': [-1, 19],
      'x2Sign': [121, 40],
      'continue': [-2, 74]
    };

    _this.bg = _this.addSprite('bg', 'uiScreens', 'uiDoubleScorePanel.png');

    _this.title = _this.addText2('title', 'blue', 'Congratulations', 28);
    _this.subtitle = _this.addText2('subtitle', 'blue', 'Your level score doubled', 18);

    _this.levelScore = _this.addText2('levelScore', 'white', '13,136', 34);

    _this.x2Sign = _this.addSprite('x2Sign', 'uiScreens', 'x2Sign.png');

    _this.continue = _this.addTextButton2('continue', 'uiButtonContinue', 'Continue', _this.continueClicked);

    _this.setInputForAllButtons(false);
    return _this;
  }

  (0, _createClass3.default)(DoubleScoreScreen, [{
    key: 'continueClicked',
    value: function continueClicked(that) {
      // console.log('Continue')

      that.forceOutForAllButtons();
      that.screens.showScreen('gameSummary');
    }
  }, {
    key: 'updateScore',
    value: function updateScore() {
      this.levelScore.setText(this.doubledPoints + '');
    }
  }, {
    key: 'onShowStarted',
    value: function onShowStarted() {
      this.doubledPoints = GS.levelScore;
      this.updateScore();
      (0, _get3.default)(DoubleScoreScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(DoubleScoreScreen.prototype), 'onShowStarted', this).call(this);

      GS.score += GS.levelScore;
      GS.levelScore += GS.levelScore;

      this.x2Sign.alpha = 0;
      this.x2Sign.scale.set(1.5);
    }
  }, {
    key: 'onShowEnded',
    value: function onShowEnded() {
      (0, _get3.default)(DoubleScoreScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(DoubleScoreScreen.prototype), 'onShowEnded', this).call(this);

      this.game.add.tween(this.x2Sign).to({ alpha: 1 }, 500).start();

      this.game.add.tween(this.x2Sign.scale).to({ x: 1, y: 1 }, 500).start();

      var doubledPointsBuff = this.doubledPoints;

      var tween = this.game.add.tween(this).to({ doubledPoints: 2 * this.doubledPoints }, 1000).delay(500).start();

      tween.onUpdateCallback(function () {
        this.levelScore.setText(Math.round(this.doubledPoints) + '');
      }, this);

      this.game.time.events.add(1500, function () {
        this.doubledPoints = 2 * doubledPointsBuff;
        tween.stop();
        this.levelScore.setText(Math.round(this.doubledPoints) + '');
      }, this);
    }
  }]);
  return DoubleScoreScreen;
}(_ScreenBase3.default); /*
                          * DoubleScoreScreen
                          * ==========
                          */

exports.default = DoubleScoreScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],424:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _StatsScreen2 = require('../ui/StatsScreen');

var _StatsScreen3 = _interopRequireDefault(_StatsScreen2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExitGameScreen = function (_StatsScreen) {
    (0, _inherits3.default)(ExitGameScreen, _StatsScreen);

    function ExitGameScreen(game, screens) {
        (0, _classCallCheck3.default)(this, ExitGameScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ExitGameScreen.__proto__ || (0, _getPrototypeOf2.default)(ExitGameScreen)).call(this, game, 'exitGame'));

        _this.screens = screens;
        _this.params = {
            'title': [0, -50],
            'subtitle': [1, -4],
            'yes': [-51, 57],
            'no': [50, 57]
        };

        _this.bg = _this.addSprite('bg', 'uiScreens', 'uiExitPanel.png');
        _this.title = _this.addText2('title', 'blue', 'Exit game', 28);
        _this.subtitle = _this.addText2('subtitle', 'blue', 'Are you sure?', 18);
        _this.yes = _this.addTextButton2('yes', 'uiYesButton', 'Yes', _this.yesClicked);
        _this.no = _this.addTextButton2('no', 'uiNoButton', 'No', _this.noClicked);
        _this.setInputForAllButtons(false);
        return _this;
    }

    (0, _createClass3.default)(ExitGameScreen, [{
        key: 'yesClicked',
        value: function yesClicked(that) {
            that.forceOutForAllButtons();
            that.screens.showScreen('gameStart');
            that.clicked = 'yes';

            _gameGATracker('send', 'event', 'Quit Game', GS.level, GS.score);

            ARK_game_arena_connector.fireEventToArena('event_change');
            ARK_game_arena_connector.changeScore(GS.score, 'Quit Game');
            ARK_game_arena_connector.fireEventToArena('game_end');
        }
    }, {
        key: 'noClicked',
        value: function noClicked(that) {
            that.forceOutForAllButtons();
            that.screens.hideScreen();
            that.clicked = 'no';

            ARK_game_arena_connector.fireEventToArena('event_change');
        }
    }, {
        key: 'onHideEnded',
        value: function onHideEnded() {
            (0, _get3.default)(ExitGameScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(ExitGameScreen.prototype), 'onHideEnded', this).call(this);
            if (this.clicked === 'no') {
                GS.resume();
            } else {
                GS.setupLevel(1);
            }
        }
    }]);
    return ExitGameScreen;
}(_StatsScreen3.default); /*
                           * ExitGameScreen
                           * ==========
                           */

exports.default = ExitGameScreen;

},{"../ui/StatsScreen":438,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],425:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FakePauseScreen = function (_ScreenBase) {
  (0, _inherits3.default)(FakePauseScreen, _ScreenBase);

  function FakePauseScreen(game, screens) {
    (0, _classCallCheck3.default)(this, FakePauseScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FakePauseScreen.__proto__ || (0, _getPrototypeOf2.default)(FakePauseScreen)).call(this, game, 'pause'));

    _this.screens = screens;

    _this.params = {
      'bg': [0, 0],
      'currentScore': [-280 / 2, -155 / 2],
      'currentScoreVal': [280 / 2, -155 / 2],
      'bestScore': [-280 / 2, -95 / 2],
      'bestScoreVal': [280 / 2, -95 / 2],
      'highestLevel': [-280 / 2, -35 / 2],
      'highestLevelVal': [280 / 2, -35 / 2],
      'bestWord': [-280 / 2, 25 / 2],
      'bestWordVal': [280 / 2, 25 / 2],
      'bestWordScore': [-280 / 2, 85 / 2],
      'bestWordScoreVal': [280 / 2, 85 / 2],
      'linesCleared': [-280 / 2, 145 / 2],
      'linesClearedVal': [280 / 2, 145 / 2],
      'title': [0 / 2, -268 / 2],
      'subtitle': [0 / 2, -220 / 2],
      'continue': [0 / 2, 250 / 2]
    };
    return _this;
  }

  (0, _createClass3.default)(FakePauseScreen, [{
    key: 'onShowStarted',
    value: function onShowStarted() {
      (0, _get3.default)(FakePauseScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(FakePauseScreen.prototype), 'onShowStarted', this).call(this);
    }
  }, {
    key: 'onHideEnded',
    value: function onHideEnded() {
      GS.resume();
      (0, _get3.default)(FakePauseScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(FakePauseScreen.prototype), 'onHideEnded', this).call(this);
    }
  }]);
  return FakePauseScreen;
}(_ScreenBase3.default); /*
                          * PauseScreen
                          * ==========
                          */

exports.default = FakePauseScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],426:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GameStartScreen = function (_ScreenBase) {
    (0, _inherits3.default)(GameStartScreen, _ScreenBase);

    function GameStartScreen(game, screens) {
        (0, _classCallCheck3.default)(this, GameStartScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GameStartScreen.__proto__ || (0, _getPrototypeOf2.default)(GameStartScreen)).call(this, game, 'gameStart'));

        window.gss = _this;
        _this.screens = screens;

        _this.params = {
            'bg': [0, 0],
            'logo': [0, -89],
            'instruction': [0, 0],
            'play': [0, 95],
            'help': [-116, 95],
            'mute': [115, 96],
            'unmute': [115, 96]
        };

        _this.bg = _this.addSprite('bg', 'uiScreens', 'uiGameStartPanel.png');
        _this.logo = _this.addSprite('logo', 'uiScreens', 'uiLogo.png');
        _this.instruction = _this.addText2('instruction', 'blue', 'Join adjacent letters to create words.\nClear as many lines as you can\nbefore the time runs out!', 18);

        _this.play = _this.addTextButton2('play', 'uiButtonContinue', 'Play', _this.playClicked);
        _this.help = _this.addButton('help', 'helpButton', _this.helpClicked);

        _this.buttonMute = _this.addButton('mute', 'unmuteButton', _this.unmuteClicked);
        _this.buttonUnmute = _this.addButton('unmute', 'muteButton', _this.muteClicked);

        _this.setInputForAllButtons(false);
        return _this;
    }

    (0, _createClass3.default)(GameStartScreen, [{
        key: 'onShowEnded',
        value: function onShowEnded() {
            (0, _get3.default)(GameStartScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(GameStartScreen.prototype), 'onShowEnded', this).call(this);
            this.updateMuteButtons();
        }
    }, {
        key: 'playClicked',
        value: function playClicked(that) {
            AUDIO.playMusic();
            ARK_game_arena_connector.fireEventToArena('game_start');
            that.forceOutForAllButtons();
            that.screens.showScreen('levelStart');
        }
    }, {
        key: 'helpClicked',
        value: function helpClicked(that) {
            GS.overlayScreens.screenBeforeHelp = 'gameStart';
            GS.overlayScreens.showScreen('help1');
        }
    }, {
        key: 'muteClicked',
        value: function muteClicked(that) {
            GS.mute();
        }
    }, {
        key: 'unmuteClicked',
        value: function unmuteClicked(that) {
            GS.unmute();
        }
    }, {
        key: 'updateMuteButtons',
        value: function updateMuteButtons() {
            if (AUDIO.allMuted) {
                this.buttonMute.alpha = 1;
                this.buttonUnmute.alpha = 0;
                this.buttonMute.inputEnabled = true;
                this.buttonUnmute.inputEnabled = false;
            } else {
                this.buttonMute.alpha = 0;
                this.buttonUnmute.alpha = 1;
                this.buttonMute.inputEnabled = false;
                this.buttonUnmute.inputEnabled = true;
            }
        }
    }]);
    return GameStartScreen;
}(_ScreenBase3.default); /*
                          * GameStartScreen
                          * ==========
                          */


exports.default = GameStartScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],427:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _StatsScreen2 = require('../ui/StatsScreen');

var _StatsScreen3 = _interopRequireDefault(_StatsScreen2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GameSummaryScreen = function (_StatsScreen) {
    (0, _inherits3.default)(GameSummaryScreen, _StatsScreen);

    function GameSummaryScreen(game, screens) {
        (0, _classCallCheck3.default)(this, GameSummaryScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GameSummaryScreen.__proto__ || (0, _getPrototypeOf2.default)(GameSummaryScreen)).call(this, game, 'gameOver'));

        window.gameOver = _this;

        _this.screens = screens;
        _this.bg = _this.addSprite('bg', 'uiScreens', 'uiGameSummaryPanel.png');

        _this.statsOffsetY = 0;
        _this.initSummaryStats();

        _this.params = {
            'bg': [0, 0],
            'title': [1, -146],
            'yourScore': [0, -103],
            'yourScoreValue': [0, -69],
            'continue': [2, 141]
        };

        _this.title = _this.addText2('title', 'blue', 'GAME OVER', 30);
        _this.yourScore = _this.addText2('yourScore', 'white', 'Total Score', 20);
        _this.yourScoreValue = _this.addText2('yourScoreValue', 'white', '3,136', 34);
        _this.continue = _this.addTextButton2('continue', 'uiButtonContinue', 'Continue', _this.continueClicked);
        _this.setInputForAllButtons(false);
        return _this;
    }

    (0, _createClass3.default)(GameSummaryScreen, [{
        key: 'continueClicked',
        value: function continueClicked(that) {
            // console.log('Continue')
            that.setInputForAllButtons(false);
            that.forceOutForAllButtons();

            if (GS.goalReached) {
                that.screens.showScreen('levelStart');
            } else {
                ARK_game_arena_connector.changeScore(GS.score, 'Game Complete');
                ARK_game_arena_connector.fireEventToArena('game_end');
                GS.setupLevel(1);
                setTimeout(function () {
                    that.screens.showScreen('gameStart');
                }, 5000);
            }
        }
    }, {
        key: 'onShowStarted',
        value: function onShowStarted() {
            this.updateView();
            (0, _get3.default)(GameSummaryScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(GameSummaryScreen.prototype), 'onShowStarted', this).call(this);

            if (GS.game.device.desktop) {
                ARK_game_arena_connector.fireEventToArena('pause_ready');
            }
            ARK_game_arena_connector.fireEventToArena('event_change');
            _gameGATracker('send', 'event', 'Level Complete', GS.level, GS.levelScore);

            if (GS.lines !== 20 && GS.goalReached) {
                AUDIO.playSound('success');
            } else if (!GS.goalReached) {
                AUDIO.playSound('gameOver');
            }
        }
    }, {
        key: 'updateView',
        value: function updateView() {
            if (GS.goalReached) {
                this.title.setText('LEVEL COMPLETED');
                this.continue.txt.setText('Continue');

                this.bestWordVal.setText(GS.bestWordLevel.toUpperCase().substring(0, 15));
                this.bestWordScoreVal.setText(GS.bestWordScoreLevel + '');
            } else {
                this.title.setText('GAME OVER');
                this.continue.txt.setText('Play Again');

                this.bestWordVal.setText(GS.bestWord.toUpperCase().substring(0, 15));
                this.bestWordScoreVal.setText(GS.bestWordScore + '');

                _gameGATracker('send', 'event', 'Game Over', GS.level, GS.score);
            }

            this.yourScoreValue.setText(GS.score + '');
            this.lastLevelScoreVal.setText(GS.levelScore + '');
            this.highestLevelVal.setText(GS.level + '');
            this.linesClearedVal.setText(GS.lines + '');
        }
    }]);
    return GameSummaryScreen;
}(_StatsScreen3.default); /*
                           * GameSummaryScreen
                           * ==========
                           */

exports.default = GameSummaryScreen;

},{"../ui/StatsScreen":438,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],428:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpBase = function (_ScreenBase) {
    (0, _inherits3.default)(HelpBase, _ScreenBase);

    function HelpBase(game, screens) {
        (0, _classCallCheck3.default)(this, HelpBase);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HelpBase.__proto__ || (0, _getPrototypeOf2.default)(HelpBase)).call(this, game));

        _this.landscapeView = game.make.group();
        _this.portraitView = game.make.group();

        _this.view.add(_this.landscapeView);
        _this.view.add(_this.portraitView);
        return _this;
    }

    (0, _createClass3.default)(HelpBase, [{
        key: 'addSprite',
        value: function addSprite(paramName, atlas, texture, orientation) {
            var sprite = (0, _get3.default)(HelpBase.prototype.__proto__ || (0, _getPrototypeOf2.default)(HelpBase.prototype), 'addSprite', this).call(this, paramName, atlas, texture);

            if (orientation === 'p') {
                this.portraitView.add(sprite);
            } else {
                this.landscapeView.add(sprite);
            }

            return sprite;
        }
    }, {
        key: 'addButton',
        value: function addButton(paramName, texture, action, orientation) {
            var x = 0;
            var y = 0;
            if (this.params[paramName]) {
                x = this.params[paramName][0] * PARAMS.scaleFactor;
                y = this.params[paramName][1] * PARAMS.scaleFactor;
            }

            var normal = texture + '.png';

            var down = texture + 'Rollover.png';

            var button = null;
            var that = this;

            var callback = function callback() {
                if (button && button.worldAlpha === 0 || this.screens.activeScreen !== that) {
                    return;
                }
                action(this);
                AUDIO.playSound('buttonClick');
                ARK_game_arena_connector.fireEventToArena('event_change');
            };

            var button = PARAMS.addButton(this.game, x, y, 'helpScreens', callback, this, normal, normal, down);

            button.anchor.set(0.5);

            this.addDrag(button);
            this.view.add(button);

            this.traced.push(button);
            button.tracedName = paramName;

            this.buttons.push(button);

            if (orientation === 'p') {
                this.portraitView.add(button);
            } else {
                this.landscapeView.add(button);
            }

            return button;
        }
    }, {
        key: 'initHelpButtons',
        value: function initHelpButtons(omitPrev, omitNext) {
            if (!omitPrev) this.prevL = this.addButton('prevL', 'helpPrevButton', this.onPrev, 'l');
            if (!omitNext) this.nextL = this.addButton('nextL', 'helpNextButton', this.onNext, 'l');
            this.exitL = this.addButton('exitL', 'helpCloseButton', this.onExit, 'l');

            if (!omitPrev) this.prevP = this.addButton('prevP', 'helpPrevButton', this.onPrev, 'p');
            if (!omitNext) this.nextP = this.addButton('nextP', 'helpNextButton', this.onNext, 'p');
            this.exitP = this.addButton('exitP', 'helpCloseButton', this.onExit, 'p');
        }
    }, {
        key: 'onPrev',
        value: function onPrev(that) {
            that.screens.showScreen('help' + (that.page - 1));
        }
    }, {
        key: 'onNext',
        value: function onNext(that) {
            that.screens.showScreen('help' + (that.page + 1));
        }
    }, {
        key: 'onExit',
        value: function onExit(that) {
            that.game.add.tween(that.screens.bg).to({ alpha: 0.5 }, 250).start();
            if (that.screens.screenBeforeHelp === 'gameStart') {
                that.screens.showScreen('gameStart');
            } else {
                that.screens.hideScreen();
                GS.resume();
            }
        }
    }, {
        key: 'setOrientation',
        value: function setOrientation(orientation) {
            if (orientation === 'p') {
                this.portraitView.alpha = 1;
                this.landscapeView.alpha = 1;
                // this.view.removeChild(this.landscapeView)
                // this.view.add(this.portraitView)
                this.landscapeView.x = 10000;
                this.portraitView.x = 0;
            } else {
                this.portraitView.alpha = 1;
                this.landscapeView.alpha = 1;
                // this.view.removeChild(this.portraitView)
                // this.view.add(this.landscapeView)
                this.portraitView.x = 10000;
                this.landscapeView.x = 0;
            }
        }
    }]);
    return HelpBase;
}(_ScreenBase3.default); /*
                          * HelpScreenBase
                          * ==========
                          */


exports.default = HelpBase;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],429:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HelpBase2 = require('../ui/HelpBase');

var _HelpBase3 = _interopRequireDefault(_HelpBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpScreen1 = function (_HelpBase) {
    (0, _inherits3.default)(HelpScreen1, _HelpBase);

    function HelpScreen1(game, screens) {
        (0, _classCallCheck3.default)(this, HelpScreen1);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HelpScreen1.__proto__ || (0, _getPrototypeOf2.default)(HelpScreen1)).call(this, game));

        _this.screens = screens;

        _this.page = 1;

        _this.params = {
            'helpWinnerText1P': [70, 170],
            'helpWinnerText2P': [-61, -135],
            'helpWinnerGridP': [-26, 24],
            'helpWinnerUiP': [2, 306],
            'helpWinnerText1L': [-166, 65],
            'helpWinnerText2L': [49, -135],
            'helpWinnerGridL': [57, 27],
            'helpWinnerUiL': [-240, -150],

            'prevL': [-54, 194],
            'nextL': [158, 194],
            'exitL': [54, 194],

            'prevP': [-103, -274],
            'nextP': [107, -274],
            'exitP': [2, -274]
        };

        _this.helpWinnerText1P = _this.addSprite('helpWinnerText1P', 'helpScreens', 'helpWinnerText1.png', 'p');
        _this.helpWinnerText2P = _this.addSprite('helpWinnerText2P', 'helpScreens', 'helpWinnerText2.png', 'p');
        _this.helpWinnerGridP = _this.addSprite('helpWinnerGridP', 'helpScreens', 'helpWinnerGrid.png', 'p');
        _this.helpWinnerUiP = _this.addSprite('helpWinnerUiP', 'helpScreens', 'helpWinnerUi.png', 'p');

        _this.helpWinnerText1L = _this.addSprite('helpWinnerText1L', 'helpScreens', 'helpWinnerText1.png', 'l');
        _this.helpWinnerText2L = _this.addSprite('helpWinnerText2L', 'helpScreens', 'helpWinnerText2.png', 'l');
        _this.helpWinnerGridL = _this.addSprite('helpWinnerGridL', 'helpScreens', 'helpWinnerGrid.png', 'l');
        _this.helpWinnerUiL = _this.addSprite('helpWinnerUiL', 'helpScreens', 'helpWinnerUiLandscape.png', 'l');

        _this.helpWinnerText1L.scale.set(0.85);

        _this.initHelpButtons(true, false);

        _this.setInputForAllButtons(false);
        return _this;
    }

    return HelpScreen1;
}(_HelpBase3.default); /*
                        * HelpScreen1
                        * ==========
                        */


exports.default = HelpScreen1;

},{"../ui/HelpBase":428,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],430:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HelpBase2 = require('../ui/HelpBase');

var _HelpBase3 = _interopRequireDefault(_HelpBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpScreen2 = function (_HelpBase) {
  (0, _inherits3.default)(HelpScreen2, _HelpBase);

  function HelpScreen2(game, screens) {
    (0, _classCallCheck3.default)(this, HelpScreen2);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpScreen2.__proto__ || (0, _getPrototypeOf2.default)(HelpScreen2)).call(this, game));

    _this.screens = screens;

    _this.page = 2;

    _this.params = {
      'helpWinnerText1P': [70, 170],
      'helpClickTextP': [-18, -145],
      'helpWinnerGridP': [-26, 24],
      'helpWinnerUiP': [2, 306],
      'helpWinnerText1L': [-166, 65],
      'helpClickTextL': [67, -129],
      'helpWinnerGridL': [57, 27],
      'helpWinnerUiL': [-240, -150],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, -274],
      'nextP': [107, -274],
      'exitP': [2, -274]
    };

    _this.helpClickTextP = _this.addSprite('helpClickTextP', 'helpScreens', 'helpClickText.png', 'p');
    _this.helpWinnerGridP = _this.addSprite('helpWinnerGridP', 'helpScreens', 'helpWinnerGrid.png', 'p');

    _this.helpClickTextL = _this.addSprite('helpClickTextL', 'helpScreens', 'helpClickText.png', 'l');
    _this.helpWinnerGridL = _this.addSprite('helpWinnerGridL', 'helpScreens', 'helpWinnerGrid.png', 'l');

    _this.initHelpButtons();

    _this.setInputForAllButtons(false);
    return _this;
  }

  return HelpScreen2;
}(_HelpBase3.default); /*
                        * HelpScreen2
                        * ==========
                        */


exports.default = HelpScreen2;

},{"../ui/HelpBase":428,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],431:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HelpBase2 = require('../ui/HelpBase');

var _HelpBase3 = _interopRequireDefault(_HelpBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpScreen3 = function (_HelpBase) {
  (0, _inherits3.default)(HelpScreen3, _HelpBase);

  function HelpScreen3(game, screens) {
    (0, _classCallCheck3.default)(this, HelpScreen3);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpScreen3.__proto__ || (0, _getPrototypeOf2.default)(HelpScreen3)).call(this, game));

    _this.screens = screens;

    _this.page = 3;

    _this.params = {
      'helpLinesArrow1P': [127, 130],
      'helpLinesArrow2P': [53, -113],
      'helpLinesColumnP': [211, 1],
      'helpLinesRowP': [-1, -211],
      'helpLinesUiP': [-1, -321],
      'helpLinesTextP': [-17, 29],
      'helpLinesArrow1L': [202, 123],
      'helpLinesArrow2L': [107, -107],
      'helpLinesColumnL': [289, -1],
      'helpLinesRowL': [77, -213],
      'helpLinesUiL': [-242, 38],
      'helpLinesTextL': [61, 28],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]
    };

    _this.helpLinesArrow1P = _this.addSprite('helpLinesArrow1P', 'helpScreens', 'helpLinesArrow1.png', 'p');
    _this.helpLinesArrow2P = _this.addSprite('helpLinesArrow2P', 'helpScreens', 'helpLinesArrow2.png', 'p');
    _this.helpLinesColumnP = _this.addSprite('helpLinesColumnP', 'helpScreens', 'helpLinesColumn.png', 'p');
    _this.helpLinesRowP = _this.addSprite('helpLinesRowP', 'helpScreens', 'helpLinesRow.png', 'p');
    _this.helpLinesUiP = _this.addSprite('helpLinesUiP', 'helpScreens', 'helpLinesUi.png', 'p');
    _this.helpLinesTextP = _this.addSprite('helpLinesTextP', 'helpScreens', 'helpLinesText.png', 'p');

    _this.helpLinesArrow1L = _this.addSprite('helpLinesArrow1L', 'helpScreens', 'helpLinesArrow1.png', 'l');
    _this.helpLinesArrow2L = _this.addSprite('helpLinesArrow2L', 'helpScreens', 'helpLinesArrow2.png', 'l');
    _this.helpLinesColumnL = _this.addSprite('helpLinesColumnL', 'helpScreens', 'helpLinesColumn.png', 'l');
    _this.helpLinesRowL = _this.addSprite('helpLinesRowL', 'helpScreens', 'helpLinesRow.png', 'l');
    _this.helpLinesUiL = _this.addSprite('helpLinesUiL', 'helpScreens', 'helpLinesUiLandscape.png', 'l');
    _this.helpLinesTextL = _this.addSprite('helpLinesTextL', 'helpScreens', 'helpLinesText.png', 'l');

    _this.helpLinesColumnP.scale.set(0.975);
    _this.helpLinesColumnL.scale.set(0.975);
    _this.helpLinesRowP.scale.set(0.975);
    _this.helpLinesRowL.scale.set(0.975);

    _this.initHelpButtons();

    _this.setInputForAllButtons(false);
    return _this;
  }

  return HelpScreen3;
}(_HelpBase3.default); /*
                        * HelpScreen3
                        * ==========
                        */


exports.default = HelpScreen3;

},{"../ui/HelpBase":428,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],432:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HelpBase2 = require('../ui/HelpBase');

var _HelpBase3 = _interopRequireDefault(_HelpBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpScreen4 = function (_HelpBase) {
  (0, _inherits3.default)(HelpScreen4, _HelpBase);

  function HelpScreen4(game, screens) {
    (0, _classCallCheck3.default)(this, HelpScreen4);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpScreen4.__proto__ || (0, _getPrototypeOf2.default)(HelpScreen4)).call(this, game));

    _this.screens = screens;

    _this.page = 4;

    _this.params = {
      'helpFunTextP': [2, 87],
      'helpFunArrowP': [-15, -164],
      'helpFunGridP': [-96, -45],
      'helpFunUiP': [0, -310],
      'helpFunTextL': [107, 77],
      'helpFunArrowL': [-83, 118],
      'helpFunGridL': [-16, -46],
      'helpFunUiL': [-242, 109],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]
    };

    _this.helpFunTextP = _this.addSprite('helpFunTextP', 'helpScreens', 'helpFunText.png', 'p');
    _this.helpFunArrowP = _this.addSprite('helpFunArrowP', 'helpScreens', 'helpFunArrow.png', 'p');
    _this.helpFunGridP = _this.addSprite('helpFunGridP', 'helpScreens', 'helpFunGrid.png', 'p');
    _this.helpFunUiP = _this.addSprite('helpFunUiP', 'helpScreens', 'helpFunUi.png', 'p');

    _this.helpFunTextL = _this.addSprite('helpFunTextL', 'helpScreens', 'helpFunText.png', 'l');
    _this.helpFunArrowL = _this.addSprite('helpFunArrowL', 'helpScreens', 'helpFunArrow.png', 'l');
    _this.helpFunGridL = _this.addSprite('helpFunGridL', 'helpScreens', 'helpFunGrid.png', 'l');
    _this.helpFunUiL = _this.addSprite('helpFunUiL', 'helpScreens', 'helpFunUiLandscape.png', 'l');

    _this.helpFunArrowL.rotation = -Math.PI / 2;
    _this.helpFunArrowL.scale.x = -1;
    _this.initHelpButtons();

    _this.setInputForAllButtons(false);
    return _this;
  }

  return HelpScreen4;
}(_HelpBase3.default); /*
                        * HelpScreen4
                        * ==========
                        */


exports.default = HelpScreen4;

},{"../ui/HelpBase":428,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],433:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HelpBase2 = require('../ui/HelpBase');

var _HelpBase3 = _interopRequireDefault(_HelpBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpScreen5 = function (_HelpBase) {
  (0, _inherits3.default)(HelpScreen5, _HelpBase);

  function HelpScreen5(game, screens) {
    (0, _classCallCheck3.default)(this, HelpScreen5);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpScreen5.__proto__ || (0, _getPrototypeOf2.default)(HelpScreen5)).call(this, game));

    _this.screens = screens;

    _this.page = 5;

    _this.params = {

      'helpBombTextP': [-2, -170],
      'helpBombGridP': [-25, 23],
      'helpBombUiP': [-6, -336],
      'helpBombTextL': [50, -160],
      'helpBombGridL': [55, 27],
      'helpBombUiL': [-255, 73],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]

    };

    _this.helpBombTextP = _this.addSprite('helpBombTextP', 'helpScreens', 'helpBombText.png', 'p');
    _this.helpBombGridP = _this.addSprite('helpBombGridP', 'helpScreens', 'helpBombGrid.png', 'p');
    _this.helpBombUiP = _this.addSprite('helpBombUiP', 'helpScreens', 'helpBombUi.png', 'p');

    _this.helpBombTextL = _this.addSprite('helpBombTextL', 'helpScreens', 'helpBombText.png', 'l');
    _this.helpBombGridL = _this.addSprite('helpBombGridL', 'helpScreens', 'helpBombGrid.png', 'l');
    _this.helpBombUiL = _this.addSprite('helpBombUiL', 'helpScreens', 'helpBombUi.png', 'l');

    _this.helpBombUiL.scale.set(0.9);

    _this.initHelpButtons(false, true);

    _this.setInputForAllButtons(false);
    return _this;
  }

  return HelpScreen5;
}(_HelpBase3.default); /*
                        * HelpScreen5
                        * ==========
                        */


exports.default = HelpScreen5;

},{"../ui/HelpBase":428,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],434:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelStartScreen = function (_ScreenBase) {
    (0, _inherits3.default)(LevelStartScreen, _ScreenBase);

    function LevelStartScreen(game, screens) {
        (0, _classCallCheck3.default)(this, LevelStartScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LevelStartScreen.__proto__ || (0, _getPrototypeOf2.default)(LevelStartScreen)).call(this, game, 'levelStart'));

        _this.screens = screens;
        _this.params = {
            'bg': [0, 0],
            'level': [0, -54],
            'instruction': [-2, 6],
            'begin': [0, 57]
        };

        _this.bg = _this.addSprite('bg', 'uiScreens', 'uiLevelStartPanel.png');
        _this.level = _this.addText2('level', 'blue', 'Level 1', 26);
        _this.instruction = _this.addText2('instruction', 'blue', 'Wipe clear at least 1 line of\nletter tiles', 16);
        _this.begin = _this.addTextButton2('begin', 'uiButtonBegin', 'Begin', _this.beginClicked);
        _this.setInputForAllButtons(false);
        return _this;
    }

    (0, _createClass3.default)(LevelStartScreen, [{
        key: 'beginClicked',
        value: function beginClicked(that) {
            ARK_game_arena_connector.fireEventToArena('event_change');

            that.forceOutForAllButtons();
            that.screens.hideScreen();
        }
    }, {
        key: 'onHideEnded',
        value: function onHideEnded() {
            GS.startGame();
        }
    }, {
        key: 'onShowStarted',
        value: function onShowStarted() {
            this.updateView();
            (0, _get3.default)(LevelStartScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(LevelStartScreen.prototype), 'onShowStarted', this).call(this);
        }
    }, {
        key: 'onShowEnded',
        value: function onShowEnded() {
            (0, _get3.default)(LevelStartScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(LevelStartScreen.prototype), 'onShowEnded', this).call(this);
            if (!GS.isFresh()) {
                setTimeout(GS.setupNextLevel, 250);
            }
        }
    }, {
        key: 'updateView',
        value: function updateView() {
            var goal = GS.isFresh() ? GS.goal : GS.goal + 1;
            var lineText = goal === 1 ? "line" : "lines";
            this.level.setText('Level ' + goal);
            this.instruction.setText('Wipe clear at least ' + goal + ' ' + lineText + '\nof letter tiles');
        }
    }]);
    return LevelStartScreen;
}(_ScreenBase3.default); /*
                          * LevelStartScreen
                          * ==========
                          */


exports.default = LevelStartScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],435:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _GameStartScreen = require('../ui/GameStartScreen');

var _GameStartScreen2 = _interopRequireDefault(_GameStartScreen);

var _LevelStartScreen = require('../ui/LevelStartScreen');

var _LevelStartScreen2 = _interopRequireDefault(_LevelStartScreen);

var _GameSummaryScreen = require('../ui/GameSummaryScreen');

var _GameSummaryScreen2 = _interopRequireDefault(_GameSummaryScreen);

var _PauseScreen = require('../ui/PauseScreen');

var _PauseScreen2 = _interopRequireDefault(_PauseScreen);

var _FakePauseScreen = require('../ui/FakePauseScreen');

var _FakePauseScreen2 = _interopRequireDefault(_FakePauseScreen);

var _DoubleScoreScreen = require('../ui/DoubleScoreScreen');

var _DoubleScoreScreen2 = _interopRequireDefault(_DoubleScoreScreen);

var _ExitGameScreen = require('../ui/ExitGameScreen');

var _ExitGameScreen2 = _interopRequireDefault(_ExitGameScreen);

var _HelpScreen = require('../ui/HelpScreen1');

var _HelpScreen2 = _interopRequireDefault(_HelpScreen);

var _HelpScreen3 = require('../ui/HelpScreen2');

var _HelpScreen4 = _interopRequireDefault(_HelpScreen3);

var _HelpScreen5 = require('../ui/HelpScreen3');

var _HelpScreen6 = _interopRequireDefault(_HelpScreen5);

var _HelpScreen7 = require('../ui/HelpScreen4');

var _HelpScreen8 = _interopRequireDefault(_HelpScreen7);

var _HelpScreen9 = require('../ui/HelpScreen5');

var _HelpScreen10 = _interopRequireDefault(_HelpScreen9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * OverlayScreens
 * ==========
 */

var OverlayScreens = function () {
    function OverlayScreens(game) {
        (0, _classCallCheck3.default)(this, OverlayScreens);

        this.view = game.make.group();
        this.game = game;

        if (!GS.game.device.webGL || GS.game.renderType === 1) {
            this.blurredBg = PARAMS.makeSprite(game, 0, 0, 'blurredBg');
            this.blurredBg.anchor.set(0.5);
            this.view.add(this.blurredBg);
        }

        this.bg = game.make.graphics();
        this.view.add(this.bg);

        this.bg.beginFill(0x000000, 1);
        this.bg.drawRect(-100, -100, 200, 200);
        this.bg.endFill();

        this.bg.alpha = 0.5;
        this.bg.scale.set(10);
        this.screens = {};

        this.screens['gameStart'] = this.gameStart = new _GameStartScreen2.default(game, this);
        this.screens['levelStart'] = this.levelStart = new _LevelStartScreen2.default(game, this);
        this.screens['gameSummary'] = this.gameSummary = new _GameSummaryScreen2.default(game, this);
        this.screens['pause'] = this.pause = new _PauseScreen2.default(game, this);
        this.screens['fakePause'] = this.fakePause = new _FakePauseScreen2.default(game, this);
        this.screens['doubleScore'] = this.doubleScore = new _DoubleScoreScreen2.default(game, this);
        this.screens['exitGame'] = this.exitGame = new _ExitGameScreen2.default(game, this);
        this.screens['help1'] = this.help1 = new _HelpScreen2.default(game, this);
        this.screens['help2'] = this.help2 = new _HelpScreen4.default(game, this);
        this.screens['help3'] = this.help3 = new _HelpScreen6.default(game, this);
        this.screens['help4'] = this.help4 = new _HelpScreen8.default(game, this);
        this.screens['help5'] = this.help5 = new _HelpScreen10.default(game, this);

        this.activeScreen = null;
        this.tweenTime = 250;
        this.showScreen('gameStart');
    }

    (0, _createClass3.default)(OverlayScreens, [{
        key: 'showScreen',
        value: function showScreen(screenName) {
            _gameGATracker('send', 'pageview', { 'page': '/' + screenName + 'Screen' });

            if (screenName === 'help1') {
                this.game.add.tween(this.bg).to({ alpha: 0.8 }, 250).start();
            }
            if (this.activeScreen) {
                this.makeTransition(screenName);
                return;
            }

            var screen = this.screens[screenName];
            screen.view.alpha = 1;
            screen.view.x = 0;

            this.activeScreen = screen;
            this.view.add(this.activeScreen.view);
            this.activeScreen.onShowStarted();

            var tween = this.game.add.tween(this.view).to({ alpha: 1 }, this.tweenTime).start();

            this.game.time.events.add(this.tweenTime, function () {
                tween.stop();
                this.view.alpha = 1;

                this.activeScreen.onShowEnded();
            }, this);
        }
    }, {
        key: 'hideScreen',
        value: function hideScreen() {
            if (!this.activeScreen) {
                this.view.alpha = 0;
                return;
            }

            _gameGATracker('send', 'pageview', { 'page': '/GameScene' });

            var screen = this.activeScreen;

            var tween = this.game.add.tween(this.view).to({ alpha: 0 }, this.tweenTime).start();

            this.game.time.events.add(this.tweenTime, function () {
                tween.stop();
                this.view.alpha = 0;
                this.activeScreen.onHideEnded();
                this.activeScreen.view.x = 100000;
                this.view.removeChild(this.activeScreen.view);
                this.activeScreen = null;
            }, this);

            this.activeScreen.onHideStarted();
        }
    }, {
        key: 'makeTransition',
        value: function makeTransition(screenName) {
            var newScreen = this.screens[screenName];
            var oldScreen = this.activeScreen;

            newScreen.view.x = 0;
            newScreen.view.alpha = 0;
            this.view.add(newScreen.view);

            this.game.tweens.removeFrom(newScreen.view);
            this.game.tweens.removeFrom(oldScreen.view);

            newScreen.onShowStarted();
            oldScreen.onHideStarted();

            var tween = this.game.add.tween(newScreen.view).to({ alpha: 1 }, this.tweenTime).start();

            var tween2 = this.game.add.tween(oldScreen.view).to({ alpha: 0 }, this.tweenTime / 2).start();

            this.game.time.events.add(this.tweenTime, function () {
                tween.stop();
                tween2.stop();
                newScreen.view.alpha = 1;
                oldScreen.view.alpha = 0;
                oldScreen.view.x = 1000000;
                newScreen.onShowEnded();
                this.activeScreen = newScreen;
                oldScreen.onHideEnded();
                this.view.removeChild(oldScreen.view);
            }, this);
        }
    }, {
        key: 'showScreenQuickly',
        value: function showScreenQuickly(screenName) {
            if (this.activeScreen) {
                this.anciveScreen.onHideStarted();
                this.activeScreen.view.alpha = 0;
                this.view.removeChild(this.activeScreen.view);
                this.anciveScreen.onHideEnded();
                this.activeScreen.view.x = 100000;
            }

            var screen = this.screens[screenName];

            screen.onShowStarted();

            this.view.alpha = 1;

            this.view.addChild(screen.view);
            screen.view.alpha = 1;

            this.activeScreen = screen;
            this.activeScreen.view.x = 0;

            screen.onShowEnded();
        }
    }, {
        key: 'setOrientation',
        value: function setOrientation(orientation) {
            this.gameStart.updateTexts();
            this.levelStart.updateTexts();
            this.gameSummary.updateTexts();
            this.pause.updateTexts();
            this.fakePause.updateTexts();
            this.doubleScore.updateTexts();
            this.exitGame.updateTexts();
            this.help1.updateTexts();
            this.help2.updateTexts();
            this.help3.updateTexts();
            this.help4.updateTexts();
            this.help5.updateTexts();

            if (orientation === 'portrait') {
                this.help1.setOrientation('p');
                this.help2.setOrientation('p');
                this.help3.setOrientation('p');
                this.help4.setOrientation('p');
                this.help5.setOrientation('p');
            } else {
                this.help1.setOrientation('l');
                this.help2.setOrientation('l');
                this.help3.setOrientation('l');
                this.help4.setOrientation('l');
                this.help5.setOrientation('l');
            }
        }
    }]);
    return OverlayScreens;
}();

exports.default = OverlayScreens;

},{"../ui/DoubleScoreScreen":423,"../ui/ExitGameScreen":424,"../ui/FakePauseScreen":425,"../ui/GameStartScreen":426,"../ui/GameSummaryScreen":427,"../ui/HelpScreen1":429,"../ui/HelpScreen2":430,"../ui/HelpScreen3":431,"../ui/HelpScreen4":432,"../ui/HelpScreen5":433,"../ui/LevelStartScreen":434,"../ui/PauseScreen":436,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],436:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PauseScreen = function (_ScreenBase) {
  (0, _inherits3.default)(PauseScreen, _ScreenBase);

  function PauseScreen(game, screens) {
    (0, _classCallCheck3.default)(this, PauseScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PauseScreen.__proto__ || (0, _getPrototypeOf2.default)(PauseScreen)).call(this, game, 'pause'));

    _this.screens = screens;

    _this.params = {
      'bg': [0, 0],
      'currentScore': [-280 / 2, -155 / 2],
      'currentScoreVal': [280 / 2, -155 / 2],
      'bestScore': [-280 / 2, -95 / 2],
      'bestScoreVal': [280 / 2, -95 / 2],
      'highestLevel': [-280 / 2, -35 / 2],
      'highestLevelVal': [280 / 2, -35 / 2],
      'bestWord': [-280 / 2, 25 / 2],
      'bestWordVal': [280 / 2, 25 / 2],
      'bestWordScore': [-280 / 2, 85 / 2],
      'bestWordScoreVal': [280 / 2, 85 / 2],
      'linesCleared': [-280 / 2, 145 / 2],
      'linesClearedVal': [280 / 2, 145 / 2],
      'title': [0 / 2, -268 / 2],
      'subtitle': [0 / 2, -220 / 2],
      'continue': [0 / 2, 250 / 2]
    };

    _this.bg = _this.addSprite('bg', 'uiScreens', 'uiPausePanel.png');

    _this.statsOffsetY = -2 * PARAMS.scaleFactor;
    _this.initSummaryStats();

    _this.title = _this.addText2('title', 'blue', 'Pause', 30);
    _this.subtitle = _this.addText2('subtitle', 'blue', 'All-time stats', 20);

    _this.continue = _this.addTextButton2('continue', 'uiButtonContinue', 'Continue', _this.continueClicked);

    _this.setInputForAllButtons(false);
    return _this;
  }

  (0, _createClass3.default)(PauseScreen, [{
    key: 'initSummaryStats',
    value: function initSummaryStats() {
      this.currentScore = this.addText2('currentScore', 'white', 'Current Score', 20, 0);
      this.currentScoreVal = this.addText2('currentScoreVal', 'white', '1120', 20, 1);
      this.bestScore = this.addText2('bestScore', 'white', 'Highest Score', 20, 0);
      this.bestScoreVal = this.addText2('bestScoreVal', 'white', '10124', 20, 1);
      this.highestLevel = this.addText2('highestLevel', 'white', 'Highest Level', 20, 0);
      this.highestLevelVal = this.addText2('highestLevelVal', 'white', '10', 20, 1);
      this.bestWord = this.addText2('bestWord', 'white', 'Best Word', 20, 0);
      this.bestWordVal = this.addText2('bestWordVal', 'white', 'IHAHA', 20, 1);
      this.bestWordScore = this.addText2('bestWordScore', 'white', 'Best Word\'s Score', 20, 0);
      this.bestWordScoreVal = this.addText2('bestWordScoreVal', 'white', '180', 20, 1);
      this.linesCleared = this.addText2('linesCleared', 'white', 'Lines Cleared', 20, 0);
      this.linesClearedVal = this.addText2('linesClearedVal', 'white', '10', 20, 1);

      this.currentScore.y += this.statsOffsetY;
      this.currentScoreVal.y += this.statsOffsetY;

      this.bestScore.y += this.statsOffsetY;
      this.bestScoreVal.y += this.statsOffsetY;

      this.highestLevel.y += this.statsOffsetY;
      this.highestLevelVal.y += this.statsOffsetY;

      this.bestWord.y += this.statsOffsetY;
      this.bestWordVal.y += this.statsOffsetY;

      this.bestWordScore.y += this.statsOffsetY;
      this.bestWordScoreVal.y += this.statsOffsetY;

      this.linesCleared.y += this.statsOffsetY;
      this.linesClearedVal.y += this.statsOffsetY;
    }
  }, {
    key: 'continueClicked',
    value: function continueClicked(that) {
      that.screens.hideScreen();
    }
  }, {
    key: 'onShowStarted',
    value: function onShowStarted() {
      (0, _get3.default)(PauseScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(PauseScreen.prototype), 'onShowStarted', this).call(this);

      this.currentScoreVal.text = GS.score + '';
      this.bestScoreVal.text = STATS.highestScore + '';
      this.highestLevelVal.text = STATS.highestLevel + '';
      this.bestWordVal.text = (STATS.bestWord + '').toUpperCase().substring(0, 15);
      this.bestWordScoreVal.text = STATS.bestWordScore + '';
      this.linesClearedVal.text = STATS.linesCleared + '';
    }
  }, {
    key: 'onHideEnded',
    value: function onHideEnded() {
      GS.resume();
      (0, _get3.default)(PauseScreen.prototype.__proto__ || (0, _getPrototypeOf2.default)(PauseScreen.prototype), 'onHideEnded', this).call(this);
    }
  }]);
  return PauseScreen;
}(_ScreenBase3.default); /*
                          * PauseScreen
                          * ==========
                          */

exports.default = PauseScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/get":14,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}],437:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * ScreenBase
 * ==========
 */

var ScreenBase = function () {
    function ScreenBase(game, placeholderTextures) {
        (0, _classCallCheck3.default)(this, ScreenBase);

        this.game = game;
        this.designerMode = false;

        this.params = {};
        this.texts = [];
        this.buttons = [];
        this.traced = [];

        this.view = game.make.group();

        this.fakeShaderReload = this.addText2('bg', 'blue', ' ', 1);
        if (this.designerMode && placeholderTextures) {
            this.placeholder = PARAMS.makeSprite(game, 0, 0, placeholderTextures);
            this.placeholder.anchor.set(0.5);
            this.view.add(this.placeholder);
        }
        this.view.alpha = 0;

        this.setInputForAllButtons(false);
    }

    (0, _createClass3.default)(ScreenBase, [{
        key: 'setInputEnabledForButtons',
        value: function setInputEnabledForButtons(enable) {
            for (var i = 0; i < this.buttons.length; i++) {
                this.buttons[i].inputEnabled = enable;
                this.buttons[i].frameName = this.buttons[i]._onOutFrame;
            }
        }
    }, {
        key: 'forceOutForAllButtons',
        value: function forceOutForAllButtons() {
            for (var i = 0; i < this.buttons.length; i++) {
                this.buttons[i].frameName = this.buttons[i]._onOutFrame;
            }
        }
    }, {
        key: 'onHideStarted',
        value: function onHideStarted() {
            this.setInputForAllButtons(false);
            // this.view.cacheAsBitmap = true
        }
    }, {
        key: 'onHideEnded',
        value: function onHideEnded() {
            // this.view.cacheAsBitmap = false
        }
    }, {
        key: 'onShowStarted',
        value: function onShowStarted() {
            // this.view.cacheAsBitmap = true
            this.updateTexts(this);
        }
    }, {
        key: 'onShowEnded',
        value: function onShowEnded() {
            this.setInputForAllButtons(true);
            // this.view.cacheAsBitmap = false
        }
    }, {
        key: 'addSprite',
        value: function addSprite(paramName, atlas, texture) {
            var x = 0;
            var y = 0;
            if (this.params[paramName]) {
                x = this.params[paramName][0] * PARAMS.scaleFactor;
                y = this.params[paramName][1] * PARAMS.scaleFactor;
            }

            var sprite = PARAMS.makeSprite(this.game, x, y, atlas, texture);
            sprite.anchor.set(0.5);
            this.view.add(sprite);
            this.addDrag(sprite);

            this.traced.push(sprite);
            sprite.tracedName = paramName;
            return sprite;
        }

        /* addText (paramName, font, text, size, anchorX = 0.5) {
         console.trace()
         var x = 0
         var y = 0
         if (this.params[paramName]) {
         x = this.params[paramName][0] * PARAMS.scaleFactor
         y = this.params[paramName][1] * PARAMS.scaleFactor
         }
          var txt = this.game.make.bitmapText(x, y, font, text, size * PARAMS.scaleFactor, 'center')
         txt.anchor.set(0.5)
         this.view.add(txt)
          this.addDrag(txt)
          this.traced.push(txt)
          txt.tracedName = paramName
          txt.anchor.set(anchorX, 0.5)
          return txt
         }
          addTextButton (paramName, texture, text, action) {
         console.trace()
         var x = 0
         var y = 0
         if (this.params[paramName]) {
         x = this.params[paramName][0] * PARAMS.scaleFactor
         y = this.params[paramName][1] * PARAMS.scaleFactor
         }
          var normal = texture + '.png'
          var down = texture + 'Rollover.png'
          var button = null;
          var callback = function () {
         if ( button && button.worldAlpha === 0 ) {
         //console.log("Here stopped")
         return
         }
         action(this);
         AUDIO.playSound('buttonClick')
         }
          button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down)
          button.anchor.set(0.5)
          this.addDrag(button)
         this.view.add(button)
          var txt = this.game.make.bitmapText(0, -13 * PARAMS.scaleFactor, 'main-big-blue', text, 26 * PARAMS.scaleFactor, 'center')
         txt.anchor.set(0.5, 0)
         button.addChild(txt)
         button.txt=txt
          this.traced.push(button)
         button.tracedName = paramName
          this.buttons.push(button)
         return button
         } */

    }, {
        key: 'addText2',
        value: function addText2(paramName, fontColor, text, size) {
            var anchorX = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.5;

            var x = 0;
            var y = 0;
            if (this.params[paramName]) {
                x = this.params[paramName][0] * PARAMS.scaleFactor;
                y = this.params[paramName][1] * PARAMS.scaleFactor;
            }

            var font = PARAMS.getFonts(fontColor, size * PARAMS.scaleFactor);
            var txt = this.game.make.bitmapText(x, y, font, text, size * PARAMS.scaleFactor, 'center');
            txt.preferredFontSize = size * PARAMS.scaleFactor;
            txt.fontNameColor = fontColor;

            this.view.add(txt);
            this.addDrag(txt);
            this.traced.push(txt);

            txt.tracedName = paramName;
            txt.anchor.set(anchorX, 0.5);
            this.texts.push(txt);
            return txt;
        }
    }, {
        key: 'addTextButton2',
        value: function addTextButton2(paramName, texture, text, action) {
            var x = 0;
            var y = 0;
            if (this.params[paramName]) {
                x = Math.round(this.params[paramName][0] * PARAMS.scaleFactor);
                y = Math.round(this.params[paramName][1] * PARAMS.scaleFactor);
            }

            var normal = texture + '.png';
            var down = texture + 'Rollover.png';
            var button = null;
            var that = this;

            var callback = function callback() {
                if (button && button.worldAlpha === 0 || this.screens.activeScreen !== that) {
                    return;
                }
                action(this);
                AUDIO.playSound('buttonClick');
            };

            button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down);
            button.anchor.set(0.5);
            this.addDrag(button);
            this.view.add(button);

            var size = 26 * PARAMS.scaleFactor;
            var font = PARAMS.getFonts('blue', size);
            var txt = this.game.make.bitmapText(0, -13 * PARAMS.scaleFactor, font, text, size);

            txt.preferredFontSize = size;
            txt.fontNameColor = 'blue';
            txt.anchor.set(0.5, 0);
            this.texts.push(txt);

            button.addChild(txt);
            button.txt = txt;

            this.traced.push(button);
            button.tracedName = paramName;

            this.buttons.push(button);
            return button;
        }
    }, {
        key: 'addButton',
        value: function addButton(paramName, texture, action) {
            var x = 0;
            var y = 0;
            if (this.params[paramName]) {
                x = this.params[paramName][0] * PARAMS.scaleFactor;
                y = this.params[paramName][1] * PARAMS.scaleFactor;
            }

            var normal = texture + '.png';

            var down = texture + 'Rollover.png';

            var button = null;
            var that = this;

            var callback = function callback() {
                if (button && button.worldAlpha === 0 || this.screens.activeScreen !== that) {
                    // console.log("Here stopped")
                    return;
                }
                action(this);
                AUDIO.playSound('buttonClick');
            };

            button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down);
            button.anchor.set(0.5);
            this.addDrag(button);
            this.view.add(button);

            this.traced.push(button);
            button.tracedName = paramName;
            this.buttons.push(button);

            return button;
        }
    }, {
        key: 'updateTexts',
        value: function updateTexts() {
            for (var i = 0; i < this.texts.length; i++) {
                var elem = this.texts[i];

                // elem.x = Math.round(elem.x)
                // elem.y = Math.round(elem.y)

                if (elem.preferredFontSize) {
                    var newFont = PARAMS.getFonts(elem.fontNameColor, elem.worldScale.x * elem.preferredFontSize);
                    // console.log(newFont, elem.preferredFontSize);
                    elem.font = newFont;
                }

                // elem.x -= elem.worldPosition.x - Math.floor(elem.worldPosition.x) ;
                // elem.y -= elem.worldPosition.y - Math.floor(elem.worldPosition.y) ;
                // console.log(elem.worldPosition.x, elem.worldPosition.y)
            }
        }
    }, {
        key: 'setInputForAllButtons',
        value: function setInputForAllButtons(enable) {
            for (var i = 0; i < this.buttons.length; i++) {
                this.buttons[i].inputEnabled = enable;
            }
        }
    }, {
        key: 'addDrag',
        value: function addDrag(el) {
            if (!this.designerMode) return;
            el.inputEnabled = true;
            el.input.enableDrag(true);

            el.events.onDragStop.add(function () {
                // //console.log( Math.floor(el.x), Math.floor(el.y) )
                this.printTraced();
            }, this);

            el.events.onDragUpdate.add(function (sprite, pointer) {
                var pos = sprite.game.input.getLocalPosition(sprite.parent, pointer);

                if (sprite.hitArea) {
                    sprite.x = pos.x - sprite.hitArea.width / 2;
                    sprite.y = pos.y - sprite.hitArea.height / 2;
                } else {
                    sprite.x = pos.x - sprite.width / 2;
                    sprite.y = pos.y - sprite.height / 2;
                }
            });
        }
    }, {
        key: 'printTraced',
        value: function printTraced() {
            var result = '{\n';
            for (var i = 0; i < this.traced.length; i++) {
                result += '\t\'' + this.traced[i].tracedName + '\': [' + Math.round(this.traced[i].x) + ', ' + Math.round(this.traced[i].y) + ']';
                if (i < this.traced.length - 1) result += ',\n';else result += '\n';
            }
            result += '}';

            // console.log(result)
        }
    }]);
    return ScreenBase;
}();

exports.default = ScreenBase;

},{"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13}],438:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ScreenBase2 = require('../ui/ScreenBase');

var _ScreenBase3 = _interopRequireDefault(_ScreenBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatsScreen = function (_ScreenBase) {
    (0, _inherits3.default)(StatsScreen, _ScreenBase);

    function StatsScreen(game, placeholder) {
        (0, _classCallCheck3.default)(this, StatsScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (StatsScreen.__proto__ || (0, _getPrototypeOf2.default)(StatsScreen)).call(this, game, placeholder));

        window.gameOver = _this;

        _this.offsetY = 2;

        _this.params = {
            'lastLevelScore': [-140, -30],
            'lastLevelScoreVal': [140, -30],
            'highestLevel': [-140, 0],
            'highestLevelVal': [140, 0],
            'bestWord': [-140, 30],
            'bestWordVal': [140, 30],
            'bestWordScore': [-140, 60],
            'bestWordScoreVal': [140, 60],
            'linesCleared': [-140, 90],
            'linesClearedVal': [140, 90]
        };

        _this.statsOffsetY = 2 * PARAMS.scaleFactor;
        return _this;
    }

    (0, _createClass3.default)(StatsScreen, [{
        key: 'initSummaryStats',
        value: function initSummaryStats() {
            this.lastLevelScore = this.addText2('lastLevelScore', 'white', 'This Level\'s Score', 20, 0);
            this.lastLevelScoreVal = this.addText2('lastLevelScoreVal', 'white', '10', 20, 1);

            this.highestLevel = this.addText2('highestLevel', 'white', 'Highest Level', 20, 0);
            this.highestLevelVal = this.addText2('highestLevelVal', 'white', '10', 20, 1);
            this.bestWord = this.addText2('bestWord', 'white', 'Best Word', 20, 0);
            this.bestWordVal = this.addText2('bestWordVal', 'white', 'IHAHA', 20, 1);
            this.bestWordScore = this.addText2('bestWordScore', 'white', 'Best Word\'s Score', 20, 0);
            this.bestWordScoreVal = this.addText2('bestWordScoreVal', 'white', '180', 20, 1);
            this.linesCleared = this.addText2('linesCleared', 'white', 'Lines Cleared', 20, 0);
            this.linesClearedVal = this.addText2('linesClearedVal', 'white', '10', 20, 1);

            // return;
            this.lastLevelScore.y += this.statsOffsetY;
            this.lastLevelScoreVal.y += this.statsOffsetY;

            this.highestLevel.y += this.statsOffsetY;
            this.highestLevelVal.y += this.statsOffsetY;

            this.bestWord.y += this.statsOffsetY;
            this.bestWordVal.y += this.statsOffsetY;

            this.bestWordScore.y += this.statsOffsetY;
            this.bestWordScoreVal.y += this.statsOffsetY;

            this.linesCleared.y += this.statsOffsetY;
            this.linesClearedVal.y += this.statsOffsetY;
        }
    }]);
    return StatsScreen;
}(_ScreenBase3.default); /*
                          * StatsScreen
                          * ==========
                          */

exports.default = StatsScreen;

},{"../ui/ScreenBase":437,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":12,"babel-runtime/helpers/createClass":13,"babel-runtime/helpers/inherits":15,"babel-runtime/helpers/possibleConstructorReturn":16}]},{},[401])(401)
});

